import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { of } from 'rxjs';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_VIEW_WHITE_LABEL = '/spe-view-n-white-label';
let SpeNViewWhiteLabelProxy = class SpeNViewWhiteLabelProxy {
    constructor(api) {
        this.api = api;
    }
    getAllProducts(uuidWhiteLabel) {
        const uri = `${SPE_N_VIEW_WHITE_LABEL}/v1/products/all/actives/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    getAllProductsVisible(uuidWhiteLabel, typeVisible) {
        const uri = `${SPE_N_VIEW_WHITE_LABEL}/v1/products/all/visible/${uuidWhiteLabel}/type/${typeVisible}`;
        return this.api.get(uri);
    }
};
SpeNViewWhiteLabelProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNViewWhiteLabelProxy);

let SpeNOnboardingEcProxy = class SpeNOnboardingEcProxy {
    constructor(api) {
        this.api = api;
        // rg, cpf, name, status(master, partner, attorney, legalRepresentative)
        // só um dos sócios pode ser master
        // outros sócios tem que se encaixar em uma das tres categorias
        this.partnersList = [
            {
                uuidBusinessPartner: '289392183971328',
                fullname: 'Gabriel Heitor Rodrigo Freitas',
                docNumber: '485.596.301-12',
                legalRepresentative: false,
                attorney: false,
                partner: true,
                master: true,
            },
            {
                uuidBusinessPartner: '289392183971928',
                fullname: 'Francisco Marcelo André Mendes',
                docNumber: '375.912.356-21',
                legalRepresentative: true,
                attorney: false,
                partner: false,
                master: false,
            },
            {
                uuidBusinessPartner: '289392183971999',
                fullname: 'Ayla Antônia Aurora Silveira',
                docNumber: '476.460.413-27',
                legalRepresentative: false,
                attorney: true,
                partner: false,
                master: false,
            },
        ];
    }
    // retorna dados normais (list) e dps Obersable
    getListPartners(uuidAccount, uuidWhiteLabel) {
        return this.partnersList;
    }
    addNewPartner(uuidAccount, uuidWhiteLabel, newPartner) {
        this.partnersList = [...this.partnersList, newPartner];
        return newPartner.uuidBusinessPartner;
    }
    editPartner(uuidAccount, uuidWhiteLabel, uuidBusinessPartner, editedPartner) {
        this.partnersList = this.partnersList.map((partner) => {
            if (partner.uuidBusinessPartner === uuidBusinessPartner)
                return editedPartner;
            return partner;
        });
        return editedPartner;
    }
    removePartner(uuidAccount, uuidWhiteLabel, uuidBusinessPartner) {
        const removedPartner = this.partnersList.find((partner) => partner.uuidBusinessPartner === uuidBusinessPartner);
        // console.log("ANTES DE REMOVE: " + this.partnersList)
        this.partnersList = this.partnersList.filter((partner) => partner.uuidBusinessPartner !== uuidBusinessPartner);
        // console.log("DEPOIS DE REMOVER: " + this.partnersList)
        return removedPartner;
    }
    getFaqList() {
        // const uri = `${SPE_N_ONBOARDING}/api/faq/`;
        // return this.api.get(uri);
        const data = [
            {
                id: 1,
                title: 'O que é um E-Commerce?',
                subtitle: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Sed euismod nisi porta lorem mollis aliquam. Scelerisque in dictum non consectetur`,
                date: new Date(),
                description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.`,
                fullDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. At augue eget arcu dictum varius duis at consectetur lorem. Ultricies leo integer
          malesuada nunc. Vitae semper quis lectus nulla at volutpat. Ornare arcu dui vivamus arcu felis bibendum ut tristique.
          Ut tortor pretium viverra suspendisse potenti nullam. Pretium viverra suspendisse potenti nullam ac tortor vitae purus.
          Morbi tristique senectus et netus et malesuada fames ac turpis. Tristique nulla aliquet enim tortor at auctor.
          Dignissim cras tincidunt lobortis feugiat vivamus. Placerat orci nulla pellentesque dignissim enim. Tincidunt lobortis
          feugiat vivamus at. Dui id ornare arcu odio ut sem. Tellus orci ac auctor augue mauris augue neque gravida. Sed id semper
          risus in hendrerit gravida rutrum. Scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt.`,
            },
            {
                id: 2,
                title: 'Quais documentos preciso apresentar?',
                subtitle: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Sed euismod nisi porta lorem mollis aliquam. Scelerisque in dictum non consectetur`,
                date: new Date(),
                description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.`,
                fullDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. At augue eget arcu dictum varius duis at consectetur lorem. Ultricies leo integer
          malesuada nunc. Vitae semper quis lectus nulla at volutpat. Ornare arcu dui vivamus arcu felis bibendum ut tristique.
          Ut tortor pretium viverra suspendisse potenti nullam. Pretium viverra suspendisse potenti nullam ac tortor vitae purus.
          Morbi tristique senectus et netus et malesuada fames ac turpis. Tristique nulla aliquet enim tortor at auctor.
          Dignissim cras tincidunt lobortis feugiat vivamus. Placerat orci nulla pellentesque dignissim enim. Tincidunt lobortis
          feugiat vivamus at. Dui id ornare arcu odio ut sem. Tellus orci ac auctor augue mauris augue neque gravida. Sed id semper
          risus in hendrerit gravida rutrum. Scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt.`,
            },
            {
                id: 3,
                title: 'Como solicitar uma maquininha?',
                subtitle: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Sed euismod nisi porta lorem mollis aliquam. Scelerisque in dictum non consectetur`,
                date: new Date(),
                description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.`,
                fullDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. At augue eget arcu dictum varius duis at consectetur lorem. Ultricies leo integer
          malesuada nunc. Vitae semper quis lectus nulla at volutpat. Ornare arcu dui vivamus arcu felis bibendum ut tristique.
          Ut tortor pretium viverra suspendisse potenti nullam. Pretium viverra suspendisse potenti nullam ac tortor vitae purus.
          Morbi tristique senectus et netus aqui é um teste et malesuada fames ac turpis. Tristique nulla aliquet enim tortor at auctor.
          Dignissim cras tincidunt lobortis feugiat vivamus. Placerat orci nulla pellentesque dignissim enim. Tincidunt lobortis
          feugiat vivamus at. Dui id ornare arcu odio ut sem. Tellus orci ac auctor augue mauris augue neque gravida. Sed id semper
          risus in hendrerit gravida rutrum. Scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt.`,
            },
            {
                id: 4,
                title: 'Taxas para vendas no crédito',
                subtitle: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Sed euismod nisi porta lorem mollis aliquam. Scelerisque in dictum non consectetur`,
                date: new Date(),
                description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.`,
                fullDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. At augue eget arcu dictum varius duis at consectetur lorem. Ultricies leo integer
          malesuada nunc. Vitae semper quis lectus nulla at volutpat. Ornare arcu dui vivamus arcu felis bibendum ut tristique.
          Ut tortor pretium viverra suspendisse potenti nullam. Pretium viverra suspendisse potenti nullam ac tortor vitae purus.
          Morbi tristique senectus et netus et malesuada fames ac turpis. Tristique nulla aliquet enim tortor at auctor.
          Dignissim cras tincidunt lobortis feugiat vivamus. Placerat orci nulla pellentesque dignissim enim. Tincidunt lobortis
          feugiat vivamus at. Dui id ornare arcu odio ut sem. Tellus orci ac auctor augue mauris augue neque gravida. Sed id semper
          risus in hendrerit gravida rutrum. Scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt.`,
            },
            {
                id: 5,
                title: 'Cancelamento',
                subtitle: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Sed euismod nisi porta lorem mollis aliquam. Scelerisque in dictum non consectetur`,
                date: new Date(),
                description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.`,
                fullDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. At augue eget arcu dictum varius duis at consectetur lorem. Ultricies leo integer
          malesuada nunc. Vitae semper quis lectus nulla at volutpat. Ornare arcu dui vivamus arcu felis bibendum ut tristique.
          Ut tortor pretium viverra suspendisse potenti nullam. Pretium viverra suspendisse potenti nullam ac tortor vitae purus.
          Morbi tristique senectus et netus et malesuada fames ac turpis. Tristique nulla aliquet enim tortor at auctor.
          Dignissim cras tincidunt lobortis feugiat vivamus. Placerat orci nulla pellentesque dignissim enim. Tincidunt lobortis
          feugiat vivamus at. Dui id ornare arcu odio ut sem. Tellus orci ac auctor augue mauris augue neque gravida. Sed id semper
          risus in hendrerit gravida rutrum. Scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt.`,
            },
        ];
        return data;
    }
};
SpeNOnboardingEcProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNOnboardingEcProxy);

const SPE_J_ONBOARDING_EC_UPLOAD = '/spe-j-open-account-upload';
let SpeJOnboardingEcUploadProxy = class SpeJOnboardingEcUploadProxy {
    constructor(api) {
        this.api = api;
    }
    getUploads(uuidAccount, uuidPartner) {
        // return this.api.get(uri);
        let response = {
            selfPhoto: 'UPLOADED',
            rg: 'UPLOADED',
            cnh: null,
            residencialCertificate: null,
            attorneyLetter: null,
        };
        return response;
    }
    uploadFile(id, upload) {
        let ownership = !!upload.ownership ? upload.ownership : '';
        const uri = `${SPE_J_ONBOARDING_EC_UPLOAD}/v1/image/upload/${id}?typeDocument=${upload.uploadType}&position=${upload.positionPhoto}&ownership=${ownership}`;
        let nameFile = !!upload.fileName ? upload.fileName : 'imagem.jpeg';
        // preparando objeto para converter para blob
        let image64 = upload.fileBase64;
        let block = image64.photo.split(";");
        let contentType = block[0].split(":")[1];
        let realData = block[1].split(",")[1];
        // convertendo para blob
        const blob = this.b64toBlob(realData, contentType);
        const formData = new FormData();
        const file = new File([blob], nameFile);
        formData.append('file', file);
        return this.api.post(uri, formData);
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};
SpeJOnboardingEcUploadProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJOnboardingEcUploadProxy);

const SPE_N_VIEW_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    findUuidAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_N_VIEW_ACCOUNT}/v1/product-request/of-account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_N_ACCOUNTS = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    save(request) {
        const uri = `${SPE_N_ACCOUNTS}/v1/product-request/`;
        return this.api.post(uri, request);
    }
    updateProduct(request, idPreProductAccount, uuid) {
        const uri = `${SPE_N_ACCOUNTS}/v1/product-request/${idPreProductAccount}/products/${uuid}/`;
        return this.api.put(uri, request);
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

const activitysBranchMock = [
    {
        id: 1882,
        departamentCode: "55",
        description: "Produção de carvão vegetal - florestas plantadas",
        cnae: "02101/08",
        activityBranch: "0210108",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1883,
        departamentCode: "55",
        description: "Produção de carvão vegetal - florestas nativas",
        cnae: "02209/02",
        activityBranch: "0220902",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1884,
        departamentCode: "55",
        description: "Extração de carvão mineral",
        cnae: "05003/01",
        activityBranch: "0500301",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1885,
        departamentCode: "119",
        description: "Beneficiamento de carvão mineral",
        cnae: "05003/02",
        activityBranch: "0500302",
        mcc: {
            code: 5983,
            description: "REVENDEDORES DE COMBUSTIVEIS (FUEL DEALERS)"
        }
    },
    {
        id: 1886,
        departamentCode: "56",
        description: "Extração de petróleo e gás natural",
        cnae: "06000/01",
        activityBranch: "0600001",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 1887,
        departamentCode: "56",
        description: "Extração e beneficiamento de xisto",
        cnae: "06000/02",
        activityBranch: "0600002",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 1888,
        departamentCode: "56",
        description: "Extração e beneficiamento de areias betuminosas",
        cnae: "06000/03",
        activityBranch: "0600003",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 1889,
        departamentCode: "43",
        description: "Extração de minério de ferro",
        cnae: "07103/01",
        activityBranch: "0710301",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1890,
        departamentCode: "43",
        description: "Pelotização, sinterização e outros beneficiamentos de minério de ferro",
        cnae: "07103/02",
        activityBranch: "0710302",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1891,
        departamentCode: "43",
        description: "Extração de minério de alumínio",
        cnae: "07219/01",
        activityBranch: "0721901",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1892,
        departamentCode: "43",
        description: "Beneficiamento de minério de alumínio",
        cnae: "07219/02",
        activityBranch: "0721902",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1893,
        departamentCode: "43",
        description: "Extração de minério de estanho",
        cnae: "07227/01",
        activityBranch: "0722701",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1894,
        departamentCode: "43",
        description: "Beneficiamento de minério de estanho",
        cnae: "07227/02",
        activityBranch: "0722702",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1895,
        departamentCode: "43",
        description: "Extração de minério de manganês",
        cnae: "07235/01",
        activityBranch: "0723501",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1896,
        departamentCode: "43",
        description: "Beneficiamento de minério de manganês",
        cnae: "07235/02",
        activityBranch: "0723502",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1897,
        departamentCode: "48",
        description: "Extração de minério de metais preciosos",
        cnae: "07243/01",
        activityBranch: "0724301",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 1898,
        departamentCode: "48",
        description: "Beneficiamento de minério de metais preciosos",
        cnae: "07243/02",
        activityBranch: "0724302",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 1899,
        departamentCode: "43",
        description: "Extração de minerais radioativos",
        cnae: "07251/00",
        activityBranch: "0725100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1900,
        departamentCode: "43",
        description: "Extração de minérios de nióbio e titânio",
        cnae: "07294/01",
        activityBranch: "0729401",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1901,
        departamentCode: "43",
        description: "Extração de minério de tungstênio",
        cnae: "07294/02",
        activityBranch: "0729402",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1902,
        departamentCode: "43",
        description: "Extração de minério de níquel",
        cnae: "07294/03",
        activityBranch: "0729403",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1903,
        departamentCode: "43",
        description: "Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não especificados anteriormente",
        cnae: "07294/04",
        activityBranch: "0729404",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1904,
        departamentCode: "43",
        description: "Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não especificados anteriormente",
        cnae: "07294/05",
        activityBranch: "0729405",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1905,
        departamentCode: "55",
        description: "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos",
        cnae: "08916/00",
        activityBranch: "0891600",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1906,
        departamentCode: "55",
        description: "Extração de sal marinho",
        cnae: "08924/01",
        activityBranch: "0892401",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1907,
        departamentCode: "55",
        description: "Extração de sal-gema",
        cnae: "08924/02",
        activityBranch: "0892402",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1908,
        departamentCode: "48",
        description: "Extração de gemas (pedras preciosas e semipreciosas)",
        cnae: "08932/00",
        activityBranch: "0893200",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 1909,
        departamentCode: "55",
        description: "Extração de grafita",
        cnae: "08991/01",
        activityBranch: "0899101",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1910,
        departamentCode: "55",
        description: "Extração de quartzo",
        cnae: "08991/02",
        activityBranch: "0899102",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1911,
        departamentCode: "55",
        description: "Extração de amianto",
        cnae: "08991/03",
        activityBranch: "0899103",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1912,
        departamentCode: "56",
        description: "Atividades de apoio à extração de petróleo e gás natural",
        cnae: "09106/00",
        activityBranch: "0910600",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 1913,
        departamentCode: "43",
        description: "Atividades de apoio à extração de minério de ferro",
        cnae: "09904/01",
        activityBranch: "0990401",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1914,
        departamentCode: "43",
        description: "Atividades de apoio à extração de minerais metálicos não-ferrosos",
        cnae: "09904/02",
        activityBranch: "0990402",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 1915,
        departamentCode: "71",
        description: "Frigorífico - abate de bovinos",
        cnae: "10112/01",
        activityBranch: "1011201",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1916,
        departamentCode: "71",
        description: "Frigorífico - abate de eqüinos",
        cnae: "10112/02",
        activityBranch: "1011202",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1917,
        departamentCode: "71",
        description: "Frigorífico - abate de ovinos e caprinos",
        cnae: "10112/03",
        activityBranch: "1011203",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1918,
        departamentCode: "71",
        description: "Frigorífico - abate de bufalinos",
        cnae: "10112/04",
        activityBranch: "1011204",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1919,
        departamentCode: "71",
        description: "Matadouro - abate de reses sob contrato, exceto abate de suínos",
        cnae: "10112/05",
        activityBranch: "1011205",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1920,
        departamentCode: "75",
        description: "Abate de aves",
        cnae: "10121/01",
        activityBranch: "1012101",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 1921,
        departamentCode: "71",
        description: "Abate de pequenos animais",
        cnae: "10121/02",
        activityBranch: "1012102",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1922,
        departamentCode: "71",
        description: "Frigorífico - abate de suínos",
        cnae: "10121/03",
        activityBranch: "1012103",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1923,
        departamentCode: "71",
        description: "Matadouro - abate de suínos sob contrato",
        cnae: "10121/04",
        activityBranch: "1012104",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1924,
        departamentCode: "60",
        description: "Fabricação de produtos de carne",
        cnae: "10139/01",
        activityBranch: "1013901",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1925,
        departamentCode: "71",
        description: "Preparação de subprodutos do abate",
        cnae: "10139/02",
        activityBranch: "1013902",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1926,
        departamentCode: "71",
        description: "Preservação de peixes, crustáceos e moluscos",
        cnae: "10201/01",
        activityBranch: "1020101",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 1927,
        departamentCode: "60",
        description: "Fabricação de conservas de peixes, crustáceos e moluscos",
        cnae: "10201/02",
        activityBranch: "1020102",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1928,
        departamentCode: "60",
        description: "Fabricação de conservas de frutas",
        cnae: "10317/00",
        activityBranch: "1031700",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1929,
        departamentCode: "60",
        description: "Fabricação de conservas de palmito",
        cnae: "10325/01",
        activityBranch: "1032501",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1930,
        departamentCode: "60",
        description: "Fabricação de conservas de legumes e outros vegetais, exceto palmito",
        cnae: "10325/99",
        activityBranch: "1032599",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1931,
        departamentCode: "60",
        description: "Fabricação de sucos concentrados de frutas, hortaliças e legumes",
        cnae: "10333/01",
        activityBranch: "1033301",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1932,
        departamentCode: "60",
        description: "Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados",
        cnae: "10333/02",
        activityBranch: "1033302",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1933,
        departamentCode: "60",
        description: "Fabricação de óleos vegetais em bruto, exceto óleo de milho",
        cnae: "10414/00",
        activityBranch: "1041400",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1934,
        departamentCode: "60",
        description: "Fabricação de óleos vegetais refinados, exceto óleo de milho",
        cnae: "10422/00",
        activityBranch: "1042200",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1935,
        departamentCode: "60",
        description: "Fabricação de margarina e outras gorduras vegetais e de óleos não-comestíveis de animais",
        cnae: "10431/00",
        activityBranch: "1043100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1936,
        departamentCode: "60",
        description: "Preparação do leite",
        cnae: "10511/00",
        activityBranch: "1051100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1937,
        departamentCode: "60",
        description: "Fabricação de laticínios",
        cnae: "10520/00",
        activityBranch: "1052000",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1938,
        departamentCode: "60",
        description: "Fabricação de sorvetes e outros gelados comestíveis",
        cnae: "10538/00",
        activityBranch: "1053800",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1939,
        departamentCode: "60",
        description: "Fabricação de produtos do arroz",
        cnae: "10619/02",
        activityBranch: "1061902",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1940,
        departamentCode: "60",
        description: "Moagem de trigo e fabricação de derivados",
        cnae: "10627/00",
        activityBranch: "1062700",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1941,
        departamentCode: "60",
        description: "Fabricação de farinha de mandioca e derivados",
        cnae: "10635/00",
        activityBranch: "1063500",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1942,
        departamentCode: "60",
        description: "Fabricação de farinha de milho e derivados, exceto óleos de milho",
        cnae: "10643/00",
        activityBranch: "1064300",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1943,
        departamentCode: "60",
        description: "Fabricação de amidos e féculas de vegetais",
        cnae: "10651/01",
        activityBranch: "1065101",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1944,
        departamentCode: "60",
        description: "Fabricação de óleo de milho em bruto",
        cnae: "10651/02",
        activityBranch: "1065102",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1945,
        departamentCode: "60",
        description: "Fabricação de óleo de milho refinado",
        cnae: "10651/03",
        activityBranch: "1065103",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1946,
        departamentCode: "60",
        description: "Fabricação de alimentos para animais",
        cnae: "10660/00",
        activityBranch: "1066000",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1947,
        departamentCode: "60",
        description: "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente",
        cnae: "10694/00",
        activityBranch: "1069400",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1948,
        departamentCode: "60",
        description: "Fabricação de açúcar em bruto",
        cnae: "10716/00",
        activityBranch: "1071600",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1949,
        departamentCode: "60",
        description: "Fabricação de açúcar de cana refinado",
        cnae: "10724/01",
        activityBranch: "1072401",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1950,
        departamentCode: "60",
        description: "Fabricação de açúcar de cereais (dextrose) e de beterraba",
        cnae: "10724/02",
        activityBranch: "1072402",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1951,
        departamentCode: "60",
        description: "Fabricação de produtos à base de café",
        cnae: "10821/00",
        activityBranch: "1082100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1952,
        departamentCode: "74",
        description: "Fabricação de produtos de panificação industrial",
        cnae: "10911/01",
        activityBranch: "1091101",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 1953,
        departamentCode: "74",
        description: "Fabricação de produtos de padaria e confeitaria com predominância de produção própria",
        cnae: "10911/02",
        activityBranch: "1091102",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 1954,
        departamentCode: "60",
        description: "Fabricação de biscoitos e bolachas",
        cnae: "10929/00",
        activityBranch: "1092900",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1955,
        departamentCode: "60",
        description: "Fabricação de produtos derivados do cacau e de chocolates",
        cnae: "10937/01",
        activityBranch: "1093701",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1956,
        departamentCode: "60",
        description: "Fabricação de frutas cristalizadas, balas e semelhantes",
        cnae: "10937/02",
        activityBranch: "1093702",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1957,
        departamentCode: "60",
        description: "Fabricação de massas alimentícias",
        cnae: "10945/00",
        activityBranch: "1094500",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1958,
        departamentCode: "60",
        description: "Fabricação de especiarias, molhos, temperos e condimentos",
        cnae: "10953/00",
        activityBranch: "1095300",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1959,
        departamentCode: "60",
        description: "Fabricação de alimentos e pratos prontos",
        cnae: "10961/00",
        activityBranch: "1096100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1960,
        departamentCode: "60",
        description: "Fabricação de vinagres",
        cnae: "10996/01",
        activityBranch: "1099601",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1961,
        departamentCode: "60",
        description: "Fabricação de pós alimentícios",
        cnae: "10996/02",
        activityBranch: "1099602",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1962,
        departamentCode: "60",
        description: "Fabricação de fermentos e leveduras",
        cnae: "10996/03",
        activityBranch: "1099603",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1963,
        departamentCode: "60",
        description: "Fabricação de gelo comum",
        cnae: "10996/04",
        activityBranch: "1099604",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1964,
        departamentCode: "60",
        description: "Fabricação de produtos para infusão (chá, mate, etc.)",
        cnae: "10996/05",
        activityBranch: "1099605",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1965,
        departamentCode: "60",
        description: "Fabricação de adoçantes naturais e artificiais",
        cnae: "10996/06",
        activityBranch: "1099606",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1966,
        departamentCode: "60",
        description: "Fabricação de alimentos dietéticos e complementos alimentares",
        cnae: "10996/07",
        activityBranch: "1099607",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1967,
        departamentCode: "60",
        description: "Fabricação de outros produtos alimentícios não especificados anteriormente",
        cnae: "10996/99",
        activityBranch: "1099699",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1968,
        departamentCode: "60",
        description: "Fabricação de aguardente de cana-de-açúcar",
        cnae: "11119/01",
        activityBranch: "1111901",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1969,
        departamentCode: "60",
        description: "Fabricação de outras aguardentes e bebidas destiladas",
        cnae: "11119/02",
        activityBranch: "1111902",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1970,
        departamentCode: "60",
        description: "Fabricação de vinho",
        cnae: "11127/00",
        activityBranch: "1112700",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1971,
        departamentCode: "60",
        description: "Fabricação de malte, inclusive malte uísque",
        cnae: "11135/01",
        activityBranch: "1113501",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1972,
        departamentCode: "60",
        description: "Fabricação de cervejas e chopes",
        cnae: "11135/02",
        activityBranch: "1113502",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1973,
        departamentCode: "60",
        description: "Fabricação de águas envasadas",
        cnae: "11216/00",
        activityBranch: "1121600",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1974,
        departamentCode: "60",
        description: "Fabricação de refrigerantes",
        cnae: "11224/01",
        activityBranch: "1122401",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1975,
        departamentCode: "60",
        description: "Fabricação de chá mate e outros chás prontos para consumo",
        cnae: "11224/02",
        activityBranch: "1122402",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1976,
        departamentCode: "60",
        description: "Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas",
        cnae: "11224/03",
        activityBranch: "1122403",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1977,
        departamentCode: "60",
        description: "Fabricação de bebidas isotônicas",
        cnae: "11224/04",
        activityBranch: "1122404",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1978,
        departamentCode: "60",
        description: "Fabricação de outras bebidas não-alcoólicas não especificadas anteriormente",
        cnae: "11224/99",
        activityBranch: "1122499",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1979,
        departamentCode: "60",
        description: "Fabricação de cigarros",
        cnae: "12204/01",
        activityBranch: "1220401",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1980,
        departamentCode: "60",
        description: "Fabricação de cigarrilhas e charutos",
        cnae: "12204/02",
        activityBranch: "1220402",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1981,
        departamentCode: "60",
        description: "Fabricação de filtros para cigarros",
        cnae: "12204/03",
        activityBranch: "1220403",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1982,
        departamentCode: "60",
        description: "Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos",
        cnae: "12204/99",
        activityBranch: "1220499",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 1983,
        departamentCode: "52",
        description: "Preparação e fiação de fibras de algodão",
        cnae: "13111/00",
        activityBranch: "1311100",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1984,
        departamentCode: "52",
        description: "Preparação e fiação de fibras têxteis naturais, exceto algodão",
        cnae: "13120/00",
        activityBranch: "1312000",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1985,
        departamentCode: "52",
        description: "Fiação de fibras artificiais e sintéticas",
        cnae: "13138/00",
        activityBranch: "1313800",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1986,
        departamentCode: "52",
        description: "Fabricação de linhas para costurar e bordar",
        cnae: "13146/00",
        activityBranch: "1314600",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1987,
        departamentCode: "52",
        description: "Tecelagem de fios de algodão",
        cnae: "13219/00",
        activityBranch: "1321900",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1988,
        departamentCode: "52",
        description: "Tecelagem de fios de fibras têxteis naturais, exceto algodão",
        cnae: "13227/00",
        activityBranch: "1322700",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1989,
        departamentCode: "52",
        description: "Tecelagem de fios de fibras artificiais e sintéticas",
        cnae: "13235/00",
        activityBranch: "1323500",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1990,
        departamentCode: "52",
        description: "Fabricação de tecidos de malha",
        cnae: "13308/00",
        activityBranch: "1330800",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1991,
        departamentCode: "52",
        description: "Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário",
        cnae: "13405/01",
        activityBranch: "1340501",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1992,
        departamentCode: "52",
        description: "Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário",
        cnae: "13405/02",
        activityBranch: "1340502",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1993,
        departamentCode: "86",
        description: "Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário",
        cnae: "13405/99",
        activityBranch: "1340599",
        mcc: {
            code: 5697,
            description: "COSTUREIRAS E ALFAIATES"
        }
    },
    {
        id: 1994,
        departamentCode: "52",
        description: "Fabricação de artefatos têxteis para uso doméstico",
        cnae: "13511/00",
        activityBranch: "1351100",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1995,
        departamentCode: "52",
        description: "Fabricação de artefatos de tapeçaria",
        cnae: "13529/00",
        activityBranch: "1352900",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1996,
        departamentCode: "52",
        description: "Fabricação de artefatos de cordoaria",
        cnae: "13537/00",
        activityBranch: "1353700",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1997,
        departamentCode: "52",
        description: "Fabricação de tecidos especiais, inclusive artefatos",
        cnae: "13545/00",
        activityBranch: "1354500",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1998,
        departamentCode: "52",
        description: "Fabricação de outros produtos têxteis não especificados anteriormente",
        cnae: "13596/00",
        activityBranch: "1359600",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 1999,
        departamentCode: "53",
        description: "Confecção de roupas íntimas",
        cnae: "14118/01",
        activityBranch: "1411801",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2000,
        departamentCode: "53",
        description: "Facção de roupas íntimas",
        cnae: "14118/02",
        activityBranch: "1411802",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2001,
        departamentCode: "53",
        description: "Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida",
        cnae: "14126/01",
        activityBranch: "1412601",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2002,
        departamentCode: "86",
        description: "Confecção, sob medida, de peças do vestuário, exceto roupas íntimas",
        cnae: "14126/02",
        activityBranch: "1412602",
        mcc: {
            code: 5697,
            description: "COSTUREIRAS E ALFAIATES"
        }
    },
    {
        id: 2003,
        departamentCode: "53",
        description: "Facção de peças do vestuário, exceto roupas íntimas",
        cnae: "14126/03",
        activityBranch: "1412603",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2004,
        departamentCode: "53",
        description: "Confecção de roupas profissionais, exceto sob medida",
        cnae: "14134/01",
        activityBranch: "1413401",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2005,
        departamentCode: "53",
        description: "Confecção, sob medida, de roupas profissionais",
        cnae: "14134/02",
        activityBranch: "1413402",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2006,
        departamentCode: "53",
        description: "Facção de roupas profissionais",
        cnae: "14134/03",
        activityBranch: "1413403",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2007,
        departamentCode: "53",
        description: "Fabricação de acessórios do vestuário, exceto para segurança e proteção",
        cnae: "14142/00",
        activityBranch: "1414200",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2008,
        departamentCode: "53",
        description: "Fabricação de meias",
        cnae: "14215/00",
        activityBranch: "1421500",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2009,
        departamentCode: "84",
        description: "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias",
        cnae: "14223/00",
        activityBranch: "1422300",
        mcc: {
            code: 5651,
            description: "ROUPAS MASCULINAS, FEMININAS E INFANTIS"
        }
    },
    {
        id: 2010,
        departamentCode: "113",
        description: "Curtimento e outras preparações de couro",
        cnae: "15106/00",
        activityBranch: "1510600",
        mcc: {
            code: 5948,
            description: "ARTIGOS DE COURO"
        }
    },
    {
        id: 2011,
        departamentCode: "60",
        description: "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material",
        cnae: "15211/00",
        activityBranch: "1521100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2012,
        departamentCode: "113",
        description: "Fabricação de artefatos de couro não especificados anteriormente",
        cnae: "15297/00",
        activityBranch: "1529700",
        mcc: {
            code: 5948,
            description: "ARTIGOS DE COURO"
        }
    },
    {
        id: 2013,
        departamentCode: "54",
        description: "Fabricação de calçados de couro",
        cnae: "15319/01",
        activityBranch: "1531901",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2014,
        departamentCode: "54",
        description: "Acabamento de calçados de couro sob contrato",
        cnae: "15319/02",
        activityBranch: "1531902",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2015,
        departamentCode: "54",
        description: "Fabricação de tênis de qualquer material",
        cnae: "15327/00",
        activityBranch: "1532700",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2016,
        departamentCode: "54",
        description: "Fabricação de calçados de material sintético",
        cnae: "15335/00",
        activityBranch: "1533500",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2017,
        departamentCode: "54",
        description: "Fabricação de calçados de materiais não especificados anteriormente",
        cnae: "15394/00",
        activityBranch: "1539400",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2018,
        departamentCode: "54",
        description: "Fabricação de partes para calçados, de qualquer material",
        cnae: "15408/00",
        activityBranch: "1540800",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2019,
        departamentCode: "61",
        description: "Serrarias com desdobramento de madeira",
        cnae: "16102/01",
        activityBranch: "1610201",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2020,
        departamentCode: "61",
        description: "Serrarias sem desdobramento de madeira",
        cnae: "16102/02",
        activityBranch: "1610202",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2021,
        departamentCode: "49",
        description: "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada",
        cnae: "16218/00",
        activityBranch: "1621800",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2022,
        departamentCode: "4",
        description: "Fabricação de casas de madeira pré-fabricadas",
        cnae: "16226/01",
        activityBranch: "1622601",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2023,
        departamentCode: "49",
        description: "Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais",
        cnae: "16226/02",
        activityBranch: "1622602",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2024,
        departamentCode: "49",
        description: "Fabricação de outros artigos de carpintaria para construção",
        cnae: "16226/99",
        activityBranch: "1622699",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2025,
        departamentCode: "47",
        description: "Fabricação de artefatos de tanoaria e de embalagens de madeira",
        cnae: "16234/00",
        activityBranch: "1623400",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2026,
        departamentCode: "49",
        description: "Fabricação de artefatos diversos de madeira, exceto móveis",
        cnae: "16293/01",
        activityBranch: "1629301",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2027,
        departamentCode: "47",
        description: "Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis",
        cnae: "16293/02",
        activityBranch: "1629302",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2028,
        departamentCode: "50",
        description: "Fabricação de celulose e outras pastas para a fabricação de papel",
        cnae: "17109/00",
        activityBranch: "1710900",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2029,
        departamentCode: "50",
        description: "Fabricação de papel",
        cnae: "17214/00",
        activityBranch: "1721400",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2030,
        departamentCode: "50",
        description: "Fabricação de cartolina e papel-cartão",
        cnae: "17222/00",
        activityBranch: "1722200",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2031,
        departamentCode: "60",
        description: "Fabricação de embalagens de papel",
        cnae: "17311/00",
        activityBranch: "1731100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2032,
        departamentCode: "60",
        description: "Fabricação de embalagens de cartolina e papel-cartão",
        cnae: "17320/00",
        activityBranch: "1732000",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2033,
        departamentCode: "50",
        description: "Fabricação de chapas e de embalagens de papelão ondulado",
        cnae: "17338/00",
        activityBranch: "1733800",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2034,
        departamentCode: "50",
        description: "Fabricação de formulários contínuos",
        cnae: "17419/01",
        activityBranch: "1741901",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2035,
        departamentCode: "50",
        description: "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório",
        cnae: "17419/02",
        activityBranch: "1741902",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2036,
        departamentCode: "51",
        description: "Fabricação de fraldas descartáveis",
        cnae: "17427/01",
        activityBranch: "1742701",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2037,
        departamentCode: "51",
        description: "Fabricação de absorventes higiênicos",
        cnae: "17427/02",
        activityBranch: "1742702",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2038,
        departamentCode: "51",
        description: "Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente",
        cnae: "17427/99",
        activityBranch: "1742799",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2039,
        departamentCode: "50",
        description: "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente",
        cnae: "17494/00",
        activityBranch: "1749400",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2040,
        departamentCode: "12",
        description: "Impressão de jornais",
        cnae: "18113/01",
        activityBranch: "1811301",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2041,
        departamentCode: "12",
        description: "Impressão de livros, revistas e outras publicações periódicas",
        cnae: "18113/02",
        activityBranch: "1811302",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2042,
        departamentCode: "12",
        description: "Impressão de material de segurança",
        cnae: "18121/00",
        activityBranch: "1812100",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2043,
        departamentCode: "12",
        description: "Impressão de material para uso publicitário",
        cnae: "18130/01",
        activityBranch: "1813001",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2044,
        departamentCode: "12",
        description: "Impressão de material para outros usos",
        cnae: "18130/99",
        activityBranch: "1813099",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2045,
        departamentCode: "13",
        description: "Serviços de pré-impressão",
        cnae: "18211/00",
        activityBranch: "1821100",
        mcc: {
            code: 2791,
            description: "TIPOGRAFIA, FABRICACAO DE CHAPAS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2046,
        departamentCode: "147",
        description: "Serviços de encadernação e plastificação",
        cnae: "18229/01",
        activityBranch: "1822901",
        mcc: {
            code: 7338,
            description: "SERVICOS DE COPIA RAPIDA, REPRODUCAO E BLUEPRINTING"
        }
    },
    {
        id: 2047,
        departamentCode: "147",
        description: "Serviços de acabamentos gráficos, exceto encadernação e plastificação",
        cnae: "18229/99",
        activityBranch: "1822999",
        mcc: {
            code: 7338,
            description: "SERVICOS DE COPIA RAPIDA, REPRODUCAO E BLUEPRINTING"
        }
    },
    {
        id: 2048,
        departamentCode: "143",
        description: "Reprodução de som em qualquer suporte",
        cnae: "18300/01",
        activityBranch: "1830001",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2049,
        departamentCode: "170",
        description: "Reprodução de vídeo em qualquer suporte",
        cnae: "18300/02",
        activityBranch: "1830002",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2050,
        departamentCode: "40",
        description: "Reprodução de software em qualquer suporte",
        cnae: "18300/03",
        activityBranch: "1830003",
        mcc: {
            code: 5045,
            description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES"
        }
    },
    {
        id: 2051,
        departamentCode: "47",
        description: "Coquerias",
        cnae: "19101/00",
        activityBranch: "1910100",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2052,
        departamentCode: "56",
        description: "Fabricação de produtos do refino de petróleo",
        cnae: "19217/00",
        activityBranch: "1921700",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2053,
        departamentCode: "56",
        description: "Formulação de combustíveis",
        cnae: "19225/01",
        activityBranch: "1922501",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2054,
        departamentCode: "56",
        description: "Rerrefino de óleos lubrificantes",
        cnae: "19225/02",
        activityBranch: "1922502",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2055,
        departamentCode: "56",
        description: "Fabricação de outros produtos derivados do petróleo, exceto produtos do refino",
        cnae: "19225/99",
        activityBranch: "1922599",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2056,
        departamentCode: "55",
        description: "Fabricação de álcool",
        cnae: "19314/00",
        activityBranch: "1931400",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2057,
        departamentCode: "56",
        description: "Fabricação de biocombustíveis, exceto álcool",
        cnae: "19322/00",
        activityBranch: "1932200",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2058,
        departamentCode: "55",
        description: "Fabricação de cloro e álcalis",
        cnae: "20118/00",
        activityBranch: "2011800",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2059,
        departamentCode: "55",
        description: "Fabricação de intermediários para fertilizantes",
        cnae: "20126/00",
        activityBranch: "2012600",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2060,
        departamentCode: "55",
        description: "Fabricação de adubos e fertilizantes organo-minerais",
        cnae: "20134/01",
        activityBranch: "2013401",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2061,
        departamentCode: "55",
        description: "Fabricação de adubos e fertilizantes, exceto organo-minerais",
        cnae: "20134/02",
        activityBranch: "2013402",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2062,
        departamentCode: "55",
        description: "Fabricação de gases industriais",
        cnae: "20142/00",
        activityBranch: "2014200",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2063,
        departamentCode: "55",
        description: "Elaboração de combustíveis nucleares",
        cnae: "20193/01",
        activityBranch: "2019301",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2064,
        departamentCode: "55",
        description: "Fabricação de outros produtos químicos inorgânicos não especificados anteriormente",
        cnae: "20193/99",
        activityBranch: "2019399",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2065,
        departamentCode: "55",
        description: "Fabricação de produtos petroquímicos básicos",
        cnae: "20215/00",
        activityBranch: "2021500",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2066,
        departamentCode: "55",
        description: "Fabricação de intermediários para plastificantes, resinas e fibras",
        cnae: "20223/00",
        activityBranch: "2022300",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2067,
        departamentCode: "55",
        description: "Fabricação de produtos químicos orgânicos não especificados anteriormente",
        cnae: "20291/00",
        activityBranch: "2029100",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2068,
        departamentCode: "55",
        description: "Fabricação de resinas termoplásticas",
        cnae: "20312/00",
        activityBranch: "2031200",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2069,
        departamentCode: "55",
        description: "Fabricação de resinas termofixas",
        cnae: "20321/00",
        activityBranch: "2032100",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2070,
        departamentCode: "55",
        description: "Fabricação de elastômeros",
        cnae: "20339/00",
        activityBranch: "2033900",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2071,
        departamentCode: "55",
        description: "Fabricação de fibras artificiais e sintéticas",
        cnae: "20401/00",
        activityBranch: "2040100",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2072,
        departamentCode: "55",
        description: "Fabricação de defensivos agrícolas",
        cnae: "20517/00",
        activityBranch: "2051700",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2073,
        departamentCode: "14",
        description: "Fabricação de desinfestantes domissanitários",
        cnae: "20525/00",
        activityBranch: "2052500",
        mcc: {
            code: 2842,
            description: "PREPARACOES ESPECIAIS DE LIMPEZA, POLIMENTO E SANEAMENTO"
        }
    },
    {
        id: 2074,
        departamentCode: "14",
        description: "Fabricação de sabões e detergentes sintéticos",
        cnae: "20614/00",
        activityBranch: "2061400",
        mcc: {
            code: 2842,
            description: "PREPARACOES ESPECIAIS DE LIMPEZA, POLIMENTO E SANEAMENTO"
        }
    },
    {
        id: 2075,
        departamentCode: "14",
        description: "Fabricação de produtos de limpeza e polimento",
        cnae: "20622/00",
        activityBranch: "2062200",
        mcc: {
            code: 2842,
            description: "PREPARACOES ESPECIAIS DE LIMPEZA, POLIMENTO E SANEAMENTO"
        }
    },
    {
        id: 2076,
        departamentCode: "51",
        description: "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal",
        cnae: "20631/00",
        activityBranch: "2063100",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2077,
        departamentCode: "59",
        description: "Fabricação de tintas, vernizes, esmaltes e lacas",
        cnae: "20711/00",
        activityBranch: "2071100",
        mcc: {
            code: 5198,
            description: "PINTURA, POLIMENTO E SUPRIM. (PAN., VARN. & SUPPLIES)"
        }
    },
    {
        id: 2078,
        departamentCode: "59",
        description: "Fabricação de tintas de impressão",
        cnae: "20720/00",
        activityBranch: "2072000",
        mcc: {
            code: 5198,
            description: "PINTURA, POLIMENTO E SUPRIM. (PAN., VARN. & SUPPLIES)"
        }
    },
    {
        id: 2079,
        departamentCode: "55",
        description: "Fabricação de impermeabilizantes, solventes e produtos afins",
        cnae: "20738/00",
        activityBranch: "2073800",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2080,
        departamentCode: "55",
        description: "Fabricação de adesivos e selantes",
        cnae: "20916/00",
        activityBranch: "2091600",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2081,
        departamentCode: "55",
        description: "Fabricação de pólvoras, explosivos e detonantes",
        cnae: "20924/01",
        activityBranch: "2092401",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2082,
        departamentCode: "55",
        description: "Fabricação de artigos pirotécnicos",
        cnae: "20924/02",
        activityBranch: "2092402",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2083,
        departamentCode: "55",
        description: "Fabricação de fósforos de segurança",
        cnae: "20924/03",
        activityBranch: "2092403",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2084,
        departamentCode: "55",
        description: "Fabricação de aditivos de uso industrial",
        cnae: "20932/00",
        activityBranch: "2093200",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2085,
        departamentCode: "55",
        description: "Fabricação de catalisadores",
        cnae: "20941/00",
        activityBranch: "2094100",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2086,
        departamentCode: "39",
        description: "Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia",
        cnae: "20991/01",
        activityBranch: "2099101",
        mcc: {
            code: 5044,
            description: "EQUIPAMENTO DE ESCRITORIO, FOTOGRAFICO, FOTOCOPIA E MICROFILME"
        }
    },
    {
        id: 2087,
        departamentCode: "55",
        description: "Fabricação de outros produtos químicos não especificados anteriormente",
        cnae: "20991/99",
        activityBranch: "2099199",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2088,
        departamentCode: "51",
        description: "Fabricação de produtos farmoquímicos",
        cnae: "21106/00",
        activityBranch: "2110600",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2089,
        departamentCode: "51",
        description: "Fabricação de medicamentos alopáticos para uso humano",
        cnae: "21211/01",
        activityBranch: "2121101",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2090,
        departamentCode: "51",
        description: "Fabricação de medicamentos homeopáticos para uso humano",
        cnae: "21211/02",
        activityBranch: "2121102",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2091,
        departamentCode: "51",
        description: "Fabricação de medicamentos fitoterápicos para uso humano",
        cnae: "21211/03",
        activityBranch: "2121103",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2092,
        departamentCode: "51",
        description: "Fabricação de medicamentos para uso veterinário",
        cnae: "21220/00",
        activityBranch: "2122000",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2093,
        departamentCode: "51",
        description: "Fabricação de preparações farmacêuticas",
        cnae: "21238/00",
        activityBranch: "2123800",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2094,
        departamentCode: "36",
        description: "Fabricação de pneumáticos e de câmaras-de-ar",
        cnae: "22111/00",
        activityBranch: "2211100",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2095,
        departamentCode: "161",
        description: "Reforma de pneumáticos usados",
        cnae: "22129/00",
        activityBranch: "2212900",
        mcc: {
            code: 7534,
            description: "REFORMA DE PNEUS E OFICINAS"
        }
    },
    {
        id: 2096,
        departamentCode: "47",
        description: "Fabricação de artefatos de borracha não especificados anteriormente",
        cnae: "22196/00",
        activityBranch: "2219600",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2097,
        departamentCode: "38",
        description: "Fabricação de laminados planos e tubulares de material plástico",
        cnae: "22218/00",
        activityBranch: "2221800",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2098,
        departamentCode: "47",
        description: "Fabricação de embalagens de material plástico",
        cnae: "22226/00",
        activityBranch: "2222600",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2099,
        departamentCode: "38",
        description: "Fabricação de tubos e acessórios de material plástico para uso na construção",
        cnae: "22234/00",
        activityBranch: "2223400",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2100,
        departamentCode: "60",
        description: "Fabricação de artefatos de material plástico para uso pessoal e doméstico",
        cnae: "22293/01",
        activityBranch: "2229301",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2101,
        departamentCode: "47",
        description: "Fabricação de artefatos de material plástico para usos industriais",
        cnae: "22293/02",
        activityBranch: "2229302",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2102,
        departamentCode: "38",
        description: "Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios",
        cnae: "22293/03",
        activityBranch: "2229303",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2103,
        departamentCode: "49",
        description: "Fabricação de artefatos de material plástico para outros usos não especificados anteriormente",
        cnae: "22293/99",
        activityBranch: "2229399",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2104,
        departamentCode: "38",
        description: "Fabricação de vidro plano e de segurança",
        cnae: "23117/00",
        activityBranch: "2311700",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2105,
        departamentCode: "38",
        description: "Fabricação de embalagens de vidro",
        cnae: "23125/00",
        activityBranch: "2312500",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2106,
        departamentCode: "38",
        description: "Fabricação de artigos de vidro",
        cnae: "23192/00",
        activityBranch: "2319200",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2107,
        departamentCode: "38",
        description: "Fabricação de cimento",
        cnae: "23206/00",
        activityBranch: "2320600",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2108,
        departamentCode: "38",
        description: "Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda",
        cnae: "23303/01",
        activityBranch: "2330301",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2109,
        departamentCode: "38",
        description: "Fabricação de artefatos de cimento para uso na construção",
        cnae: "23303/02",
        activityBranch: "2330302",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2110,
        departamentCode: "38",
        description: "Fabricação de artefatos de fibrocimento para uso na construção",
        cnae: "23303/03",
        activityBranch: "2330303",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2111,
        departamentCode: "38",
        description: "Fabricação de casas pré-moldadas de concreto",
        cnae: "23303/04",
        activityBranch: "2330304",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2112,
        departamentCode: "10",
        description: "Preparação de massa de concreto e argamassa para construção",
        cnae: "23303/05",
        activityBranch: "2330305",
        mcc: {
            code: 1771,
            description: "EMPREITEIO PARA SERVICOS ESPECIALIZADO"
        }
    },
    {
        id: 2113,
        departamentCode: "38",
        description: "Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais semelhantes",
        cnae: "23303/99",
        activityBranch: "2330399",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2114,
        departamentCode: "38",
        description: "Fabricação de produtos cerâmicos refratários",
        cnae: "23419/00",
        activityBranch: "2341900",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2115,
        departamentCode: "38",
        description: "Fabricação de azulejos e pisos",
        cnae: "23427/01",
        activityBranch: "2342701",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2116,
        departamentCode: "38",
        description: "Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos",
        cnae: "23427/02",
        activityBranch: "2342702",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2117,
        departamentCode: "38",
        description: "Fabricação de material sanitário de cerâmica",
        cnae: "23494/01",
        activityBranch: "2349401",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2118,
        departamentCode: "38",
        description: "Fabricação de produtos cerâmicos não-refratários não especificados anteriormente",
        cnae: "23494/99",
        activityBranch: "2349499",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2119,
        departamentCode: "38",
        description: "Britamento de pedras, exceto associado à extração",
        cnae: "23915/01",
        activityBranch: "2391501",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2120,
        departamentCode: "7",
        description: "Aparelhamento de pedras para construção, exceto associado à extração",
        cnae: "23915/02",
        activityBranch: "2391502",
        mcc: {
            code: 1740,
            description: "PEDREIROS E SERVICOS DE INSTALACAO"
        }
    },
    {
        id: 2121,
        departamentCode: "49",
        description: "Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras",
        cnae: "23915/03",
        activityBranch: "2391503",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2122,
        departamentCode: "38",
        description: "Fabricação de cal e gesso",
        cnae: "23923/00",
        activityBranch: "2392300",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2123,
        departamentCode: "143",
        description: "Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal",
        cnae: "23991/01",
        activityBranch: "2399101",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2124,
        departamentCode: "55",
        description: "Fabricação de abrasivos",
        cnae: "23991/02",
        activityBranch: "2399102",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2125,
        departamentCode: "49",
        description: "Fabricação de outros produtos de minerais não-metálicos não especificados anteriormente",
        cnae: "23991/99",
        activityBranch: "2399199",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2126,
        departamentCode: "43",
        description: "Produção de ferro-gusa",
        cnae: "24113/00",
        activityBranch: "2411300",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2127,
        departamentCode: "43",
        description: "Produção de ferroligas",
        cnae: "24121/00",
        activityBranch: "2412100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2128,
        departamentCode: "43",
        description: "Produção de semi-acabados de aço",
        cnae: "24211/00",
        activityBranch: "2421100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2129,
        departamentCode: "43",
        description: "Produção de laminados planos de aço ao carbono, revestidos ou não",
        cnae: "24229/01",
        activityBranch: "2422901",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2130,
        departamentCode: "43",
        description: "Produção de laminados planos de aços especiais",
        cnae: "24229/02",
        activityBranch: "2422902",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2131,
        departamentCode: "43",
        description: "Produção de tubos de aço sem costura",
        cnae: "24237/01",
        activityBranch: "2423701",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2132,
        departamentCode: "43",
        description: "Produção de laminados longos de aço, exceto tubos",
        cnae: "24237/02",
        activityBranch: "2423702",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2133,
        departamentCode: "43",
        description: "Produção de arames de aço",
        cnae: "24245/01",
        activityBranch: "2424501",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2134,
        departamentCode: "43",
        description: "Produção de relaminados, trefilados e perfilados de aço, exceto arames",
        cnae: "24245/02",
        activityBranch: "2424502",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2135,
        departamentCode: "43",
        description: "Produção de tubos de aço com costura",
        cnae: "24318/00",
        activityBranch: "2431800",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2136,
        departamentCode: "43",
        description: "Produção de outros tubos de ferro e aço",
        cnae: "24393/00",
        activityBranch: "2439300",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2137,
        departamentCode: "43",
        description: "Produção de alumínio e suas ligas em formas primárias",
        cnae: "24415/01",
        activityBranch: "2441501",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2138,
        departamentCode: "43",
        description: "Produção de laminados de alumínio",
        cnae: "24415/02",
        activityBranch: "2441502",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2139,
        departamentCode: "43",
        description: "Metalurgia dos metais preciosos",
        cnae: "24423/00",
        activityBranch: "2442300",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2140,
        departamentCode: "43",
        description: "Metalurgia do cobre",
        cnae: "24431/00",
        activityBranch: "2443100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2141,
        departamentCode: "43",
        description: "Produção de zinco em formas primárias",
        cnae: "24491/01",
        activityBranch: "2449101",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2142,
        departamentCode: "43",
        description: "Produção de laminados de zinco",
        cnae: "24491/02",
        activityBranch: "2449102",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2143,
        departamentCode: "43",
        description: "Produção de ânodos para galvanoplastia",
        cnae: "24491/03",
        activityBranch: "2449103",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2144,
        departamentCode: "43",
        description: "Metalurgia de outros metais não-ferrosos e suas ligas não especificados anteriormente",
        cnae: "24491/99",
        activityBranch: "2449199",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2145,
        departamentCode: "43",
        description: "Fundição de ferro e aço",
        cnae: "24512/00",
        activityBranch: "2451200",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2146,
        departamentCode: "43",
        description: "Fundição de metais não-ferrosos e suas ligas",
        cnae: "24521/00",
        activityBranch: "2452100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2147,
        departamentCode: "43",
        description: "Fabricação de estruturas metálicas",
        cnae: "25110/00",
        activityBranch: "2511000",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2148,
        departamentCode: "43",
        description: "Fabricação de esquadrias de metal",
        cnae: "25128/00",
        activityBranch: "2512800",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2149,
        departamentCode: "11",
        description: "Fabricação de obras de caldeiraria pesada",
        cnae: "25136/00",
        activityBranch: "2513600",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2150,
        departamentCode: "43",
        description: "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central",
        cnae: "25217/00",
        activityBranch: "2521700",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2151,
        departamentCode: "47",
        description: "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos",
        cnae: "25225/00",
        activityBranch: "2522500",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2152,
        departamentCode: "43",
        description: "Produção de forjados de aço",
        cnae: "25314/01",
        activityBranch: "2531401",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2153,
        departamentCode: "43",
        description: "Produção de forjados de metais não-ferrosos e suas ligas",
        cnae: "25314/02",
        activityBranch: "2531402",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2154,
        departamentCode: "43",
        description: "Produção de artefatos estampados de metal",
        cnae: "25322/01",
        activityBranch: "2532201",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2155,
        departamentCode: "43",
        description: "Metalurgia do pó",
        cnae: "25322/02",
        activityBranch: "2532202",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2156,
        departamentCode: "43",
        description: "Serviços de usinagem, tornearia e solda",
        cnae: "25390/01 ",
        activityBranch: "2539001 ",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2157,
        departamentCode: "43",
        description: "Serviços de tratamento e revestimento em metais",
        cnae: "25390/02 ",
        activityBranch: "2539002 ",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2158,
        departamentCode: "43",
        description: "Fabricação de artigos de cutelaria",
        cnae: "25411/00",
        activityBranch: "2541100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2159,
        departamentCode: "45",
        description: "Fabricação de artigos de serralheria, exceto esquadrias",
        cnae: "25420/00",
        activityBranch: "2542000",
        mcc: {
            code: 5072,
            description: "EQUIP./DISTRIB. DE HARDWARE (HARDWARE EQUIP.SUPPLIES)"
        }
    },
    {
        id: 2160,
        departamentCode: "45",
        description: "Fabricação de ferramentas",
        cnae: "25438/00",
        activityBranch: "2543800",
        mcc: {
            code: 5072,
            description: "EQUIP./DISTRIB. DE HARDWARE (HARDWARE EQUIP.SUPPLIES)"
        }
    },
    {
        id: 2161,
        departamentCode: "49",
        description: "Fabricação de equipamento bélico pesado, exceto veículos militares de combate",
        cnae: "25501/01",
        activityBranch: "2550101",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2162,
        departamentCode: "49",
        description: "Fabricação de armas de fogo, outras armas e munições",
        cnae: "25501/02",
        activityBranch: "2550102",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2163,
        departamentCode: "43",
        description: "Fabricação de embalagens metálicas",
        cnae: "25918/00",
        activityBranch: "2591800",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2164,
        departamentCode: "43",
        description: "Fabricação de produtos de trefilados de metal padronizados",
        cnae: "25926/01",
        activityBranch: "2592601",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2165,
        departamentCode: "43",
        description: "Fabricação de produtos de trefilados de metal, exceto padronizados",
        cnae: "25926/02",
        activityBranch: "2592602",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2166,
        departamentCode: "43",
        description: "Fabricação de artigos de metal para uso doméstico e pessoal",
        cnae: "25934/00",
        activityBranch: "2593400",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2167,
        departamentCode: "43",
        description: "Serviços de confecção de armações metálicas para a construção",
        cnae: "25993/01",
        activityBranch: "2599301",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2168,
        departamentCode: "43",
        description: "Serviço de corte e dobra de metais",
        cnae: "25993/02",
        activityBranch: "2599302",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2169,
        departamentCode: "43",
        description: "Fabricação de outros produtos de metal não especificados anteriormente",
        cnae: "25993/99",
        activityBranch: "2599399",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2170,
        departamentCode: "44",
        description: "Fabricação de componentes eletrônicos",
        cnae: "26108/00",
        activityBranch: "2610800",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2171,
        departamentCode: "40",
        description: "Fabricação de equipamentos de informática",
        cnae: "26213/00",
        activityBranch: "2621300",
        mcc: {
            code: 5045,
            description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES"
        }
    },
    {
        id: 2172,
        departamentCode: "40",
        description: "Fabricação de periféricos para equipamentos de informática",
        cnae: "26221/00",
        activityBranch: "2622100",
        mcc: {
            code: 5045,
            description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES"
        }
    },
    {
        id: 2173,
        departamentCode: "44",
        description: "Fabricação de equipamentos transmissores de comunicação, peças e acessórios",
        cnae: "26311/00",
        activityBranch: "2631100",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2174,
        departamentCode: "44",
        description: "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios",
        cnae: "26329/00",
        activityBranch: "2632900",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2175,
        departamentCode: "44",
        description: "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo",
        cnae: "26400/00",
        activityBranch: "2640000",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2176,
        departamentCode: "44",
        description: "Fabricação de aparelhos e equipamentos de medida, teste e controle",
        cnae: "26515/00",
        activityBranch: "2651500",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2177,
        departamentCode: "48",
        description: "Fabricação de cronômetros e relógios",
        cnae: "26523/00",
        activityBranch: "2652300",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2178,
        departamentCode: "42",
        description: "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
        cnae: "26604/00",
        activityBranch: "2660400",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2179,
        departamentCode: "47",
        description: "Fabricação de equipamentos e instrumentos ópticos, peças e acessórios",
        cnae: "26701/01",
        activityBranch: "2670101",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2180,
        departamentCode: "39",
        description: "Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios",
        cnae: "26701/02",
        activityBranch: "2670102",
        mcc: {
            code: 5044,
            description: "EQUIPAMENTO DE ESCRITORIO, FOTOGRAFICO, FOTOCOPIA E MICROFILME"
        }
    },
    {
        id: 2181,
        departamentCode: "39",
        description: "Fabricação de mídias virgens, magnéticas e ópticas",
        cnae: "26809/00",
        activityBranch: "2680900",
        mcc: {
            code: 5044,
            description: "EQUIPAMENTO DE ESCRITORIO, FOTOGRAFICO, FOTOCOPIA E MICROFILME"
        }
    },
    {
        id: 2182,
        departamentCode: "44",
        description: "Fabricação de geradores de corrente contínua e alternada, peças e acessórios",
        cnae: "27104/01",
        activityBranch: "2710401",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2183,
        departamentCode: "44",
        description: "Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios",
        cnae: "27104/02",
        activityBranch: "2710402",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2184,
        departamentCode: "44",
        description: "Fabricação de motores elétricos, peças e acessórios",
        cnae: "27104/03",
        activityBranch: "2710403",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2185,
        departamentCode: "44",
        description: "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores",
        cnae: "27210/00",
        activityBranch: "2721000",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2186,
        departamentCode: "44",
        description: "Fabricação de baterias e acumuladores para veículos automotores",
        cnae: "27228/01",
        activityBranch: "2722801",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2187,
        departamentCode: "162",
        description: "Recondicionamento de baterias e acumuladores para veículos automotores",
        cnae: "27228/02",
        activityBranch: "2722802",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2188,
        departamentCode: "44",
        description: "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica",
        cnae: "27317/00",
        activityBranch: "2731700",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2189,
        departamentCode: "44",
        description: "Fabricação de material elétrico para instalações em circuito de consumo",
        cnae: "27325/00",
        activityBranch: "2732500",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2190,
        departamentCode: "44",
        description: "Fabricação de fios, cabos e condutores elétricos isolados",
        cnae: "27333/00",
        activityBranch: "2733300",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2191,
        departamentCode: "44",
        description: "Fabricação de lâmpadas",
        cnae: "27406/01",
        activityBranch: "2740601",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2192,
        departamentCode: "44",
        description: "Fabricação de luminárias e outros equipamentos de iluminação",
        cnae: "27406/02",
        activityBranch: "2740602",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2193,
        departamentCode: "41",
        description: "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessórios",
        cnae: "27511/00",
        activityBranch: "2751100",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2194,
        departamentCode: "44",
        description: "Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios",
        cnae: "27597/01",
        activityBranch: "2759701",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2195,
        departamentCode: "41",
        description: "Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios",
        cnae: "27597/99",
        activityBranch: "2759799",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2196,
        departamentCode: "44",
        description: "Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs e isoladores",
        cnae: "27902/01",
        activityBranch: "2790201",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2197,
        departamentCode: "44",
        description: "Fabricação de equipamentos para sinalização e alarme",
        cnae: "27902/02",
        activityBranch: "2790202",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2198,
        departamentCode: "44",
        description: "Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente",
        cnae: "27902/99",
        activityBranch: "2790299",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2199,
        departamentCode: "49",
        description: "Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários",
        cnae: "28119/00",
        activityBranch: "2811900",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2200,
        departamentCode: "47",
        description: "Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas",
        cnae: "28127/00",
        activityBranch: "2812700",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2201,
        departamentCode: "47",
        description: "Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios",
        cnae: "28135/00",
        activityBranch: "2813500",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2202,
        departamentCode: "47",
        description: "Fabricação de compressores para uso industrial, peças e acessórios",
        cnae: "28143/01",
        activityBranch: "2814301",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2203,
        departamentCode: "49",
        description: "Fabricação de compressores para uso não-industrial, peças e acessórios",
        cnae: "28143/02",
        activityBranch: "2814302",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2204,
        departamentCode: "47",
        description: "Fabricação de rolamentos para fins industriais",
        cnae: "28151/01",
        activityBranch: "2815101",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2205,
        departamentCode: "41",
        description: "Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos",
        cnae: "28151/02",
        activityBranch: "2815102",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2206,
        departamentCode: "41",
        description: "Fabricação de fornos industriais, aparelhos e equipamentos não-elétricos para instalações térmicas, peças e acessórios",
        cnae: "28216/01",
        activityBranch: "2821601",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2207,
        departamentCode: "41",
        description: "Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios",
        cnae: "28216/02",
        activityBranch: "2821602",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2208,
        departamentCode: "41",
        description: "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e acessórios",
        cnae: "28224/01",
        activityBranch: "2822401",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2209,
        departamentCode: "41",
        description: "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acessórios",
        cnae: "28224/02",
        activityBranch: "2822402",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2210,
        departamentCode: "41",
        description: "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peças e acessórios",
        cnae: "28232/00",
        activityBranch: "2823200",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2211,
        departamentCode: "41",
        description: "Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial",
        cnae: "28241/01",
        activityBranch: "2824101",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2212,
        departamentCode: "41",
        description: "Fabricação de aparelhos e equipamentos de ar condicionado para uso não-industrial",
        cnae: "28241/02",
        activityBranch: "2824102",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2213,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios",
        cnae: "28259/00",
        activityBranch: "2825900",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2214,
        departamentCode: "39",
        description: "Fabricação de máquinas de escrever, calcular e outros equipamentos não-eletrônicos para escritório, peças e acessórios",
        cnae: "28291/01",
        activityBranch: "2829101",
        mcc: {
            code: 5044,
            description: "EQUIPAMENTO DE ESCRITORIO, FOTOGRAFICO, FOTOCOPIA E MICROFILME"
        }
    },
    {
        id: 2215,
        departamentCode: "41",
        description: "Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e acessórios",
        cnae: "28291/99",
        activityBranch: "2829199",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2216,
        departamentCode: "83",
        description: "Fabricação de tratores agrícolas, peças e acessórios",
        cnae: "28313/00",
        activityBranch: "2831300",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2217,
        departamentCode: "83",
        description: "Fabricação de equipamentos para irrigação agrícola, peças e acessórios",
        cnae: "28321/00",
        activityBranch: "2832100",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2218,
        departamentCode: "83",
        description: "Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para irrigação",
        cnae: "28330/00",
        activityBranch: "2833000",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2219,
        departamentCode: "41",
        description: "Fabricação de máquinas-ferramenta, peças e acessórios",
        cnae: "28402/00",
        activityBranch: "2840200",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2220,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios",
        cnae: "28518/00",
        activityBranch: "2851800",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2221,
        departamentCode: "41",
        description: "Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, exceto na extração de petróleo",
        cnae: "28526/00",
        activityBranch: "2852600",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2222,
        departamentCode: "83",
        description: "Fabricação de tratores, peças e acessórios, exceto agrícolas",
        cnae: "28534/00",
        activityBranch: "2853400",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2223,
        departamentCode: "83",
        description: "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessórios, exceto tratores",
        cnae: "28542/00",
        activityBranch: "2854200",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2224,
        departamentCode: "41",
        description: "Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta",
        cnae: "28615/00",
        activityBranch: "2861500",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2225,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acessórios",
        cnae: "28623/00",
        activityBranch: "2862300",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2226,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios",
        cnae: "28631/00",
        activityBranch: "2863100",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2227,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças e acessórios",
        cnae: "28640/00",
        activityBranch: "2864000",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2228,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, peças e acessórios",
        cnae: "28658/00",
        activityBranch: "2865800",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2229,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios",
        cnae: "28666/00",
        activityBranch: "2866600",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2230,
        departamentCode: "41",
        description: "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente, peças e acessórios",
        cnae: "28691/00",
        activityBranch: "2869100",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2231,
        departamentCode: "76",
        description: "Fabricação de automóveis, camionetas e utilitários",
        cnae: "29107/01",
        activityBranch: "2910701",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2232,
        departamentCode: "36",
        description: "Fabricação de chassis com motor para automóveis, camionetas e utilitários",
        cnae: "29107/02",
        activityBranch: "2910702",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2233,
        departamentCode: "36",
        description: "Fabricação de motores para automóveis, camionetas e utilitários",
        cnae: "29107/03",
        activityBranch: "2910703",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2234,
        departamentCode: "76",
        description: "Fabricação de caminhões e ônibus",
        cnae: "29204/01",
        activityBranch: "2920401",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2235,
        departamentCode: "36",
        description: "Fabricação de motores para caminhões e ônibus",
        cnae: "29204/02",
        activityBranch: "2920402",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2236,
        departamentCode: "83",
        description: "Fabricação de cabines, carrocerias e reboques para caminhões",
        cnae: "29301/01",
        activityBranch: "2930101",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2237,
        departamentCode: "36",
        description: "Fabricação de carrocerias para ônibus",
        cnae: "29301/02",
        activityBranch: "2930102",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2238,
        departamentCode: "83",
        description: "Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ônibus",
        cnae: "29301/03",
        activityBranch: "2930103",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2239,
        departamentCode: "36",
        description: "Fabricação de peças e acessórios para o sistema motor de veículos automotores",
        cnae: "29417/00",
        activityBranch: "2941700",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2240,
        departamentCode: "36",
        description: "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores",
        cnae: "29425/00",
        activityBranch: "2942500",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2241,
        departamentCode: "36",
        description: "Fabricação de peças e acessórios para o sistema de freios de veículos automotores",
        cnae: "29433/00",
        activityBranch: "2943300",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2242,
        departamentCode: "36",
        description: "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores",
        cnae: "29441/00",
        activityBranch: "2944100",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2243,
        departamentCode: "36",
        description: "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias",
        cnae: "29450/00",
        activityBranch: "2945000",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2244,
        departamentCode: "36",
        description: "Fabricação de bancos e estofados para veículos automotores",
        cnae: "29492/01",
        activityBranch: "2949201",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2245,
        departamentCode: "36",
        description: "Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente",
        cnae: "29492/99",
        activityBranch: "2949299",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2246,
        departamentCode: "162",
        description: "Recondicionamento e recuperação de motores para veículos automotores",
        cnae: "29506/00",
        activityBranch: "2950600",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2247,
        departamentCode: "49",
        description: "Construção de embarcações de grande porte",
        cnae: "30113/01",
        activityBranch: "3011301",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2248,
        departamentCode: "49",
        description: "Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte",
        cnae: "30113/02",
        activityBranch: "3011302",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2249,
        departamentCode: "49",
        description: "Construção de embarcações para esporte e lazer",
        cnae: "30121/00",
        activityBranch: "3012100",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2250,
        departamentCode: "83",
        description: "Fabricação de locomotivas, vagões e outros materiais rodantes",
        cnae: "30318/00",
        activityBranch: "3031800",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2251,
        departamentCode: "83",
        description: "Fabricação de peças e acessórios para veículos ferroviários",
        cnae: "30326/00",
        activityBranch: "3032600",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2252,
        departamentCode: "83",
        description: "Fabricação de aeronaves",
        cnae: "30415/00",
        activityBranch: "3041500",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2253,
        departamentCode: "83",
        description: "Fabricação de turbinas, motores e outros componentes e peças para aeronaves",
        cnae: "30423/00",
        activityBranch: "3042300",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2254,
        departamentCode: "83",
        description: "Fabricação de veículos militares de combate",
        cnae: "30504/00",
        activityBranch: "3050400",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2255,
        departamentCode: "49",
        description: "Fabricação de motocicletas",
        cnae: "30911/01",
        activityBranch: "3091101",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2256,
        departamentCode: "47",
        description: "Fabricação de peças e acessórios para motocicletas",
        cnae: "30911/02",
        activityBranch: "3091102",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2257,
        departamentCode: "49",
        description: "Fabricação de bicicletas e triciclos não-motorizados, peças e acessórios",
        cnae: "30920/00",
        activityBranch: "3092000",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2258,
        departamentCode: "83",
        description: "Fabricação de equipamentos de transporte não especificados anteriormente",
        cnae: "30997/00",
        activityBranch: "3099700",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2259,
        departamentCode: "37",
        description: "Fabricação de móveis com predominância de madeira",
        cnae: "31012/00",
        activityBranch: "3101200",
        mcc: {
            code: 5021,
            description: "MOVEIS PARA ESCRITORIOS (COMMERCIAL FURNITURE)"
        }
    },
    {
        id: 2260,
        departamentCode: "37",
        description: "Fabricação de móveis com predominância de metal",
        cnae: "31021/00",
        activityBranch: "3102100",
        mcc: {
            code: 5021,
            description: "MOVEIS PARA ESCRITORIOS (COMMERCIAL FURNITURE)"
        }
    },
    {
        id: 2261,
        departamentCode: "37",
        description: "Fabricação de móveis de outros materiais, exceto madeira e metal",
        cnae: "31039/00",
        activityBranch: "3103900",
        mcc: {
            code: 5021,
            description: "MOVEIS PARA ESCRITORIOS (COMMERCIAL FURNITURE)"
        }
    },
    {
        id: 2262,
        departamentCode: "88",
        description: "Fabricação de colchões",
        cnae: "31047/00",
        activityBranch: "3104700",
        mcc: {
            code: 5712,
            description: "LOJA DE MOVEIS"
        }
    },
    {
        id: 2263,
        departamentCode: "48",
        description: "Lapidação de gemas",
        cnae: "32116/01",
        activityBranch: "3211601",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2264,
        departamentCode: "48",
        description: "Fabricação de artefatos de joalheria e ourivesaria",
        cnae: "32116/02",
        activityBranch: "3211602",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2265,
        departamentCode: "48",
        description: "Cunhagem de moedas e medalhas",
        cnae: "32116/03",
        activityBranch: "3211603",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2266,
        departamentCode: "48",
        description: "Fabricação de bijuterias e artefatos semelhantes",
        cnae: "32124/00",
        activityBranch: "3212400",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2267,
        departamentCode: "49",
        description: "Fabricação de instrumentos musicais, peças e acessórios",
        cnae: "32205/00",
        activityBranch: "3220500",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2268,
        departamentCode: "60",
        description: "Fabricação de artefatos para pesca e esporte",
        cnae: "32302/00",
        activityBranch: "3230200",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2269,
        departamentCode: "49",
        description: "Fabricação de jogos eletrônicos",
        cnae: "32400/01",
        activityBranch: "3240001",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2270,
        departamentCode: "49",
        description: "Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação",
        cnae: "32400/02",
        activityBranch: "3240002",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2271,
        departamentCode: "49",
        description: "Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação",
        cnae: "32400/03",
        activityBranch: "3240003",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2272,
        departamentCode: "49",
        description: "Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente",
        cnae: "32400/99",
        activityBranch: "3240099",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2273,
        departamentCode: "42",
        description: "Fabricação de instrumentos não-eletrônicos e utensílios para uso médico, cirúrgico, odontológico e de laboratório",
        cnae: "32507/01",
        activityBranch: "3250701",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2274,
        departamentCode: "42",
        description: "Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório",
        cnae: "32507/02",
        activityBranch: "3250702",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2275,
        departamentCode: "42",
        description: "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda",
        cnae: "32507/03",
        activityBranch: "3250703",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2276,
        departamentCode: "42",
        description: "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral, exceto sob encomenda",
        cnae: "32507/04",
        activityBranch: "3250704",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2277,
        departamentCode: "42",
        description: "Fabricação de materiais para medicina e odontologia",
        cnae: "32507/05",
        activityBranch: "3250705",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2278,
        departamentCode: "187",
        description: "Serviços de prótese dentária",
        cnae: "32507/06",
        activityBranch: "3250706",
        mcc: {
            code: 8021,
            description: "DENTISTAS E ORTODONTISTAS (CLINICAS E CONSULTORIOS)"
        }
    },
    {
        id: 2279,
        departamentCode: "42",
        description: "Fabricação de artigos ópticos",
        cnae: "32507/07",
        activityBranch: "3250707",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2280,
        departamentCode: "52",
        description: "Fabricação de artefatos de tecido não tecido para uso odonto-médico-hospitalar",
        cnae: "32507/08",
        activityBranch: "3250708",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 2281,
        departamentCode: "193",
        description: "Serviço de laboratório óptico",
        cnae: "32507/09",
        activityBranch: "3250709",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2282,
        departamentCode: "60",
        description: "Fabricação de escovas, pincéis e vassouras",
        cnae: "32914/00",
        activityBranch: "3291400",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2283,
        departamentCode: "53",
        description: "Fabricação de roupas de proteção e segurança e resistentes a fogo",
        cnae: "32922/01",
        activityBranch: "3292201",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2284,
        departamentCode: "60",
        description: "Fabricação de equipamentos e acessórios para segurança pessoal e profissional",
        cnae: "32922/02",
        activityBranch: "3292202",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2285,
        departamentCode: "60",
        description: "Fabricação de guarda-chuvas e similares",
        cnae: "32990/01",
        activityBranch: "3299001",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2286,
        departamentCode: "50",
        description: "Fabricação de canetas, lápis e outros artigos para escritório",
        cnae: "32990/02",
        activityBranch: "3299002",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2287,
        departamentCode: "13",
        description: "Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos",
        cnae: "32990/03",
        activityBranch: "3299003",
        mcc: {
            code: 2791,
            description: "TIPOGRAFIA, FABRICACAO DE CHAPAS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2288,
        departamentCode: "44",
        description: "Fabricação de painéis e letreiros luminosos",
        cnae: "32990/04",
        activityBranch: "3299004",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2289,
        departamentCode: "52",
        description: "Fabricação de aviamentos para costura",
        cnae: "32990/05",
        activityBranch: "3299005",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 2290,
        departamentCode: "60",
        description: "Fabricação de velas, inclusive decorativas",
        cnae: "32990/06",
        activityBranch: "3299006",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2291,
        departamentCode: "60",
        description: "Fabricação de produtos diversos não especificados anteriormente",
        cnae: "32990/99",
        activityBranch: "3299099",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2292,
        departamentCode: "169",
        description: "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos",
        cnae: "33112/00",
        activityBranch: "3311200",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2293,
        departamentCode: "169",
        description: "Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle",
        cnae: "33121/02",
        activityBranch: "3312102",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2294,
        departamentCode: "169",
        description: "Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
        cnae: "33121/03",
        activityBranch: "3312103",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2295,
        departamentCode: "169",
        description: "Manutenção e reparação de equipamentos e instrumentos ópticos",
        cnae: "33121/04",
        activityBranch: "3312104",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2296,
        departamentCode: "169",
        description: "Manutenção e reparação de geradores, transformadores e motores elétricos",
        cnae: "33139/01",
        activityBranch: "3313901",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2297,
        departamentCode: "169",
        description: "Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos",
        cnae: "33139/02",
        activityBranch: "3313902",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2298,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente",
        cnae: "33139/99",
        activityBranch: "3313999",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2299,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas motrizes não-elétricas",
        cnae: "33147/01",
        activityBranch: "3314701",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2300,
        departamentCode: "169",
        description: "Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas",
        cnae: "33147/02",
        activityBranch: "3314702",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2301,
        departamentCode: "169",
        description: "Manutenção e reparação de válvulas industriais",
        cnae: "33147/03",
        activityBranch: "3314703",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2302,
        departamentCode: "169",
        description: "Manutenção e reparação de compressores",
        cnae: "33147/04",
        activityBranch: "3314704",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2303,
        departamentCode: "169",
        description: "Manutenção e reparação de equipamentos de transmissão para fins industriais",
        cnae: "33147/05",
        activityBranch: "3314705",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2304,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas",
        cnae: "33147/06",
        activityBranch: "3314706",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2305,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial",
        cnae: "33147/07",
        activityBranch: "3314707",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2306,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas",
        cnae: "33147/08",
        activityBranch: "3314708",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2307,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não-eletrônicos para escritório",
        cnae: "33147/09",
        activityBranch: "3314709",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2308,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente",
        cnae: "33147/10",
        activityBranch: "3314710",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2309,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária",
        cnae: "33147/11",
        activityBranch: "3314711",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2310,
        departamentCode: "169",
        description: "Manutenção e reparação de tratores agrícolas",
        cnae: "33147/12",
        activityBranch: "3314712",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2311,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas-ferramenta",
        cnae: "33147/13",
        activityBranch: "3314713",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2312,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo",
        cnae: "33147/14",
        activityBranch: "3314714",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2313,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo",
        cnae: "33147/15",
        activityBranch: "3314715",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2314,
        departamentCode: "169",
        description: "Manutenção e reparação de tratores, exceto agrícolas",
        cnae: "33147/16",
        activityBranch: "3314716",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2315,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores",
        cnae: "33147/17",
        activityBranch: "3314717",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2316,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta",
        cnae: "33147/18",
        activityBranch: "3314718",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2317,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo",
        cnae: "33147/19",
        activityBranch: "3314719",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2318,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados",
        cnae: "33147/20",
        activityBranch: "3314720",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2319,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos",
        cnae: "33147/21",
        activityBranch: "3314721",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2320,
        departamentCode: "169",
        description: "Manutenção e reparação de máquinas e aparelhos para a indústria do plástico",
        cnae: "33147/22",
        activityBranch: "3314722",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2321,
        departamentCode: "169",
        description: "Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente",
        cnae: "33147/99",
        activityBranch: "3314799",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2322,
        departamentCode: "169",
        description: "Manutenção e reparação de veículos ferroviários",
        cnae: "33155/00",
        activityBranch: "3315500",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2323,
        departamentCode: "169",
        description: "Manutenção e reparação de aeronaves, exceto a manutenção na pista",
        cnae: "33163/01",
        activityBranch: "3316301",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2324,
        departamentCode: "169",
        description: "Manutenção de aeronaves na pista",
        cnae: "33163/02",
        activityBranch: "3316302",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2325,
        departamentCode: "25",
        description: "Manutenção e reparação de embarcações e estruturas flutuantes",
        cnae: "33171/01",
        activityBranch: "3317101",
        mcc: {
            code: 4468,
            description: "MARINAS, SERVICOS E FORNECEDORES"
        }
    },
    {
        id: 2326,
        departamentCode: "25",
        description: "Manutenção e reparação de embarcações para esporte e lazer",
        cnae: "33171/02",
        activityBranch: "3317102",
        mcc: {
            code: 4468,
            description: "MARINAS, SERVICOS E FORNECEDORES"
        }
    },
    {
        id: 2327,
        departamentCode: "169",
        description: "Manutenção e reparação de equipamentos e produtos não especificados anteriormente",
        cnae: "33198/00",
        activityBranch: "3319800",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2328,
        departamentCode: "157",
        description: "Instalação de máquinas e equipamentos industriais",
        cnae: "33210/00",
        activityBranch: "3321000",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2329,
        departamentCode: "143",
        description: "Serviços de montagem de móveis de qualquer material",
        cnae: "33295/01",
        activityBranch: "3329501",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2330,
        departamentCode: "143",
        description: "Instalação de outros equipamentos não especificados anteriormente",
        cnae: "33295/99",
        activityBranch: "3329599",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2331,
        departamentCode: "35",
        description: "Geração de energia elétrica",
        cnae: "35115/01",
        activityBranch: "3511501",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2332,
        departamentCode: "35",
        description: "Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica",
        cnae: "35115/02",
        activityBranch: "3511502",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2333,
        departamentCode: "35",
        description: "Transmissão de energia elétrica",
        cnae: "35123/00",
        activityBranch: "3512300",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2334,
        departamentCode: "35",
        description: "Comércio atacadista de energia elétrica",
        cnae: "35131/00",
        activityBranch: "3513100",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2335,
        departamentCode: "35",
        description: "Distribuição de energia elétrica",
        cnae: "35140/00",
        activityBranch: "3514000",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2336,
        departamentCode: "35",
        description: "Produção de gás; processamento de gás natural",
        cnae: "35204/01",
        activityBranch: "3520401",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2337,
        departamentCode: "35",
        description: "Distribuição de combustíveis gasosos por redes urbanas",
        cnae: "35204/02",
        activityBranch: "3520402",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2338,
        departamentCode: "5",
        description: "Produção e distribuição de vapor, água quente e ar condicionado",
        cnae: "35301/00",
        activityBranch: "3530100",
        mcc: {
            code: 1711,
            description: "PREST. DE SERV. PARA AR COND., ENCANAMENTO E AQUEC."
        }
    },
    {
        id: 2339,
        departamentCode: "35",
        description: "Captação, tratamento e distribuição de água",
        cnae: "36006/01",
        activityBranch: "3600601",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2340,
        departamentCode: "35",
        description: "Distribuição de água por caminhões",
        cnae: "36006/02",
        activityBranch: "3600602",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2341,
        departamentCode: "35",
        description: "Gestão de redes de esgoto",
        cnae: "37011/00",
        activityBranch: "3701100",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2342,
        departamentCode: "35",
        description: "Atividades relacionadas a esgoto, exceto a gestão de redes",
        cnae: "37029/00",
        activityBranch: "3702900",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2343,
        departamentCode: "35",
        description: "Coleta de resíduos não-perigosos",
        cnae: "38114/00",
        activityBranch: "3811400",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2344,
        departamentCode: "35",
        description: "Coleta de resíduos perigosos",
        cnae: "38122/00",
        activityBranch: "3812200",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2345,
        departamentCode: "35",
        description: "Tratamento e disposição de resíduos não-perigosos",
        cnae: "38211/00",
        activityBranch: "3821100",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2346,
        departamentCode: "35",
        description: "Tratamento e disposição de resíduos perigosos",
        cnae: "38220/00",
        activityBranch: "3822000",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2347,
        departamentCode: "104",
        description: "Recuperação de sucatas de alumínio",
        cnae: "38319/01",
        activityBranch: "3831901",
        mcc: {
            code: 5935,
            description: "PATIOS DE DEMOLICAO E SALVAMENTO"
        }
    },
    {
        id: 2348,
        departamentCode: "104",
        description: "Recuperação de materiais metálicos, exceto alumínio",
        cnae: "38319/99",
        activityBranch: "3831999",
        mcc: {
            code: 5935,
            description: "PATIOS DE DEMOLICAO E SALVAMENTO"
        }
    },
    {
        id: 2349,
        departamentCode: "157",
        description: "Recuperação de materiais plásticos",
        cnae: "38327/00",
        activityBranch: "3832700",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2350,
        departamentCode: "157",
        description: "Usinas de compostagem",
        cnae: "38394/01",
        activityBranch: "3839401",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2351,
        departamentCode: "157",
        description: "Recuperação de materiais não especificados anteriormente",
        cnae: "38394/99",
        activityBranch: "3839499",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2352,
        departamentCode: "35",
        description: "Descontaminação e outros serviços de gestão de resíduos",
        cnae: "39005/00",
        activityBranch: "3900500",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2353,
        departamentCode: "4",
        description: "Incorporação de empreendimentos imobiliários",
        cnae: "41107/00",
        activityBranch: "4110700",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2354,
        departamentCode: "4",
        description: "Construção de edifícios",
        cnae: "41204/00",
        activityBranch: "4120400",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2355,
        departamentCode: "10",
        description: "Construção de rodovias e ferrovias",
        cnae: "42111/01",
        activityBranch: "4211101",
        mcc: {
            code: 1771,
            description: "EMPREITEIO PARA SERVICOS ESPECIALIZADO"
        }
    },
    {
        id: 2356,
        departamentCode: "4",
        description: "Pintura para sinalização em pistas rodoviárias e aeroportos",
        cnae: "42111/02",
        activityBranch: "4211102",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2357,
        departamentCode: "116",
        description: "Construção de obras-de-arte especiais",
        cnae: "42120/00",
        activityBranch: "4212000",
        mcc: {
            code: 5971,
            description: "GALERIA DE ARTE (ART DEALERS & GALLERIES)"
        }
    },
    {
        id: 2358,
        departamentCode: "10",
        description: "Obras de urbanização - ruas, praças e calçadas",
        cnae: "42138/00",
        activityBranch: "4213800",
        mcc: {
            code: 1771,
            description: "EMPREITEIO PARA SERVICOS ESPECIALIZADO"
        }
    },
    {
        id: 2359,
        departamentCode: "208",
        description: "Construção de barragens e represas para geração de energia elétrica",
        cnae: "42219/01",
        activityBranch: "4221901",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2360,
        departamentCode: "208",
        description: "Construção de estações e redes de distribuição de energia elétrica",
        cnae: "42219/02",
        activityBranch: "4221902",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2361,
        departamentCode: "35",
        description: "Manutenção de redes de distribuição de energia elétrica",
        cnae: "42219/03",
        activityBranch: "4221903",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2362,
        departamentCode: "208",
        description: "Construção de estações e redes de telecomunicações",
        cnae: "42219/04",
        activityBranch: "4221904",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2363,
        departamentCode: "6",
        description: "Manutenção de estações e redes de telecomunicações",
        cnae: "42219/05",
        activityBranch: "4221905",
        mcc: {
            code: 1731,
            description: "ELETRICISTAS E SERVICOS ELETRICOS"
        }
    },
    {
        id: 2364,
        departamentCode: "4",
        description: "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação",
        cnae: "42227/01",
        activityBranch: "4222701",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2365,
        departamentCode: "4",
        description: "Obras de irrigação",
        cnae: "42227/02",
        activityBranch: "4222702",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2366,
        departamentCode: "4",
        description: "Construção de redes de transportes por dutos, exceto para água e esgoto",
        cnae: "42235/00",
        activityBranch: "4223500",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2367,
        departamentCode: "4",
        description: "Obras portuárias, marítimas e fluviais",
        cnae: "42910/00",
        activityBranch: "4291000",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2368,
        departamentCode: "208",
        description: "Montagem de estruturas metálicas",
        cnae: "42928/01",
        activityBranch: "4292801",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2369,
        departamentCode: "4",
        description: "Obras de montagem industrial",
        cnae: "42928/02",
        activityBranch: "4292802",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2370,
        departamentCode: "11",
        description: "Construção de instalações esportivas e recreativas",
        cnae: "42995/01",
        activityBranch: "4299501",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2371,
        departamentCode: "11",
        description: "Outras obras de engenharia civil não especificadas anteriormente",
        cnae: "42995/99",
        activityBranch: "4299599",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2372,
        departamentCode: "4",
        description: "Demolição de edifícios e outras estruturas",
        cnae: "43118/01",
        activityBranch: "4311801",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2373,
        departamentCode: "10",
        description: "Preparação de canteiro e limpeza de terreno",
        cnae: "43118/02",
        activityBranch: "4311802",
        mcc: {
            code: 1771,
            description: "EMPREITEIO PARA SERVICOS ESPECIALIZADO"
        }
    },
    {
        id: 2374,
        departamentCode: "208",
        description: "Perfurações e sondagens",
        cnae: "43126/00",
        activityBranch: "4312600",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2375,
        departamentCode: "208",
        description: "Obras de terraplenagem",
        cnae: "43134/00",
        activityBranch: "4313400",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2376,
        departamentCode: "208",
        description: "Serviços de preparação do terreno não especificados anteriormente",
        cnae: "43193/00",
        activityBranch: "4319300",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2377,
        departamentCode: "6",
        description: "Instalação e manutenção elétrica",
        cnae: "43215/00",
        activityBranch: "4321500",
        mcc: {
            code: 1731,
            description: "ELETRICISTAS E SERVICOS ELETRICOS"
        }
    },
    {
        id: 2378,
        departamentCode: "5",
        description: "Instalações hidráulicas, sanitárias e de gás",
        cnae: "43223/01",
        activityBranch: "4322301",
        mcc: {
            code: 1711,
            description: "PREST. DE SERV. PARA AR COND., ENCANAMENTO E AQUEC."
        }
    },
    {
        id: 2379,
        departamentCode: "5",
        description: "Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração",
        cnae: "43223/02",
        activityBranch: "4322302",
        mcc: {
            code: 1711,
            description: "PREST. DE SERV. PARA AR COND., ENCANAMENTO E AQUEC."
        }
    },
    {
        id: 2380,
        departamentCode: "5",
        description: "Instalações de sistema de prevenção contra incêndio",
        cnae: "43223/03",
        activityBranch: "4322303",
        mcc: {
            code: 1711,
            description: "PREST. DE SERV. PARA AR COND., ENCANAMENTO E AQUEC."
        }
    },
    {
        id: 2381,
        departamentCode: "143",
        description: "Instalação de painéis publicitários",
        cnae: "43291/01",
        activityBranch: "4329101",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2382,
        departamentCode: "208",
        description: "Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre",
        cnae: "43291/02",
        activityBranch: "4329102",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2383,
        departamentCode: "169",
        description: "Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes",
        cnae: "43291/03",
        activityBranch: "4329103",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2384,
        departamentCode: "6",
        description: "Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos",
        cnae: "43291/04",
        activityBranch: "4329104",
        mcc: {
            code: 1731,
            description: "ELETRICISTAS E SERVICOS ELETRICOS"
        }
    },
    {
        id: 2385,
        departamentCode: "7",
        description: "Tratamentos térmicos, acústicos ou de vibração",
        cnae: "43291/05",
        activityBranch: "4329105",
        mcc: {
            code: 1740,
            description: "PEDREIROS E SERVICOS DE INSTALACAO"
        }
    },
    {
        id: 2386,
        departamentCode: "11",
        description: "Outras obras de instalações em construções não especificadas anteriormente",
        cnae: "43291/99",
        activityBranch: "4329199",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2387,
        departamentCode: "11",
        description: "Impermeabilização em obras de engenharia civil",
        cnae: "43304/01",
        activityBranch: "4330401",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2388,
        departamentCode: "8",
        description: "Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material",
        cnae: "43304/02",
        activityBranch: "4330402",
        mcc: {
            code: 1750,
            description: "MARCENEIROS E SERVICOS DE CARPINTARIA"
        }
    },
    {
        id: 2389,
        departamentCode: "7",
        description: "Obras de acabamento em gesso e estuque",
        cnae: "43304/03",
        activityBranch: "4330403",
        mcc: {
            code: 1740,
            description: "PEDREIROS E SERVICOS DE INSTALACAO"
        }
    },
    {
        id: 2390,
        departamentCode: "9",
        description: "Serviços de pintura de edifícios em geral",
        cnae: "43304/04",
        activityBranch: "4330404",
        mcc: {
            code: 1761,
            description: "METALURGICOS"
        }
    },
    {
        id: 2391,
        departamentCode: "7",
        description: "Aplicação de revestimentos e de resinas em interiores e exteriores",
        cnae: "43304/05",
        activityBranch: "4330405",
        mcc: {
            code: 1740,
            description: "PEDREIROS E SERVICOS DE INSTALACAO"
        }
    },
    {
        id: 2392,
        departamentCode: "11",
        description: "Outras obras de acabamento da construção",
        cnae: "43304/99",
        activityBranch: "4330499",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2393,
        departamentCode: "10",
        description: "Obras de fundações",
        cnae: "43916/00",
        activityBranch: "4391600",
        mcc: {
            code: 1771,
            description: "EMPREITEIO PARA SERVICOS ESPECIALIZADO"
        }
    },
    {
        id: 2394,
        departamentCode: "4",
        description: "Administração de obras",
        cnae: "43991/01",
        activityBranch: "4399101",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2395,
        departamentCode: "11",
        description: "Montagem e desmontagem de andaimes e outras estruturas temporárias",
        cnae: "43991/02",
        activityBranch: "4399102",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2396,
        departamentCode: "7",
        description: "Obras de alvenaria",
        cnae: "43991/03",
        activityBranch: "4399103",
        mcc: {
            code: 1740,
            description: "PEDREIROS E SERVICOS DE INSTALACAO"
        }
    },
    {
        id: 2397,
        departamentCode: "143",
        description: "Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras",
        cnae: "43991/04",
        activityBranch: "4399104",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2398,
        departamentCode: "11",
        description: "Perfuração e construção de poços de água",
        cnae: "43991/05",
        activityBranch: "4399105",
        mcc: {
            code: 1799,
            description: "DEMAIS SVS DE REFORMA E CONSTRUCAO NAO-CLASSIFICADOS"
        }
    },
    {
        id: 2399,
        departamentCode: "4",
        description: "Serviços especializados para construção não especificados anteriormente",
        cnae: "43991/99",
        activityBranch: "4399199",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 2400,
        departamentCode: "76",
        description: "Comércio a varejo de automóveis, camionetas e utilitários novos",
        cnae: "45111/01",
        activityBranch: "4511101",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2401,
        departamentCode: "77",
        description: "Comércio a varejo de automóveis, camionetas e utilitários usados",
        cnae: "45111/02",
        activityBranch: "4511102",
        mcc: {
            code: 5521,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (APENAS USADOS)"
        }
    },
    {
        id: 2402,
        departamentCode: "76",
        description: "Comércio por atacado de automóveis, camionetas e utilitários novos e usados",
        cnae: "45111/03",
        activityBranch: "4511103",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2403,
        departamentCode: "76",
        description: "Comércio por atacado de caminhões novos e usados",
        cnae: "45111/04",
        activityBranch: "4511104",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2404,
        departamentCode: "76",
        description: "Comércio por atacado de reboques e semi-reboques novos e usados",
        cnae: "45111/05",
        activityBranch: "4511105",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2405,
        departamentCode: "76",
        description: "Comércio por atacado de ônibus e microônibus novos e usados",
        cnae: "45111/06",
        activityBranch: "4511106",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2406,
        departamentCode: "76",
        description: "Representantes comerciais e agentes do comércio de veículos automotores",
        cnae: "45129/01",
        activityBranch: "4512901",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2407,
        departamentCode: "76",
        description: "Comércio sob consignação de veículos automotores",
        cnae: "45129/02",
        activityBranch: "4512902",
        mcc: {
            code: 5511,
            description: "REVENDEDORES DE AUTOMOVEIS E CAMINHOES (NOVOS E USADOS). CONSERTOS, PECAS E LEASING"
        }
    },
    {
        id: 2408,
        departamentCode: "162",
        description: "Serviços de manutenção e reparação mecânica de veículos automotores",
        cnae: "45200/01",
        activityBranch: "4520001",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2409,
        departamentCode: "160",
        description: "Serviços de lanternagem ou funilaria e pintura de veículos automotores",
        cnae: "45200/02",
        activityBranch: "4520002",
        mcc: {
            code: 7531,
            description: "OFICINAS DE REPARACAO AUTOMOTIVA"
        }
    },
    {
        id: 2410,
        departamentCode: "162",
        description: "Serviços de manutenção e reparação elétrica de veículos automotores",
        cnae: "45200/03",
        activityBranch: "4520003",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2411,
        departamentCode: "162",
        description: "Serviços de alinhamento e balanceamento de veículos automotores",
        cnae: "45200/04",
        activityBranch: "4520004",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2412,
        departamentCode: "163",
        description: "Serviços de lavagem, lubrificação e polimento de veículos automotores",
        cnae: "45200/05",
        activityBranch: "4520005",
        mcc: {
            code: 7542,
            description: "LAVA JATO"
        }
    },
    {
        id: 2413,
        departamentCode: "161",
        description: "Serviços de borracharia para veículos automotores",
        cnae: "45200/06",
        activityBranch: "4520006",
        mcc: {
            code: 7534,
            description: "REFORMA DE PNEUS E OFICINAS"
        }
    },
    {
        id: 2414,
        departamentCode: "79",
        description: "Serviços de instalação, manutenção e reparação de acessórios para veículos automotores",
        cnae: "45200/07",
        activityBranch: "4520007",
        mcc: {
            code: 5533,
            description: "LOJA DE PECAS E ACESSORIOS DE CARROS"
        }
    },
    {
        id: 2415,
        departamentCode: "79",
        description: "Serviços de capotaria",
        cnae: "45200/08",
        activityBranch: "4520008",
        mcc: {
            code: 5533,
            description: "LOJA DE PECAS E ACESSORIOS DE CARROS"
        }
    },
    {
        id: 2416,
        departamentCode: "36",
        description: "Comércio por atacado de peças e acessórios novos para veículos automotores",
        cnae: "45307/01",
        activityBranch: "4530701",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2417,
        departamentCode: "36",
        description: "Comércio por atacado de pneumáticos e câmaras-de-ar",
        cnae: "45307/02",
        activityBranch: "4530702",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2418,
        departamentCode: "79",
        description: "Comércio a varejo de peças e acessórios novos para veículos automotores",
        cnae: "45307/03",
        activityBranch: "4530703",
        mcc: {
            code: 5533,
            description: "LOJA DE PECAS E ACESSORIOS DE CARROS"
        }
    },
    {
        id: 2419,
        departamentCode: "79",
        description: "Comércio a varejo de peças e acessórios usados para veículos automotores",
        cnae: "45307/04",
        activityBranch: "4530704",
        mcc: {
            code: 5533,
            description: "LOJA DE PECAS E ACESSORIOS DE CARROS"
        }
    },
    {
        id: 2420,
        departamentCode: "78",
        description: "Comércio a varejo de pneumáticos e câmaras-de-ar",
        cnae: "45307/05",
        activityBranch: "4530705",
        mcc: {
            code: 5532,
            description: "LOJA DE PNEUS"
        }
    },
    {
        id: 2421,
        departamentCode: "36",
        description: "Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores",
        cnae: "45307/06",
        activityBranch: "4530706",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2422,
        departamentCode: "82",
        description: "Comércio por atacado de motocicletas e motonetas",
        cnae: "45412/01",
        activityBranch: "4541201",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2423,
        departamentCode: "36",
        description: "Comércio por atacado de peças e acessórios para motocicletas e motonetas",
        cnae: "45412/02",
        activityBranch: "4541202",
        mcc: {
            code: 5013,
            description: "SUPRIMENTOS PARA VEICULOS E PECAS NOVAS"
        }
    },
    {
        id: 2424,
        departamentCode: "82",
        description: "Comércio a varejo de motocicletas e motonetas novas",
        cnae: "45412/03",
        activityBranch: "4541203",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2425,
        departamentCode: "82",
        description: "Comércio a varejo de motocicletas e motonetas usadas",
        cnae: "45412/04",
        activityBranch: "4541204",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2426,
        departamentCode: "82",
        description: "Comércio a varejo de peças e acessórios para motocicletas e motonetas",
        cnae: "45412/05",
        activityBranch: "4541205",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2427,
        departamentCode: "82",
        description: "Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios",
        cnae: "45421/01",
        activityBranch: "4542101",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2428,
        departamentCode: "82",
        description: "Comércio sob consignação de motocicletas e motonetas",
        cnae: "45421/02",
        activityBranch: "4542102",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 2429,
        departamentCode: "162",
        description: "Manutenção e reparação de motocicletas e motonetas",
        cnae: "45439/00",
        activityBranch: "4543900",
        mcc: {
            code: 7538,
            description: "SERVICOS PARA CARROS (NAO CONCESIONARIA)"
        }
    },
    {
        id: 2430,
        departamentCode: "2",
        description: "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos",
        cnae: "46117/00",
        activityBranch: "4611700",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2431,
        departamentCode: "55",
        description: "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos",
        cnae: "46125/00",
        activityBranch: "4612500",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2432,
        departamentCode: "38",
        description: "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens",
        cnae: "46133/00",
        activityBranch: "4613300",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2433,
        departamentCode: "83",
        description: "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves",
        cnae: "46141/00",
        activityBranch: "4614100",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2434,
        departamentCode: "49",
        description: "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico",
        cnae: "46150/00",
        activityBranch: "4615000",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2435,
        departamentCode: "87",
        description: "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem",
        cnae: "46168/00",
        activityBranch: "4616800",
        mcc: {
            code: 5699,
            description: "SERVICOS GERIAS PARA VESTIMENTA"
        }
    },
    {
        id: 2436,
        departamentCode: "60",
        description: "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo",
        cnae: "46176/00",
        activityBranch: "4617600",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2437,
        departamentCode: "51",
        description: "Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria",
        cnae: "46184/01",
        activityBranch: "4618401",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2438,
        departamentCode: "42",
        description: "Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalares",
        cnae: "46184/02",
        activityBranch: "4618402",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2439,
        departamentCode: "57",
        description: "Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações",
        cnae: "46184/03",
        activityBranch: "4618403",
        mcc: {
            code: 5192,
            description: "ATAC. E DISTRIB. DE LIVROS, PERIODICOS E JORNAIS"
        }
    },
    {
        id: 2440,
        departamentCode: "69",
        description: "Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente",
        cnae: "46184/99",
        activityBranch: "4618499",
        mcc: {
            code: 5399,
            description: "LOJA MERCADORIAS GERAIS"
        }
    },
    {
        id: 2441,
        departamentCode: "65",
        description: "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado",
        cnae: "46192/00",
        activityBranch: "4619200",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2442,
        departamentCode: "60",
        description: "Comércio atacadista de café em grão",
        cnae: "46214/00",
        activityBranch: "4621400",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2443,
        departamentCode: "60",
        description: "Comércio atacadista de soja",
        cnae: "46222/00",
        activityBranch: "4622200",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2444,
        departamentCode: "49",
        description: "Comércio atacadista de animais vivos",
        cnae: "46231/01",
        activityBranch: "4623101",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2445,
        departamentCode: "60",
        description: "Comércio atacadista de couros, lãs, peles e outros subprodutos não-comestíveis de origem animal",
        cnae: "46231/02",
        activityBranch: "4623102",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2446,
        departamentCode: "60",
        description: "Comércio atacadista de algodão",
        cnae: "46231/03",
        activityBranch: "4623103",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2447,
        departamentCode: "60",
        description: "Comércio atacadista de fumo em folha não beneficiado",
        cnae: "46231/04",
        activityBranch: "4623104",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2448,
        departamentCode: "60",
        description: "Comércio atacadista de cacau",
        cnae: "46231/05",
        activityBranch: "4623105",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2449,
        departamentCode: "58",
        description: "Comércio atacadista de sementes, flores, plantas e gramas",
        cnae: "46231/06",
        activityBranch: "4623106",
        mcc: {
            code: 5193,
            description: "SUPRIMENTOS PARA FLORISTAS, MATERIAL DE BERCARIO E FLORES"
        }
    },
    {
        id: 2450,
        departamentCode: "2",
        description: "Comércio atacadista de sisal",
        cnae: "46231/07",
        activityBranch: "4623107",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2451,
        departamentCode: "60",
        description: "Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento associada",
        cnae: "46231/08",
        activityBranch: "4623108",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2452,
        departamentCode: "60",
        description: "Comércio atacadista de alimentos para animais",
        cnae: "46231/09",
        activityBranch: "4623109",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2453,
        departamentCode: "2",
        description: "Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente",
        cnae: "46231/99",
        activityBranch: "4623199",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2454,
        departamentCode: "60",
        description: "Comércio atacadista de leite e laticínios",
        cnae: "46311/00",
        activityBranch: "4631100",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2455,
        departamentCode: "60",
        description: "Comércio atacadista de cereais e leguminosas beneficiados",
        cnae: "46320/01",
        activityBranch: "4632001",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2456,
        departamentCode: "60",
        description: "Comércio atacadista de farinhas, amidos e féculas",
        cnae: "46320/02",
        activityBranch: "4632002",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2457,
        departamentCode: "22",
        description: "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas, com atividade de fracionamento e acondicionamento associada",
        cnae: "46320/03",
        activityBranch: "4632003",
        mcc: {
            code: 4225,
            description: "ARMAZENAMENTO"
        }
    },
    {
        id: 2458,
        departamentCode: "60",
        description: "Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos",
        cnae: "46338/01",
        activityBranch: "4633801",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2459,
        departamentCode: "60",
        description: "Comércio atacadista de aves vivas e ovos",
        cnae: "46338/02",
        activityBranch: "4633802",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2460,
        departamentCode: "60",
        description: "Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação",
        cnae: "46338/03",
        activityBranch: "4633803",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2461,
        departamentCode: "60",
        description: "Comércio atacadista de carnes bovinas e suínas e derivados",
        cnae: "46346/01",
        activityBranch: "4634601",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2462,
        departamentCode: "60",
        description: "Comércio atacadista de aves abatidas e derivados",
        cnae: "46346/02",
        activityBranch: "4634602",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2463,
        departamentCode: "60",
        description: "Comércio atacadista de pescados e frutos do mar",
        cnae: "46346/03",
        activityBranch: "4634603",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2464,
        departamentCode: "60",
        description: "Comércio atacadista de carnes e derivados de outros animais",
        cnae: "46346/99",
        activityBranch: "4634699",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2465,
        departamentCode: "60",
        description: "Comércio atacadista de água mineral",
        cnae: "46354/01",
        activityBranch: "4635401",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2466,
        departamentCode: "60",
        description: "Comércio atacadista de cerveja, chope e refrigerante",
        cnae: "46354/02",
        activityBranch: "4635402",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2467,
        departamentCode: "60",
        description: "Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada",
        cnae: "46354/03",
        activityBranch: "4635403",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2468,
        departamentCode: "60",
        description: "Comércio atacadista de bebidas não especificadas anteriormente",
        cnae: "46354/99",
        activityBranch: "4635499",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2469,
        departamentCode: "60",
        description: "Comércio atacadista de fumo beneficiado",
        cnae: "46362/01",
        activityBranch: "4636201",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2470,
        departamentCode: "60",
        description: "Comércio atacadista de cigarros, cigarrilhas e charutos",
        cnae: "46362/02",
        activityBranch: "4636202",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2471,
        departamentCode: "60",
        description: "Comércio atacadista de café torrado, moído e solúvel",
        cnae: "46371/01",
        activityBranch: "4637101",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2472,
        departamentCode: "60",
        description: "Comércio atacadista de açúcar",
        cnae: "46371/02",
        activityBranch: "4637102",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2473,
        departamentCode: "60",
        description: "Comércio atacadista de óleos e gorduras",
        cnae: "46371/03",
        activityBranch: "4637103",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2474,
        departamentCode: "74",
        description: "Comércio atacadista de pães, bolos, biscoitos e similares",
        cnae: "46371/04",
        activityBranch: "4637104",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 2475,
        departamentCode: "60",
        description: "Comércio atacadista de massas alimentícias",
        cnae: "46371/05",
        activityBranch: "4637105",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2476,
        departamentCode: "60",
        description: "Comércio atacadista de sorvetes",
        cnae: "46371/06",
        activityBranch: "4637106",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2477,
        departamentCode: "60",
        description: "Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes",
        cnae: "46371/07",
        activityBranch: "4637107",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2478,
        departamentCode: "65",
        description: "Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente",
        cnae: "46371/99",
        activityBranch: "4637199",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2479,
        departamentCode: "65",
        description: "Comércio atacadista de produtos alimentícios em geral",
        cnae: "46397/01",
        activityBranch: "4639701",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2480,
        departamentCode: "65",
        description: "Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionamento associada",
        cnae: "46397/02",
        activityBranch: "4639702",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2481,
        departamentCode: "52",
        description: "Comércio atacadista de tecidos",
        cnae: "46419/01",
        activityBranch: "4641901",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 2482,
        departamentCode: "60",
        description: "Comércio atacadista de artigos de cama, mesa e banho",
        cnae: "46419/02",
        activityBranch: "4641902",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2483,
        departamentCode: "52",
        description: "Comércio atacadista de artigos de armarinho",
        cnae: "46419/03",
        activityBranch: "4641903",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 2484,
        departamentCode: "53",
        description: "Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança",
        cnae: "46427/01",
        activityBranch: "4642701",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2485,
        departamentCode: "53",
        description: "Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho",
        cnae: "46427/02",
        activityBranch: "4642702",
        mcc: {
            code: 5137,
            description: "UNIFORMES E ROUPAS COMERCIAIS MASCULINAS PARA MULHERES E CRIANCAS"
        }
    },
    {
        id: 2486,
        departamentCode: "54",
        description: "Comércio atacadista de calçados",
        cnae: "46435/01",
        activityBranch: "4643501",
        mcc: {
            code: 5139,
            description: "CALCADO COMERCIAL"
        }
    },
    {
        id: 2487,
        departamentCode: "60",
        description: "Comércio atacadista de bolsas, malas e artigos de viagem",
        cnae: "46435/02",
        activityBranch: "4643502",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2488,
        departamentCode: "51",
        description: "Comércio atacadista de medicamentos e drogas de uso humano",
        cnae: "46443/01",
        activityBranch: "4644301",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2489,
        departamentCode: "51",
        description: "Comércio atacadista de medicamentos e drogas de uso veterinário",
        cnae: "46443/02",
        activityBranch: "4644302",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2490,
        departamentCode: "42",
        description: "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laboratórios",
        cnae: "46451/01",
        activityBranch: "4645101",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2491,
        departamentCode: "42",
        description: "Comércio atacadista de próteses e artigos de ortopedia",
        cnae: "46451/02",
        activityBranch: "4645102",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2492,
        departamentCode: "42",
        description: "Comércio atacadista de produtos odontológicos",
        cnae: "46451/03",
        activityBranch: "4645103",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2493,
        departamentCode: "51",
        description: "Comércio atacadista de cosméticos e produtos de perfumaria",
        cnae: "46460/01",
        activityBranch: "4646001",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2494,
        departamentCode: "51",
        description: "Comércio atacadista de produtos de higiene pessoal",
        cnae: "46460/02",
        activityBranch: "4646002",
        mcc: {
            code: 5122,
            description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)"
        }
    },
    {
        id: 2495,
        departamentCode: "50",
        description: "Comércio atacadista de artigos de escritório e de papelaria",
        cnae: "46478/01",
        activityBranch: "4647801",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2496,
        departamentCode: "57",
        description: "Comércio atacadista de livros, jornais e outras publicações",
        cnae: "46478/02",
        activityBranch: "4647802",
        mcc: {
            code: 5192,
            description: "ATAC. E DISTRIB. DE LIVROS, PERIODICOS E JORNAIS"
        }
    },
    {
        id: 2497,
        departamentCode: "44",
        description: "Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico",
        cnae: "46494/01",
        activityBranch: "4649401",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2498,
        departamentCode: "49",
        description: "Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico",
        cnae: "46494/02",
        activityBranch: "4649402",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2499,
        departamentCode: "105",
        description: "Comércio atacadista de bicicletas, triciclos e outros veículos recreativos",
        cnae: "46494/03",
        activityBranch: "4649403",
        mcc: {
            code: 5940,
            description: "LOJA DE BICICLETAS - VENDAS E SERVICOS"
        }
    },
    {
        id: 2500,
        departamentCode: "37",
        description: "Comércio atacadista de móveis e artigos de colchoaria",
        cnae: "46494/04",
        activityBranch: "4649404",
        mcc: {
            code: 5021,
            description: "MOVEIS PARA ESCRITORIOS (COMMERCIAL FURNITURE)"
        }
    },
    {
        id: 2501,
        departamentCode: "49",
        description: "Comércio atacadista de artigos de tapeçaria; persianas e cortinas",
        cnae: "46494/05",
        activityBranch: "4649405",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2502,
        departamentCode: "44",
        description: "Comércio atacadista de lustres, luminárias e abajures",
        cnae: "46494/06",
        activityBranch: "4649406",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2503,
        departamentCode: "170",
        description: "Comércio atacadista de filmes, CDs, DVDs, fitas e discos",
        cnae: "46494/07",
        activityBranch: "4649407",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2504,
        departamentCode: "14",
        description: "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar",
        cnae: "46494/08",
        activityBranch: "4649408",
        mcc: {
            code: 2842,
            description: "PREPARACOES ESPECIAIS DE LIMPEZA, POLIMENTO E SANEAMENTO"
        }
    },
    {
        id: 2505,
        departamentCode: "14",
        description: "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar, com atividade de fracionamento e acondicionamento associada",
        cnae: "46494/09",
        activityBranch: "4649409",
        mcc: {
            code: 2842,
            description: "PREPARACOES ESPECIAIS DE LIMPEZA, POLIMENTO E SANEAMENTO"
        }
    },
    {
        id: 2506,
        departamentCode: "48",
        description: "Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapidadas",
        cnae: "46494/10",
        activityBranch: "4649410",
        mcc: {
            code: 5094,
            description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS"
        }
    },
    {
        id: 2507,
        departamentCode: "60",
        description: "Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente",
        cnae: "46494/99",
        activityBranch: "4649499",
        mcc: {
            code: 5199,
            description: "BENS NAO DURAVEIS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2508,
        departamentCode: "40",
        description: "Comércio atacadista de equipamentos de informática",
        cnae: "46516/01",
        activityBranch: "4651601",
        mcc: {
            code: 5045,
            description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES"
        }
    },
    {
        id: 2509,
        departamentCode: "40",
        description: "Comércio atacadista de suprimentos para informática",
        cnae: "46516/02",
        activityBranch: "4651602",
        mcc: {
            code: 5045,
            description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES"
        }
    },
    {
        id: 2510,
        departamentCode: "44",
        description: "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação",
        cnae: "46524/00",
        activityBranch: "4652400",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2511,
        departamentCode: "83",
        description: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças",
        cnae: "46613/00",
        activityBranch: "4661300",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2512,
        departamentCode: "83",
        description: "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças",
        cnae: "46621/00",
        activityBranch: "4662100",
        mcc: {
            code: 5599,
            description: "SERVICOS GERIAS PARA CARROS"
        }
    },
    {
        id: 2513,
        departamentCode: "47",
        description: "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças",
        cnae: "46630/00",
        activityBranch: "4663000",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2514,
        departamentCode: "42",
        description: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças",
        cnae: "46648/00",
        activityBranch: "4664800",
        mcc: {
            code: 5047,
            description: "MEDICO, OFTALMOLOGICO, EQUIPAMENTOS E SUPRIMENTOS HOSPITALARES"
        }
    },
    {
        id: 2515,
        departamentCode: "41",
        description: "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças",
        cnae: "46656/00",
        activityBranch: "4665600",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2516,
        departamentCode: "47",
        description: "Comércio atacadista de bombas e compressores; partes e peças",
        cnae: "46699/01",
        activityBranch: "4669901",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2517,
        departamentCode: "41",
        description: "Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peças",
        cnae: "46699/99",
        activityBranch: "4669999",
        mcc: {
            code: 5046,
            description: "EQUIPAMENTO COMERCIAL, NAO CLASSIFICADO EM OUTRA PARTE"
        }
    },
    {
        id: 2518,
        departamentCode: "49",
        description: "Comércio atacadista de madeira e produtos derivados",
        cnae: "46711/00",
        activityBranch: "4671100",
        mcc: {
            code: 5099,
            description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURAVEIS"
        }
    },
    {
        id: 2519,
        departamentCode: "45",
        description: "Comércio atacadista de ferragens e ferramentas",
        cnae: "46729/00",
        activityBranch: "4672900",
        mcc: {
            code: 5072,
            description: "EQUIP./DISTRIB. DE HARDWARE (HARDWARE EQUIP.SUPPLIES)"
        }
    },
    {
        id: 2520,
        departamentCode: "44",
        description: "Comércio atacadista de material elétrico",
        cnae: "46737/00",
        activityBranch: "4673700",
        mcc: {
            code: 5065,
            description: "LOJA ARTIGOS ELETRONICOS"
        }
    },
    {
        id: 2521,
        departamentCode: "38",
        description: "Comércio atacadista de cimento",
        cnae: "46745/00",
        activityBranch: "4674500",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2522,
        departamentCode: "59",
        description: "Comércio atacadista de tintas, vernizes e similares",
        cnae: "46796/01",
        activityBranch: "4679601",
        mcc: {
            code: 5198,
            description: "PINTURA, POLIMENTO E SUPRIM. (PAN., VARN. & SUPPLIES)"
        }
    },
    {
        id: 2523,
        departamentCode: "38",
        description: "Comércio atacadista de mármores e granitos",
        cnae: "46796/02",
        activityBranch: "4679602",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2524,
        departamentCode: "38",
        description: "Comércio atacadista de vidros, espelhos e vitrais",
        cnae: "46796/03",
        activityBranch: "4679603",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2525,
        departamentCode: "38",
        description: "Comércio atacadista especializado de materiais de construção não especificados anteriormente",
        cnae: "46796/04",
        activityBranch: "4679604",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2526,
        departamentCode: "38",
        description: "Comércio atacadista de materiais de construção em geral",
        cnae: "46796/99",
        activityBranch: "4679699",
        mcc: {
            code: 5039,
            description: "MATERIAL PARA CONSTRUCAO E AFINS (CONST. MAT. - DEF)"
        }
    },
    {
        id: 2527,
        departamentCode: "56",
        description: "Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto lubrificantes, não realizado por transportador retalhista (TRR)",
        cnae: "46818/01",
        activityBranch: "4681801",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2528,
        departamentCode: "56",
        description: "Comércio atacadista de combustíveis realizado por transportador retalhista (TRR)",
        cnae: "46818/02",
        activityBranch: "4681802",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2529,
        departamentCode: "56",
        description: "Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante",
        cnae: "46818/03",
        activityBranch: "4681803",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2530,
        departamentCode: "56",
        description: "Comércio atacadista de combustíveis de origem mineral em bruto",
        cnae: "46818/04",
        activityBranch: "4681804",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2531,
        departamentCode: "56",
        description: "Comércio atacadista de lubrificantes",
        cnae: "46818/05",
        activityBranch: "4681805",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2532,
        departamentCode: "56",
        description: "Comércio atacadista de gás liqüefeito de petróleo (GLP)",
        cnae: "46826/00",
        activityBranch: "4682600",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2533,
        departamentCode: "2",
        description: "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo",
        cnae: "46834/00",
        activityBranch: "4683400",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2534,
        departamentCode: "55",
        description: "Comércio atacadista de resinas e elastômeros",
        cnae: "46842/01",
        activityBranch: "4684201",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2535,
        departamentCode: "55",
        description: "Comércio atacadista de solventes",
        cnae: "46842/02",
        activityBranch: "4684202",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 2536,
        departamentCode: "56",
        description: "Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente",
        cnae: "46842/99",
        activityBranch: "4684299",
        mcc: {
            code: 5172,
            description: "PRODUTOS DE PETROLEO (PETROLEUM/PETROLEUM PRODUCTS)"
        }
    },
    {
        id: 2537,
        departamentCode: "43",
        description: "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção",
        cnae: "46851/00",
        activityBranch: "4685100",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2538,
        departamentCode: "47",
        description: "Comércio atacadista de papel e papelão em bruto",
        cnae: "46869/01",
        activityBranch: "4686901",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2539,
        departamentCode: "50",
        description: "Comércio atacadista de embalagens",
        cnae: "46869/02",
        activityBranch: "4686902",
        mcc: {
            code: 5111,
            description: "PAPELARIA, MATERIAL DE ESCRITORIO, IMPRESSAO E PAPEL DE CARTA"
        }
    },
    {
        id: 2540,
        departamentCode: "47",
        description: "Comércio atacadista de resíduos de papel e papelão",
        cnae: "46877/01",
        activityBranch: "4687701",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2541,
        departamentCode: "47",
        description: "Comércio atacadista de resíduos e sucatas não-metálicos, exceto de papel e papelão",
        cnae: "46877/02",
        activityBranch: "4687702",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2542,
        departamentCode: "43",
        description: "Comércio atacadista de resíduos e sucatas metálicos",
        cnae: "46877/03",
        activityBranch: "4687703",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 2543,
        departamentCode: "47",
        description: "Comércio atacadista de produtos da extração mineral, exceto combustíveis",
        cnae: "46893/01",
        activityBranch: "4689301",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2544,
        departamentCode: "52",
        description: "Comércio atacadista de fios e fibras beneficiados",
        cnae: "46893/02",
        activityBranch: "4689302",
        mcc: {
            code: 5131,
            description: "BENS E OUTROS ARTIGOS SECOS (PIECE GOODS, NOTIONS AND OTHER DRY GOODS)"
        }
    },
    {
        id: 2545,
        departamentCode: "47",
        description: "Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente",
        cnae: "46893/99",
        activityBranch: "4689399",
        mcc: {
            code: 5085,
            description: "SUPRIMENTOS INDUSTRIAIS, NAO CLASSIFICADOS EM OUTROS LUGARES"
        }
    },
    {
        id: 2546,
        departamentCode: "65",
        description: "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios",
        cnae: "46915/00",
        activityBranch: "4691500",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2547,
        departamentCode: "2",
        description: "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários",
        cnae: "46923/00",
        activityBranch: "4692300",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2548,
        departamentCode: "65",
        description: "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários",
        cnae: "46931/00",
        activityBranch: "4693100",
        mcc: {
            code: 5300,
            description: "VENDA POR ATACADO (WHOLESALE CLUBS)"
        }
    },
    {
        id: 2549,
        departamentCode: "70",
        description: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados",
        cnae: "47113/01",
        activityBranch: "4711301",
        mcc: {
            code: 5411,
            description: "MERCEARIAS/SUPERMERCADOS (GROCERY STORES/SUPERM.)"
        }
    },
    {
        id: 2550,
        departamentCode: "70",
        description: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercados",
        cnae: "47113/02",
        activityBranch: "4711302",
        mcc: {
            code: 5411,
            description: "MERCEARIAS/SUPERMERCADOS (GROCERY STORES/SUPERM.)"
        }
    },
    {
        id: 2551,
        departamentCode: "70",
        description: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercados, mercearias e armazéns",
        cnae: "47121/00",
        activityBranch: "4712100",
        mcc: {
            code: 5411,
            description: "MERCEARIAS/SUPERMERCADOS (GROCERY STORES/SUPERM.)"
        }
    },
    {
        id: 2552,
        departamentCode: "67",
        description: "Lojas de departamentos ou magazines",
        cnae: "47130/01",
        activityBranch: "4713001",
        mcc: {
            code: 5311,
            description: "LOJAS DE DEPARTAMENTOS (DEPARTMENT STORES)"
        }
    },
    {
        id: 2553,
        departamentCode: "68",
        description: "Lojas de variedades, exceto lojas de departamentos ou magazines",
        cnae: "47130/02",
        activityBranch: "4713002",
        mcc: {
            code: 5331,
            description: "LOJAS DE VARIEDADES"
        }
    },
    {
        id: 2554,
        departamentCode: "66",
        description: "Lojas duty free de aeroportos internacionais",
        cnae: "47130/03",
        activityBranch: "4713003",
        mcc: {
            code: 5309,
            description: "DUTY FREE STORES"
        }
    },
    {
        id: 2555,
        departamentCode: "74",
        description: "Padaria e confeitaria com predominância de revenda",
        cnae: "47211/02",
        activityBranch: "4721102",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 2556,
        departamentCode: "73",
        description: "Comércio varejista de laticínios e frios",
        cnae: "47211/03",
        activityBranch: "4721103",
        mcc: {
            code: 5451,
            description: "LOJA DE PRODUTOS DE LACTICINIOS (DAIRY PROD. STORES)"
        }
    },
    {
        id: 2557,
        departamentCode: "72",
        description: "Comércio varejista de doces, balas, bombons e semelhantes",
        cnae: "47211/04",
        activityBranch: "4721104",
        mcc: {
            code: 5441,
            description: "LOJA DE DOCES"
        }
    },
    {
        id: 2558,
        departamentCode: "71",
        description: "Comércio varejista de carnes - açougues",
        cnae: "47229/01",
        activityBranch: "4722901",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 2559,
        departamentCode: "71",
        description: "Peixaria",
        cnae: "47229/02",
        activityBranch: "4722902",
        mcc: {
            code: 5422,
            description: "ACOGUEIRO (FREEZER/MEAT LOCKERS)"
        }
    },
    {
        id: 2560,
        departamentCode: "101",
        description: "Comércio varejista de bebidas",
        cnae: "47237/00",
        activityBranch: "4723700",
        mcc: {
            code: 5921,
            description: "CERVEJAS, VINHOS E LICORES (STORE/BEER/WINE/LIQUOR)"
        }
    },
    {
        id: 2561,
        departamentCode: "75",
        description: "Comércio varejista de hortifrutigranjeiros",
        cnae: "47245/00",
        activityBranch: "4724500",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2562,
        departamentCode: "121",
        description: "Tabacaria",
        cnae: "47296/01",
        activityBranch: "4729601",
        mcc: {
            code: 5993,
            description: "TABACARIA"
        }
    },
    {
        id: 2563,
        departamentCode: "75",
        description: "Comércio varejista de mercadorias em lojas de conveniência",
        cnae: "47296/02",
        activityBranch: "4729602",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2564,
        departamentCode: "75",
        description: "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente",
        cnae: "47296/99",
        activityBranch: "4729699",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2565,
        departamentCode: "80",
        description: "Comércio varejista de combustíveis para veículos automotores",
        cnae: "47318/00",
        activityBranch: "4731800",
        mcc: {
            code: 5541,
            description: "ESTACOES DE SERVICOS (SERVICE STATIONS)"
        }
    },
    {
        id: 2566,
        departamentCode: "119",
        description: "Comércio varejista de lubrificantes",
        cnae: "47326/00",
        activityBranch: "4732600",
        mcc: {
            code: 5983,
            description: "REVENDEDORES DE COMBUSTIVEIS (FUEL DEALERS)"
        }
    },
    {
        id: 2567,
        departamentCode: "62",
        description: "Comércio varejista de tintas e materiais para pintura",
        cnae: "47415/00",
        activityBranch: "4741500",
        mcc: {
            code: 5231,
            description: "LOJAS DE VIDRO, TINTAS E PAPEIS DE PAREDE"
        }
    },
    {
        id: 2568,
        departamentCode: "61",
        description: "Comércio varejista de material elétrico",
        cnae: "47423/00",
        activityBranch: "4742300",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2569,
        departamentCode: "62",
        description: "Comércio varejista de vidros",
        cnae: "47431/00",
        activityBranch: "4743100",
        mcc: {
            code: 5231,
            description: "LOJAS DE VIDRO, TINTAS E PAPEIS DE PAREDE"
        }
    },
    {
        id: 2570,
        departamentCode: "63",
        description: "Comércio varejista de ferragens e ferramentas",
        cnae: "47440/01",
        activityBranch: "4744001",
        mcc: {
            code: 5251,
            description: "VENDA DE EQUIPAMENTOS, INCLUINDO DE FERRAGEM"
        }
    },
    {
        id: 2571,
        departamentCode: "61",
        description: "Comércio varejista de madeira e artefatos",
        cnae: "47440/02",
        activityBranch: "4744002",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2572,
        departamentCode: "61",
        description: "Comércio varejista de materiais hidráulicos",
        cnae: "47440/03",
        activityBranch: "4744003",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2573,
        departamentCode: "61",
        description: "Comércio varejista de cal, areia, pedra britada, tijolos e telhas",
        cnae: "47440/04",
        activityBranch: "4744004",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2574,
        departamentCode: "61",
        description: "Comércio varejista de materiais de construção não especificados anteriormente",
        cnae: "47440/05",
        activityBranch: "4744005",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2575,
        departamentCode: "61",
        description: "Comércio varejista de pedras para revestimento",
        cnae: "47440/06",
        activityBranch: "4744006",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2576,
        departamentCode: "61",
        description: "Comércio varejista de materiais de construção em geral",
        cnae: "47440/99",
        activityBranch: "4744099",
        mcc: {
            code: 5211,
            description: "LOJAS DE MADEIRA E MATERIAIS DE CONSTRUCAO"
        }
    },
    {
        id: 2577,
        departamentCode: "94",
        description: "Comércio varejista especializado de equipamentos e suprimentos de informática",
        cnae: "47512/01",
        activityBranch: "4751201",
        mcc: {
            code: 5734,
            description: "LOJA DE SOFTWARE"
        }
    },
    {
        id: 2578,
        departamentCode: "94",
        description: "Recarga de cartuchos para equipamentos de informática",
        cnae: "47512/02",
        activityBranch: "4751202",
        mcc: {
            code: 5734,
            description: "LOJA DE SOFTWARE"
        }
    },
    {
        id: 2579,
        departamentCode: "31",
        description: "Comércio varejista especializado de equipamentos de telefonia e comunicação",
        cnae: "47521/00",
        activityBranch: "4752100",
        mcc: {
            code: 4812,
            description: "TELEFONES E EQUIPAMENTOS DE TELECOMUN."
        }
    },
    {
        id: 2580,
        departamentCode: "91",
        description: "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo",
        cnae: "47539/00",
        activityBranch: "4753900",
        mcc: {
            code: 5722,
            description: "LOJAS DE ELETRODOMESTICOS"
        }
    },
    {
        id: 2581,
        departamentCode: "88",
        description: "Comércio varejista de móveis",
        cnae: "47547/01",
        activityBranch: "4754701",
        mcc: {
            code: 5712,
            description: "LOJA DE MOVEIS"
        }
    },
    {
        id: 2582,
        departamentCode: "88",
        description: "Comércio varejista de artigos de colchoaria",
        cnae: "47547/02",
        activityBranch: "4754702",
        mcc: {
            code: 5712,
            description: "LOJA DE MOVEIS"
        }
    },
    {
        id: 2583,
        departamentCode: "88",
        description: "Comércio varejista de artigos de iluminação",
        cnae: "47547/03",
        activityBranch: "4754703",
        mcc: {
            code: 5712,
            description: "LOJA DE MOVEIS"
        }
    },
    {
        id: 2584,
        departamentCode: "114",
        description: "Comércio varejista de tecidos",
        cnae: "47555/01",
        activityBranch: "4755501",
        mcc: {
            code: 5949,
            description: "LOJAS DE COSTURA, AGULHAS, TECIDOS E ARTIGOS DE PRECO"
        }
    },
    {
        id: 2585,
        departamentCode: "114",
        description: "Comercio varejista de artigos de armarinho",
        cnae: "47555/02",
        activityBranch: "4755502",
        mcc: {
            code: 5949,
            description: "LOJAS DE COSTURA, AGULHAS, TECIDOS E ARTIGOS DE PRECO"
        }
    },
    {
        id: 2586,
        departamentCode: "90",
        description: "Comercio varejista de artigos de cama, mesa e banho",
        cnae: "47555/03",
        activityBranch: "4755503",
        mcc: {
            code: 5719,
            description: "LOJA DE MOVEIS ESPECIALIZADA (HOME FURNISHING SPEC.)"
        }
    },
    {
        id: 2587,
        departamentCode: "93",
        description: "Comércio varejista especializado de instrumentos musicais e acessórios",
        cnae: "47563/00",
        activityBranch: "4756300",
        mcc: {
            code: 5733,
            description: "LOJA INSTRUMENTO MUSICAIS"
        }
    },
    {
        id: 2588,
        departamentCode: "92",
        description: "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação",
        cnae: "47571/00",
        activityBranch: "4757100",
        mcc: {
            code: 5732,
            description: "LOJA DE ELETRONICOS"
        }
    },
    {
        id: 2589,
        departamentCode: "89",
        description: "Comércio varejista de artigos de tapeçaria, cortinas e persianas",
        cnae: "47598/01",
        activityBranch: "4759801",
        mcc: {
            code: 5714,
            description: "LOJA DE ESTOFADOS (DRAPERY & UPHOLSTERY STORES)"
        }
    },
    {
        id: 2590,
        departamentCode: "124",
        description: "Comércio varejista de outros artigos de uso pessoal e doméstico não especificados anteriormente",
        cnae: "47598/99",
        activityBranch: "4759899",
        mcc: {
            code: 5999,
            description: "LOJAS ESPECIALIZADAS NAO LISTADAS ANTERIOMENTE"
        }
    },
    {
        id: 2591,
        departamentCode: "107",
        description: "Comércio varejista de livros",
        cnae: "47610/01",
        activityBranch: "4761001",
        mcc: {
            code: 5942,
            description: "LIVRARIAS"
        }
    },
    {
        id: 2592,
        departamentCode: "122",
        description: "Comércio varejista de jornais e revistas",
        cnae: "47610/02",
        activityBranch: "4761002",
        mcc: {
            code: 5994,
            description: "BANCA DE JORNAL E PROVEDOR DE NOTICIAS"
        }
    },
    {
        id: 2593,
        departamentCode: "108",
        description: "Comércio varejista de artigos de papelaria",
        cnae: "47610/03",
        activityBranch: "4761003",
        mcc: {
            code: 5943,
            description: "PAPELARIAS"
        }
    },
    {
        id: 2594,
        departamentCode: "95",
        description: "Comércio varejista de discos, CDs, DVDs e fitas",
        cnae: "47628/00",
        activityBranch: "4762800",
        mcc: {
            code: 5735,
            description: "LOJAS DE DISCOS"
        }
    },
    {
        id: 2595,
        departamentCode: "110",
        description: "Comércio varejista de brinquedos e artigos recreativos",
        cnae: "47636/01",
        activityBranch: "4763601",
        mcc: {
            code: 5945,
            description: "LOJA DE BRINQUEDOS"
        }
    },
    {
        id: 2596,
        departamentCode: "106",
        description: "Comércio varejista de artigos esportivos",
        cnae: "47636/02",
        activityBranch: "4763602",
        mcc: {
            code: 5941,
            description: "SERVICOS GERIAS PARA ESPORTES"
        }
    },
    {
        id: 2597,
        departamentCode: "105",
        description: "Comércio varejista de bicicletas e triciclos; peças e acessórios",
        cnae: "47636/03",
        activityBranch: "4763603",
        mcc: {
            code: 5940,
            description: "LOJA DE BICICLETAS - VENDAS E SERVICOS"
        }
    },
    {
        id: 2598,
        departamentCode: "106",
        description: "Comércio varejista de artigos de caça, pesca e camping",
        cnae: "47636/04",
        activityBranch: "4763604",
        mcc: {
            code: 5941,
            description: "SERVICOS GERIAS PARA ESPORTES"
        }
    },
    {
        id: 2599,
        departamentCode: "81",
        description: "Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios",
        cnae: "47636/05",
        activityBranch: "4763605",
        mcc: {
            code: 5551,
            description: "VENDA DE BARCOS MOTORIZADOS"
        }
    },
    {
        id: 2600,
        departamentCode: "100",
        description: "Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas",
        cnae: "47717/01",
        activityBranch: "4771701",
        mcc: {
            code: 5912,
            description: "FARMACIAS (DRUG STORES & PHARMACIES)"
        }
    },
    {
        id: 2601,
        departamentCode: "100",
        description: "Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas",
        cnae: "47717/02",
        activityBranch: "4771702",
        mcc: {
            code: 5912,
            description: "FARMACIAS (DRUG STORES & PHARMACIES)"
        }
    },
    {
        id: 2602,
        departamentCode: "100",
        description: "Comércio varejista de produtos farmacêuticos homeopáticos",
        cnae: "47717/03",
        activityBranch: "4771703",
        mcc: {
            code: 5912,
            description: "FARMACIAS (DRUG STORES & PHARMACIES)"
        }
    },
    {
        id: 2603,
        departamentCode: "100",
        description: "Comércio varejista de medicamentos veterinários",
        cnae: "47717/04",
        activityBranch: "4771704",
        mcc: {
            code: 5912,
            description: "FARMACIAS (DRUG STORES & PHARMACIES)"
        }
    },
    {
        id: 2604,
        departamentCode: "118",
        description: "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal",
        cnae: "47725/00",
        activityBranch: "4772500",
        mcc: {
            code: 5977,
            description: "LOJA DE COSMETICOS"
        }
    },
    {
        id: 2605,
        departamentCode: "117",
        description: "Comércio varejista de artigos médicos e ortopédicos",
        cnae: "47733/00",
        activityBranch: "4773300",
        mcc: {
            code: 5976,
            description: "BENS ORTOPEDICOS - PROTESES"
        }
    },
    {
        id: 2606,
        departamentCode: "189",
        description: "Comércio varejista de artigos de óptica",
        cnae: "47741/00",
        activityBranch: "4774100",
        mcc: {
            code: 8043,
            description: "OPTICIANS, OPTICAL GOODS, AND EYEGLASSES"
        }
    },
    {
        id: 2607,
        departamentCode: "84",
        description: "Comércio varejista de artigos do vestuário e acessórios",
        cnae: "47814/00",
        activityBranch: "4781400",
        mcc: {
            code: 5651,
            description: "ROUPAS MASCULINAS, FEMININAS E INFANTIS"
        }
    },
    {
        id: 2608,
        departamentCode: "85",
        description: "Comércio varejista de calçados",
        cnae: "47822/01",
        activityBranch: "4782201",
        mcc: {
            code: 5661,
            description: "LOJAS DE SAPATOS"
        }
    },
    {
        id: 2609,
        departamentCode: "112",
        description: "Comércio varejista de artigos de viagem",
        cnae: "47822/02",
        activityBranch: "4782202",
        mcc: {
            code: 5947,
            description: "LOJA DE PRESENTES"
        }
    },
    {
        id: 2610,
        departamentCode: "109",
        description: "Comércio varejista de artigos de joalheria",
        cnae: "47831/01",
        activityBranch: "4783101",
        mcc: {
            code: 5944,
            description: "JOALHERIA (JEWERLY STORE)"
        }
    },
    {
        id: 2611,
        departamentCode: "109",
        description: "Comércio varejista de artigos de relojoaria",
        cnae: "47831/02",
        activityBranch: "4783102",
        mcc: {
            code: 5944,
            description: "JOALHERIA (JEWERLY STORE)"
        }
    },
    {
        id: 2612,
        departamentCode: "119",
        description: "Comércio varejista de gás liqüefeito de petróleo (GLP)",
        cnae: "47849/00",
        activityBranch: "4784900",
        mcc: {
            code: 5983,
            description: "REVENDEDORES DE COMBUSTIVEIS (FUEL DEALERS)"
        }
    },
    {
        id: 2613,
        departamentCode: "103",
        description: "Comércio varejista de antigüidades",
        cnae: "47857/01",
        activityBranch: "4785701",
        mcc: {
            code: 5932,
            description: "LOJA DE ANTIGUIDADES (ANTIQUE SHOPS)"
        }
    },
    {
        id: 2614,
        departamentCode: "102",
        description: "Comércio varejista de outros artigos usados",
        cnae: "47857/99",
        activityBranch: "4785799",
        mcc: {
            code: 5931,
            description: "MERCADORIAS USADAS E LOJAS DE SEGUNDA MAO"
        }
    },
    {
        id: 2615,
        departamentCode: "112",
        description: "Comércio varejista de suvenires, bijuterias e artesanatos",
        cnae: "47890/01",
        activityBranch: "4789001",
        mcc: {
            code: 5947,
            description: "LOJA DE PRESENTES"
        }
    },
    {
        id: 2616,
        departamentCode: "120",
        description: "Comércio varejista de plantas e flores naturais",
        cnae: "47890/02",
        activityBranch: "4789002",
        mcc: {
            code: 5992,
            description: "FLORICULTURA"
        }
    },
    {
        id: 2617,
        departamentCode: "116",
        description: "Comércio varejista de objetos de arte",
        cnae: "47890/03",
        activityBranch: "4789003",
        mcc: {
            code: 5971,
            description: "GALERIA DE ARTE (ART DEALERS & GALLERIES)"
        }
    },
    {
        id: 2618,
        departamentCode: "123",
        description: "Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação",
        cnae: "47890/04",
        activityBranch: "4789004",
        mcc: {
            code: 5995,
            description: "PET SHOP"
        }
    },
    {
        id: 2619,
        departamentCode: "124",
        description: "Comércio varejista de produtos saneantes domissanitários",
        cnae: "47890/05",
        activityBranch: "4789005",
        mcc: {
            code: 5999,
            description: "LOJAS ESPECIALIZADAS NAO LISTADAS ANTERIOMENTE"
        }
    },
    {
        id: 2620,
        departamentCode: "124",
        description: "Comércio varejista de fogos de artifício e artigos pirotécnicos",
        cnae: "47890/06",
        activityBranch: "4789006",
        mcc: {
            code: 5999,
            description: "LOJAS ESPECIALIZADAS NAO LISTADAS ANTERIOMENTE"
        }
    },
    {
        id: 2621,
        departamentCode: "108",
        description: "Comércio varejista de equipamentos para escritório",
        cnae: "47890/07",
        activityBranch: "4789007",
        mcc: {
            code: 5943,
            description: "PAPELARIAS"
        }
    },
    {
        id: 2622,
        departamentCode: "111",
        description: "Comércio varejista de artigos fotográficos e para filmagem",
        cnae: "47890/08",
        activityBranch: "4789008",
        mcc: {
            code: 5946,
            description: "LOJA DE FOTOGRAFIA"
        }
    },
    {
        id: 2623,
        departamentCode: "124",
        description: "Comércio varejista de armas e munições",
        cnae: "47890/09",
        activityBranch: "4789009",
        mcc: {
            code: 5999,
            description: "LOJAS ESPECIALIZADAS NAO LISTADAS ANTERIOMENTE"
        }
    },
    {
        id: 2624,
        departamentCode: "124",
        description: "Comércio varejista de outros produtos não especificados anteriormente",
        cnae: "47890/99",
        activityBranch: "4789099",
        mcc: {
            code: 5999,
            description: "LOJAS ESPECIALIZADAS NAO LISTADAS ANTERIOMENTE"
        }
    },
    {
        id: 2625,
        departamentCode: "15",
        description: "Transporte ferroviário de carga",
        cnae: "49116/00",
        activityBranch: "4911600",
        mcc: {
            code: 4011,
            description: "TRANSPORTE FERROVIARIO DE CARGA"
        }
    },
    {
        id: 2626,
        departamentCode: "16",
        description: "Transporte ferroviário de passageiros intermunicipal e interestadual",
        cnae: "49124/01",
        activityBranch: "4912401",
        mcc: {
            code: 4112,
            description: "TRANSPORTE DE PASSAGEIROS EM TREM (LONGA DISTANCIA)"
        }
    },
    {
        id: 2627,
        departamentCode: "15",
        description: "Transporte ferroviário de passageiros municipal e em região metropolitana",
        cnae: "49124/02",
        activityBranch: "4912402",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2628,
        departamentCode: "15",
        description: "Transporte metroviário",
        cnae: "49124/03",
        activityBranch: "4912403",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2629,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal",
        cnae: "49213/01",
        activityBranch: "4921301",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2630,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropolitana",
        cnae: "49213/02",
        activityBranch: "4921302",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2631,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região metropolitana",
        cnae: "49221/01",
        activityBranch: "4922101",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2632,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual",
        cnae: "49221/02",
        activityBranch: "4922102",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2633,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional",
        cnae: "49221/03",
        activityBranch: "4922103",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2634,
        departamentCode: "18",
        description: "Serviço de táxi",
        cnae: "49230/01",
        activityBranch: "4923001",
        mcc: {
            code: 4121,
            description: "LIMUSINES E TAXIS (TAXICABS AND LIMOUSINES)"
        }
    },
    {
        id: 2635,
        departamentCode: "18",
        description: "Serviço de transporte de passageiros - locação de automóveis com motorista",
        cnae: "49230/02",
        activityBranch: "4923002",
        mcc: {
            code: 4121,
            description: "LIMUSINES E TAXIS (TAXICABS AND LIMOUSINES)"
        }
    },
    {
        id: 2636,
        departamentCode: "30",
        description: "Transporte escolar",
        cnae: "49248/00",
        activityBranch: "4924800",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2637,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal",
        cnae: "49299/01",
        activityBranch: "4929901",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2638,
        departamentCode: "19",
        description: "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadual e internacional",
        cnae: "49299/02",
        activityBranch: "4929902",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2639,
        departamentCode: "19",
        description: "Organização de excursões em veículos rodoviários próprios, municipal",
        cnae: "49299/03",
        activityBranch: "4929903",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2640,
        departamentCode: "19",
        description: "Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional",
        cnae: "49299/04",
        activityBranch: "4929904",
        mcc: {
            code: 4131,
            description: "COMPANHIAS DE ONIBUS"
        }
    },
    {
        id: 2641,
        departamentCode: "30",
        description: "Outros transportes rodoviários de passageiros não especificados anteriormente",
        cnae: "49299/99",
        activityBranch: "4929999",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2642,
        departamentCode: "20",
        description: "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal",
        cnae: "49302/01",
        activityBranch: "4930201",
        mcc: {
            code: 4214,
            description: "TRANSPORTE DE CARGA RODOVIARIO E ARMAZENAMENTO"
        }
    },
    {
        id: 2643,
        departamentCode: "20",
        description: "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional",
        cnae: "49302/02",
        activityBranch: "4930202",
        mcc: {
            code: 4214,
            description: "TRANSPORTE DE CARGA RODOVIARIO E ARMAZENAMENTO"
        }
    },
    {
        id: 2644,
        departamentCode: "20",
        description: "Transporte rodoviário de produtos perigosos",
        cnae: "49302/03",
        activityBranch: "4930203",
        mcc: {
            code: 4214,
            description: "TRANSPORTE DE CARGA RODOVIARIO E ARMAZENAMENTO"
        }
    },
    {
        id: 2645,
        departamentCode: "20",
        description: "Transporte rodoviário de mudanças",
        cnae: "49302/04",
        activityBranch: "4930204",
        mcc: {
            code: 4214,
            description: "TRANSPORTE DE CARGA RODOVIARIO E ARMAZENAMENTO"
        }
    },
    {
        id: 2646,
        departamentCode: "30",
        description: "Transporte dutoviário",
        cnae: "49400/00",
        activityBranch: "4940000",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2647,
        departamentCode: "30",
        description: "Trens turísticos, teleféricos e similares",
        cnae: "49507/00",
        activityBranch: "4950700",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2648,
        departamentCode: "30",
        description: "Transporte marítimo de cabotagem - Carga",
        cnae: "50114/01",
        activityBranch: "5011401",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2649,
        departamentCode: "15",
        description: "Transporte marítimo de cabotagem - passageiros",
        cnae: "50114/02",
        activityBranch: "5011402",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2650,
        departamentCode: "30",
        description: "Transporte marítimo de longo curso - Carga",
        cnae: "50122/01",
        activityBranch: "5012201",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2651,
        departamentCode: "23",
        description: "Transporte marítimo de longo curso - Passageiros",
        cnae: "50122/02",
        activityBranch: "5012202",
        mcc: {
            code: 4411,
            description: "LINHAS DE CRUZEROS (CRUISE LINES)"
        }
    },
    {
        id: 2652,
        departamentCode: "30",
        description: "Transporte por navegação interior de carga, municipal, exceto travessia",
        cnae: "50211/01",
        activityBranch: "5021101",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2653,
        departamentCode: "30",
        description: "Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia",
        cnae: "50211/02",
        activityBranch: "5021102",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2654,
        departamentCode: "30",
        description: "Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia",
        cnae: "50220/01",
        activityBranch: "5022001",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2655,
        departamentCode: "30",
        description: "Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual e internacional, exceto travessia",
        cnae: "50220/02",
        activityBranch: "5022002",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2656,
        departamentCode: "30",
        description: "Navegação de apoio marítimo",
        cnae: "50301/01",
        activityBranch: "5030101",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2657,
        departamentCode: "30",
        description: "Navegação de apoio portuário",
        cnae: "50301/02",
        activityBranch: "5030102",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2658,
        departamentCode: "157",
        description: "Serviço de rebocadores e empurradores",
        cnae: "50301/03",
        activityBranch: "5030103",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2659,
        departamentCode: "30",
        description: "Transporte por navegação de travessia, municipal",
        cnae: "50912/01",
        activityBranch: "5091201",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2660,
        departamentCode: "15",
        description: "Transporte por navegação de travessia intermunicipal, interestadual e internacional",
        cnae: "50912/02",
        activityBranch: "5091202",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2661,
        departamentCode: "15",
        description: "Transporte aquaviário para passeios turísticos",
        cnae: "50998/01",
        activityBranch: "5099801",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2662,
        departamentCode: "15",
        description: "Outros transportes aquaviários não especificados anteriormente",
        cnae: "50998/99",
        activityBranch: "5099899",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2663,
        departamentCode: "26",
        description: "Transporte aéreo de passageiros regular",
        cnae: "51111/00",
        activityBranch: "5111100",
        mcc: {
            code: 4511,
            description: "OUTRAS CIAS AEREAS"
        }
    },
    {
        id: 2664,
        departamentCode: "26",
        description: "Serviço de táxi aéreo e locação de aeronaves com tripulação",
        cnae: "51129/01",
        activityBranch: "5112901",
        mcc: {
            code: 4511,
            description: "OUTRAS CIAS AEREAS"
        }
    },
    {
        id: 2665,
        departamentCode: "26",
        description: "Outros serviços de transporte aéreo de passageiros não-regular",
        cnae: "51129/99",
        activityBranch: "5112999",
        mcc: {
            code: 4511,
            description: "OUTRAS CIAS AEREAS"
        }
    },
    {
        id: 2666,
        departamentCode: "26",
        description: "Transporte aéreo de carga",
        cnae: "51200/00",
        activityBranch: "5120000",
        mcc: {
            code: 4511,
            description: "OUTRAS CIAS AEREAS"
        }
    },
    {
        id: 2667,
        departamentCode: "30",
        description: "Transporte espacial",
        cnae: "51307/00",
        activityBranch: "5130700",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2668,
        departamentCode: "22",
        description: "Armazéns gerais - emissão de warrant",
        cnae: "52117/01",
        activityBranch: "5211701",
        mcc: {
            code: 4225,
            description: "ARMAZENAMENTO"
        }
    },
    {
        id: 2669,
        departamentCode: "22",
        description: "Guarda-móveis",
        cnae: "52117/02",
        activityBranch: "5211702",
        mcc: {
            code: 4225,
            description: "ARMAZENAMENTO"
        }
    },
    {
        id: 2670,
        departamentCode: "22",
        description: "Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis",
        cnae: "52117/99",
        activityBranch: "5211799",
        mcc: {
            code: 4225,
            description: "ARMAZENAMENTO"
        }
    },
    {
        id: 2671,
        departamentCode: "20",
        description: "Carga e descarga",
        cnae: "52125/00",
        activityBranch: "5212500",
        mcc: {
            code: 4214,
            description: "TRANSPORTE DE CARGA RODOVIARIO E ARMAZENAMENTO"
        }
    },
    {
        id: 2672,
        departamentCode: "29",
        description: "Concessionárias de rodovias, pontes, túneis e serviços relacionados",
        cnae: "52214/00",
        activityBranch: "5221400",
        mcc: {
            code: 4784,
            description: "PEDAGIOS"
        }
    },
    {
        id: 2673,
        departamentCode: "15",
        description: "Terminais rodoviários e ferroviários",
        cnae: "52222/00",
        activityBranch: "5222200",
        mcc: {
            code: 4111,
            description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS"
        }
    },
    {
        id: 2674,
        departamentCode: "159",
        description: "Estacionamento de veículos",
        cnae: "52231/00",
        activityBranch: "5223100",
        mcc: {
            code: 7523,
            description: "ESTACIONAMNTOS E GARAGENS DE CARRO"
        }
    },
    {
        id: 2675,
        departamentCode: "18",
        description: "Serviços de apoio ao transporte por táxi, inclusive centrais de chamada",
        cnae: "52290/01",
        activityBranch: "5229001",
        mcc: {
            code: 4121,
            description: "LIMUSINES E TAXIS (TAXICABS AND LIMOUSINES)"
        }
    },
    {
        id: 2676,
        departamentCode: "164",
        description: "Serviços de reboque de veículos",
        cnae: "52290/02",
        activityBranch: "5229002",
        mcc: {
            code: 7549,
            description: "SERVICOS DE REBOQUE"
        }
    },
    {
        id: 2677,
        departamentCode: "30",
        description: "Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente",
        cnae: "52290/99",
        activityBranch: "5229099",
        mcc: {
            code: 4789,
            description: "SERVICOS DE TRANSPORTE"
        }
    },
    {
        id: 2678,
        departamentCode: "143",
        description: "Administração da infra-estrutura portuária",
        cnae: "52311/01",
        activityBranch: "5231101",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2679,
        departamentCode: "157",
        description: "Atividades do Operador Portuário",
        cnae: "52311/02",
        activityBranch: "5231102",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2680,
        departamentCode: "157",
        description: "Gestão de terminais aquaviários ",
        cnae: "52311/03",
        activityBranch: "5231103",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2681,
        departamentCode: "23",
        description: "Atividades de agenciamento marítimo",
        cnae: "52320/00",
        activityBranch: "5232000",
        mcc: {
            code: 4411,
            description: "LINHAS DE CRUZEROS (CRUISE LINES)"
        }
    },
    {
        id: 2682,
        departamentCode: "157",
        description: "Serviços de praticagem",
        cnae: "52397/01",
        activityBranch: "5239701",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2683,
        departamentCode: "157",
        description: "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
        cnae: "52397/99",
        activityBranch: "5239799",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2684,
        departamentCode: "27",
        description: "Operação dos aeroportos e campos de aterrissagem",
        cnae: "52401/01",
        activityBranch: "5240101",
        mcc: {
            code: 4582,
            description: "AEROPORTOS E TERMINAIS DE AEROPORTOS"
        }
    },
    {
        id: 2685,
        departamentCode: "27",
        description: "Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem",
        cnae: "52401/99",
        activityBranch: "5240199",
        mcc: {
            code: 4582,
            description: "AEROPORTOS E TERMINAIS DE AEROPORTOS"
        }
    },
    {
        id: 2686,
        departamentCode: "157",
        description: "Comissaria de despachos",
        cnae: "52508/01",
        activityBranch: "5250801",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2687,
        departamentCode: "157",
        description: "Atividades de despachantes aduaneiros",
        cnae: "52508/02",
        activityBranch: "5250802",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2688,
        departamentCode: "21",
        description: "Agenciamento de cargas, exceto para o transporte marítimo",
        cnae: "52508/03",
        activityBranch: "5250803",
        mcc: {
            code: 4215,
            description: "CORREIOS - AEREO, TERRESTRE E TRANSITORIOS"
        }
    },
    {
        id: 2689,
        departamentCode: "21",
        description: "Organização logística do transporte de carga",
        cnae: "52508/04",
        activityBranch: "5250804",
        mcc: {
            code: 4215,
            description: "CORREIOS - AEREO, TERRESTRE E TRANSITORIOS"
        }
    },
    {
        id: 2690,
        departamentCode: "21",
        description: "Operador de transporte multimodal - OTM",
        cnae: "52508/05",
        activityBranch: "5250805",
        mcc: {
            code: 4215,
            description: "CORREIOS - AEREO, TERRESTRE E TRANSITORIOS"
        }
    },
    {
        id: 2691,
        departamentCode: "211",
        description: "Atividades do Correio Nacional",
        cnae: "53105/01",
        activityBranch: "5310501",
        mcc: {
            code: 9402,
            description: "POSTAGENS (POSTAGE STAMPS)"
        }
    },
    {
        id: 2692,
        departamentCode: "211",
        description: "Atividades de franqueadas e permissionárias do Correio Nacional",
        cnae: "53105/02",
        activityBranch: "5310502",
        mcc: {
            code: 9402,
            description: "POSTAGENS (POSTAGE STAMPS)"
        }
    },
    {
        id: 2693,
        departamentCode: "21",
        description: "Serviços de malote não realizados pelo Correio Nacional",
        cnae: "53202/01",
        activityBranch: "5320201",
        mcc: {
            code: 4215,
            description: "CORREIOS - AEREO, TERRESTRE E TRANSITORIOS"
        }
    },
    {
        id: 2694,
        departamentCode: "21",
        description: "Serviços de entrega rápida",
        cnae: "53202/02",
        activityBranch: "5320202",
        mcc: {
            code: 4215,
            description: "CORREIOS - AEREO, TERRESTRE E TRANSITORIOS"
        }
    },
    {
        id: 2695,
        departamentCode: "131",
        description: "Hotéis",
        cnae: "55108/01",
        activityBranch: "5510801",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2696,
        departamentCode: "131",
        description: "Apart-hotéis",
        cnae: "55108/02",
        activityBranch: "5510802",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2697,
        departamentCode: "131",
        description: "Motéis",
        cnae: "55108/03",
        activityBranch: "5510803",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2698,
        departamentCode: "131",
        description: "Albergues, exceto assistenciais",
        cnae: "55906/01",
        activityBranch: "5590601",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2699,
        departamentCode: "132",
        description: "Campings",
        cnae: "55906/02",
        activityBranch: "5590602",
        mcc: {
            code: 7033,
            description: "SERVICOS DE ACAMPAMENTOS"
        }
    },
    {
        id: 2700,
        departamentCode: "131",
        description: "Pensões (alojamento)",
        cnae: "55906/03",
        activityBranch: "5590603",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2701,
        departamentCode: "131",
        description: "Outros alojamentos não especificados anteriormente",
        cnae: "55906/99",
        activityBranch: "5590699",
        mcc: {
            code: 7011,
            description: "HOTEIS (HOTELS/MOTELS/RESORTS)"
        }
    },
    {
        id: 2702,
        departamentCode: "97",
        description: "Restaurantes e similares",
        cnae: "56112/01",
        activityBranch: "5611201",
        mcc: {
            code: 5812,
            description: "RESTAURANTES"
        }
    },
    {
        id: 2703,
        departamentCode: "98",
        description: "Bares e outros estabelecimentos especializados em servir bebidas",
        cnae: "56112/02",
        activityBranch: "5611202",
        mcc: {
            code: 5813,
            description: "BARES, PUBS E CASA NOTURNAS"
        }
    },
    {
        id: 2704,
        departamentCode: "99",
        description: "Lanchonetes, casas de chá, de sucos e similares",
        cnae: "56112/03",
        activityBranch: "5611203",
        mcc: {
            code: 5814,
            description: "LANCHONETES DE COMIDAS RAPIDAS (FAST FOOD)"
        }
    },
    {
        id: 2705,
        departamentCode: "75",
        description: "Serviços ambulantes de alimentação",
        cnae: "56121/00",
        activityBranch: "5612100",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2706,
        departamentCode: "75",
        description: "Fornecimento de alimentos preparados preponderantemente para empresas",
        cnae: "56201/01",
        activityBranch: "5620101",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2707,
        departamentCode: "96",
        description: "Serviços de alimentação para eventos e recepções - bufê",
        cnae: "56201/02",
        activityBranch: "5620102",
        mcc: {
            code: 5811,
            description: "DISTRIBUICAO E PRODUCAO DE ALIMENTOS"
        }
    },
    {
        id: 2708,
        departamentCode: "97",
        description: "Cantinas - serviços de alimentação privativos",
        cnae: "56201/03",
        activityBranch: "5620103",
        mcc: {
            code: 5812,
            description: "RESTAURANTES"
        }
    },
    {
        id: 2709,
        departamentCode: "75",
        description: "Fornecimento de alimentos preparados preponderantemente para consumo domiciliar",
        cnae: "56201/04",
        activityBranch: "5620104",
        mcc: {
            code: 5499,
            description: "LOJA DE ALIMENTOS VARIADOS (MISC FOOD S. - DEFAULT)"
        }
    },
    {
        id: 2710,
        departamentCode: "12",
        description: "Edição de livros",
        cnae: "58115/00",
        activityBranch: "5811500",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2711,
        departamentCode: "12",
        description: "Edição de jornais diários",
        cnae: "58123/01",
        activityBranch: "5812301",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2712,
        departamentCode: "12",
        description: "Edição de jornais não diários",
        cnae: "58123/02",
        activityBranch: "5812302",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2713,
        departamentCode: "12",
        description: "Edição de revistas",
        cnae: "58131/00",
        activityBranch: "5813100",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2714,
        departamentCode: "12",
        description: "Edição de cadastros, listas e outros produtos gráficos",
        cnae: "58191/00",
        activityBranch: "5819100",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2715,
        departamentCode: "12",
        description: "Edição integrada à impressão de livros",
        cnae: "58212/00",
        activityBranch: "5821200",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2716,
        departamentCode: "12",
        description: "Edição integrada à impressão de jornais diários",
        cnae: "58221/01",
        activityBranch: "5822101",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2717,
        departamentCode: "12",
        description: "Edição integrada à impressão de jornais não diários",
        cnae: "58221/02",
        activityBranch: "5822102",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2718,
        departamentCode: "12",
        description: "Edição integrada à impressão de revistas",
        cnae: "58239/00",
        activityBranch: "5823900",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2719,
        departamentCode: "12",
        description: "Edição integrada à impressão de cadastros, listas e outros produtos gráficos",
        cnae: "58298/00",
        activityBranch: "5829800",
        mcc: {
            code: 2741,
            description: "EDITORAS - PUBLICACOES E IMPRESSOES"
        }
    },
    {
        id: 2720,
        departamentCode: "170",
        description: "Estúdios cinematográficos",
        cnae: "59111/01",
        activityBranch: "5911101",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2721,
        departamentCode: "170",
        description: "Produção de filmes para publicidade",
        cnae: "59111/02",
        activityBranch: "5911102",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2722,
        departamentCode: "170",
        description: "Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
        cnae: "59111/99",
        activityBranch: "5911199",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2723,
        departamentCode: "170",
        description: "Serviços de dublagem",
        cnae: "59120/01",
        activityBranch: "5912001",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2724,
        departamentCode: "170",
        description: "Serviços de mixagem sonora em produção audiovisual",
        cnae: "59120/02",
        activityBranch: "5912002",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2725,
        departamentCode: "170",
        description: "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
        cnae: "59120/99",
        activityBranch: "5912099",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2726,
        departamentCode: "170",
        description: "Distribuição cinematográfica, de vídeo e de programas de televisão",
        cnae: "59138/00",
        activityBranch: "5913800",
        mcc: {
            code: 7829,
            description: "PRODUCAO E DISTRIBUICAO DE FILMES E FITAS DE VIDEOS"
        }
    },
    {
        id: 2727,
        departamentCode: "171",
        description: "Atividades de exibição cinematográfica",
        cnae: "59146/00",
        activityBranch: "5914600",
        mcc: {
            code: 7832,
            description: "CINEMAS, PRODUCOES CINEMATOGRAFICAS"
        }
    },
    {
        id: 2728,
        departamentCode: "143",
        description: "Atividades de gravação de som e de edição de música",
        cnae: "59201/00",
        activityBranch: "5920100",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2729,
        departamentCode: "34",
        description: "Atividades de rádio",
        cnae: "60101/00",
        activityBranch: "6010100",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2730,
        departamentCode: "34",
        description: "Atividades de televisão aberta",
        cnae: "60217/00",
        activityBranch: "6021700",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2731,
        departamentCode: "34",
        description: "Programadoras",
        cnae: "60225/01",
        activityBranch: "6022501",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2732,
        departamentCode: "34",
        description: "Atividades relacionadas à televisão por assinatura, exceto programadoras",
        cnae: "60225/02",
        activityBranch: "6022502",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2733,
        departamentCode: "32",
        description: "Serviços de telefonia fixa comutada - STFC",
        cnae: "61108/01",
        activityBranch: "6110801",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2734,
        departamentCode: "32",
        description: "Serviços de redes de transporte de telecomunicações - SRTT",
        cnae: "61108/02",
        activityBranch: "6110802",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2735,
        departamentCode: "32",
        description: "Serviços de comunicação multimídia - SCM",
        cnae: "61108/03",
        activityBranch: "6110803",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2736,
        departamentCode: "32",
        description: "Serviços de telecomunicações por fio não especificados anteriormente",
        cnae: "61108/99",
        activityBranch: "6110899",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2737,
        departamentCode: "32",
        description: "Telefonia móvel celular",
        cnae: "61205/01",
        activityBranch: "6120501",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2738,
        departamentCode: "32",
        description: "Serviço móvel especializado - SME",
        cnae: "61205/02",
        activityBranch: "6120502",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2739,
        departamentCode: "32",
        description: "Serviços de telecomunicações sem fio não especificados anteriormente",
        cnae: "61205/99",
        activityBranch: "6120599",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2740,
        departamentCode: "32",
        description: "Telecomunicações por satélite",
        cnae: "61302/00",
        activityBranch: "6130200",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2741,
        departamentCode: "34",
        description: "Operadoras de televisão por assinatura por cabo",
        cnae: "61418/00",
        activityBranch: "6141800",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2742,
        departamentCode: "34",
        description: "Operadoras de televisão por assinatura por microondas",
        cnae: "61426/00",
        activityBranch: "6142600",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2743,
        departamentCode: "34",
        description: "Operadoras de televisão por assinatura por satélite",
        cnae: "61434/00",
        activityBranch: "6143400",
        mcc: {
            code: 4899,
            description: "SERVICOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)"
        }
    },
    {
        id: 2744,
        departamentCode: "33",
        description: "Provedores de acesso às redes de comunicações",
        cnae: "61906/01",
        activityBranch: "6190601",
        mcc: {
            code: 4816,
            description: "REDES DE COMPUTADORES / SERVICOS DE INFORMACAO"
        }
    },
    {
        id: 2745,
        departamentCode: "32",
        description: "Provedores de voz sobre protocolo internet - VOIP",
        cnae: "61906/02",
        activityBranch: "6190602",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2746,
        departamentCode: "32",
        description: "Outras atividades de telecomunicações não especificadas anteriormente",
        cnae: "61906/99",
        activityBranch: "6190699",
        mcc: {
            code: 4814,
            description: "SERVICOS DE TELECOMUNICACAO"
        }
    },
    {
        id: 2747,
        departamentCode: "151",
        description: "Desenvolvimento de programas de computador sob encomenda",
        cnae: "62015/01",
        activityBranch: "6201501",
        mcc: {
            code: 7372,
            description: "PROGRAMACAO DE COMPUTADORES, DESIGN DE SISTEMAS INTEGRADOS E PROCESSAMENTO DE DADOS"
        }
    },
    {
        id: 2748,
        departamentCode: "212",
        description: "Web design",
        cnae: "62015/02",
        activityBranch: "6201502",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2749,
        departamentCode: "151",
        description: "Desenvolvimento e licenciamento de programas de computador customizáveis",
        cnae: "62023/00",
        activityBranch: "6202300",
        mcc: {
            code: 7372,
            description: "PROGRAMACAO DE COMPUTADORES, DESIGN DE SISTEMAS INTEGRADOS E PROCESSAMENTO DE DADOS"
        }
    },
    {
        id: 2750,
        departamentCode: "151",
        description: "Desenvolvimento e licenciamento de programas de computador não-customizáveis",
        cnae: "62031/00",
        activityBranch: "6203100",
        mcc: {
            code: 7372,
            description: "PROGRAMACAO DE COMPUTADORES, DESIGN DE SISTEMAS INTEGRADOS E PROCESSAMENTO DE DADOS"
        }
    },
    {
        id: 2751,
        departamentCode: "151",
        description: "Consultoria em tecnologia da informação",
        cnae: "62040/00",
        activityBranch: "6204000",
        mcc: {
            code: 7372,
            description: "PROGRAMACAO DE COMPUTADORES, DESIGN DE SISTEMAS INTEGRADOS E PROCESSAMENTO DE DADOS"
        }
    },
    {
        id: 2752,
        departamentCode: "152",
        description: "Suporte técnico, manutenção e outros serviços em tecnologia da informação",
        cnae: "62091/00",
        activityBranch: "6209100",
        mcc: {
            code: 7379,
            description: "COMPUTADORES: CONCERTOS E REPAROS"
        }
    },
    {
        id: 2753,
        departamentCode: "33",
        description: "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet",
        cnae: "63119/00",
        activityBranch: "6311900",
        mcc: {
            code: 4816,
            description: "REDES DE COMPUTADORES / SERVICOS DE INFORMACAO"
        }
    },
    {
        id: 2754,
        departamentCode: "33",
        description: "Portais, provedores de conteúdo e outros serviços de informação na internet",
        cnae: "63194/00",
        activityBranch: "6319400",
        mcc: {
            code: 4816,
            description: "REDES DE COMPUTADORES / SERVICOS DE INFORMACAO"
        }
    },
    {
        id: 2755,
        departamentCode: "57",
        description: "Agências de notícias",
        cnae: "63917/00",
        activityBranch: "6391700",
        mcc: {
            code: 5192,
            description: "ATAC. E DISTRIB. DE LIVROS, PERIODICOS E JORNAIS"
        }
    },
    {
        id: 2756,
        departamentCode: "143",
        description: "Outras atividades de prestação de serviços de informação não especificadas anteriormente",
        cnae: "63992/00",
        activityBranch: "6399200",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2757,
        departamentCode: "210",
        description: "Banco Central",
        cnae: "64107/00",
        activityBranch: "6410700",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2758,
        departamentCode: "126",
        description: "Bancos comerciais",
        cnae: "64212/00",
        activityBranch: "6421200",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2759,
        departamentCode: "126",
        description: "Bancos múltiplos, com carteira comercial",
        cnae: "64221/00",
        activityBranch: "6422100",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2760,
        departamentCode: "126",
        description: "Caixas econômicas",
        cnae: "64239/00",
        activityBranch: "6423900",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2761,
        departamentCode: "126",
        description: "Bancos cooperativos",
        cnae: "64247/01",
        activityBranch: "6424701",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2762,
        departamentCode: "126",
        description: "Cooperativas centrais de crédito",
        cnae: "64247/02",
        activityBranch: "6424702",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2763,
        departamentCode: "126",
        description: "Cooperativas de crédito mútuo",
        cnae: "64247/03",
        activityBranch: "6424703",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2764,
        departamentCode: "126",
        description: "Cooperativas de crédito rural",
        cnae: "64247/04",
        activityBranch: "6424704",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2765,
        departamentCode: "126",
        description: "Bancos múltiplos, sem carteira comercial",
        cnae: "64310/00",
        activityBranch: "6431000",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2766,
        departamentCode: "126",
        description: "Bancos de investimento",
        cnae: "64328/00",
        activityBranch: "6432800",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2767,
        departamentCode: "126",
        description: "Bancos de desenvolvimento",
        cnae: "64336/00",
        activityBranch: "6433600",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2768,
        departamentCode: "126",
        description: "Agências de fomento",
        cnae: "64344/00",
        activityBranch: "6434400",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2769,
        departamentCode: "126",
        description: "Sociedades de crédito imobiliário",
        cnae: "64352/01",
        activityBranch: "6435201",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2770,
        departamentCode: "126",
        description: "Associações de poupança e empréstimo",
        cnae: "64352/02",
        activityBranch: "6435202",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2771,
        departamentCode: "126",
        description: "Companhias hipotecárias",
        cnae: "64352/03",
        activityBranch: "6435203",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2772,
        departamentCode: "126",
        description: "Sociedades de crédito, financiamento e investimento - financeiras",
        cnae: "64361/00",
        activityBranch: "6436100",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2773,
        departamentCode: "126",
        description: "Sociedades de crédito ao microempreendedor",
        cnae: "64379/00",
        activityBranch: "6437900",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2774,
        departamentCode: "126",
        description: "Bancos de câmbio",
        cnae: "64387/01",
        activityBranch: "6438701",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2775,
        departamentCode: "126",
        description: "Outras instituições de intermediação não-monetária não especificadas anteriormente",
        cnae: "64387/99",
        activityBranch: "6438799",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2776,
        departamentCode: "126",
        description: "Arrendamento mercantil",
        cnae: "64409/00",
        activityBranch: "6440900",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2777,
        departamentCode: "126",
        description: "Sociedades de capitalização",
        cnae: "64506/00",
        activityBranch: "6450600",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2778,
        departamentCode: "126",
        description: "Holdings de instituições financeiras",
        cnae: "64611/00",
        activityBranch: "6461100",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2779,
        departamentCode: "212",
        description: "Holdings de instituições não-financeiras",
        cnae: "64620/00",
        activityBranch: "6462000",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2780,
        departamentCode: "212",
        description: "Outras sociedades de participação, exceto holdings",
        cnae: "64638/00",
        activityBranch: "6463800",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2781,
        departamentCode: "126",
        description: "Fundos de investimento, exceto previdenciários e imobiliários",
        cnae: "64701/01",
        activityBranch: "6470101",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2782,
        departamentCode: "126",
        description: "Fundos de investimento previdenciários",
        cnae: "64701/02",
        activityBranch: "6470102",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2783,
        departamentCode: "126",
        description: "Fundos de investimento imobiliários",
        cnae: "64701/03",
        activityBranch: "6470103",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2784,
        departamentCode: "128",
        description: "Sociedades de fomento mercantil - factoring",
        cnae: "64913/00",
        activityBranch: "6491300",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2785,
        departamentCode: "126",
        description: "Securitização de créditos",
        cnae: "64921/00",
        activityBranch: "6492100",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2786,
        departamentCode: "127",
        description: "Administração de consórcios para aquisição de bens e direitos",
        cnae: "64930/00",
        activityBranch: "6493000",
        mcc: {
            code: 6051,
            description: "INSTITUICOES NAO-FINANCEIRAS - MOEDA ESTRANGEIRA, ORDENS DE PAGAMENTO (SEM TRANSF. ELETRONICA) E CHEQUES DE VIAGEM"
        }
    },
    {
        id: 2787,
        departamentCode: "128",
        description: "Clubes de investimento",
        cnae: "64999/01",
        activityBranch: "6499901",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2788,
        departamentCode: "128",
        description: "Sociedades de investimento",
        cnae: "64999/02",
        activityBranch: "6499902",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2789,
        departamentCode: "126",
        description: "Fundo garantidor de crédito",
        cnae: "64999/03",
        activityBranch: "6499903",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2790,
        departamentCode: "126",
        description: "Caixas de financiamento de corporações",
        cnae: "64999/04",
        activityBranch: "6499904",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2791,
        departamentCode: "127",
        description: "Concessão de crédito pelas OSCIP",
        cnae: "64999/05",
        activityBranch: "6499905",
        mcc: {
            code: 6051,
            description: "INSTITUICOES NAO-FINANCEIRAS - MOEDA ESTRANGEIRA, ORDENS DE PAGAMENTO (SEM TRANSF. ELETRONICA) E CHEQUES DE VIAGEM"
        }
    },
    {
        id: 2792,
        departamentCode: "126",
        description: "Outras atividades de serviços financeiros não especificadas anteriormente",
        cnae: "64999/99",
        activityBranch: "6499999",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2793,
        departamentCode: "129",
        description: "Sociedade seguradora de seguros vida",
        cnae: "65111/01",
        activityBranch: "6511101",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2794,
        departamentCode: "129",
        description: "Planos de auxílio-funeral",
        cnae: "65111/02",
        activityBranch: "6511102",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2795,
        departamentCode: "129",
        description: "Sociedade seguradora de seguros não vida",
        cnae: "65120/00",
        activityBranch: "6512000",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2796,
        departamentCode: "129",
        description: "Sociedade seguradora de seguros saúde",
        cnae: "65201/00",
        activityBranch: "6520100",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2797,
        departamentCode: "129",
        description: "Resseguros",
        cnae: "65308/00",
        activityBranch: "6530800",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2798,
        departamentCode: "129",
        description: "Previdência complementar fechada",
        cnae: "65413/00",
        activityBranch: "6541300",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2799,
        departamentCode: "129",
        description: "Previdência complementar aberta",
        cnae: "65421/00",
        activityBranch: "6542100",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2800,
        departamentCode: "129",
        description: "Planos de saúde",
        cnae: "65502/00",
        activityBranch: "6550200",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2801,
        departamentCode: "128",
        description: "Bolsa de valores",
        cnae: "66118/01",
        activityBranch: "6611801",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2802,
        departamentCode: "128",
        description: "Bolsa de mercadorias",
        cnae: "66118/02",
        activityBranch: "6611802",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2803,
        departamentCode: "128",
        description: "Bolsa de mercadorias e futuros",
        cnae: "66118/03",
        activityBranch: "6611803",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2804,
        departamentCode: "128",
        description: "Administração de mercados de balcão organizados",
        cnae: "66118/04",
        activityBranch: "6611804",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2805,
        departamentCode: "128",
        description: "Corretoras de títulos e valores mobiliários",
        cnae: "66126/01",
        activityBranch: "6612601",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2806,
        departamentCode: "128",
        description: "Distribuidoras de títulos e valores mobiliários",
        cnae: "66126/02",
        activityBranch: "6612602",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2807,
        departamentCode: "127",
        description: "Corretoras de câmbio",
        cnae: "66126/03",
        activityBranch: "6612603",
        mcc: {
            code: 6051,
            description: "INSTITUICOES NAO-FINANCEIRAS - MOEDA ESTRANGEIRA, ORDENS DE PAGAMENTO (SEM TRANSF. ELETRONICA) E CHEQUES DE VIAGEM"
        }
    },
    {
        id: 2808,
        departamentCode: "128",
        description: "Corretoras de contratos de mercadorias",
        cnae: "66126/04",
        activityBranch: "6612604",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2809,
        departamentCode: "128",
        description: "Agentes de investimentos em aplicações financeiras",
        cnae: "66126/05",
        activityBranch: "6612605",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2810,
        departamentCode: "127",
        description: "Administração de cartões de crédito",
        cnae: "66134/00",
        activityBranch: "6613400",
        mcc: {
            code: 6051,
            description: "INSTITUICOES NAO-FINANCEIRAS - MOEDA ESTRANGEIRA, ORDENS DE PAGAMENTO (SEM TRANSF. ELETRONICA) E CHEQUES DE VIAGEM"
        }
    },
    {
        id: 2811,
        departamentCode: "126",
        description: "Serviços de liquidação e custódia",
        cnae: "66193/01",
        activityBranch: "6619301",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2812,
        departamentCode: "126",
        description: "Correspondentes de instituições financeiras",
        cnae: "66193/02",
        activityBranch: "6619302",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2813,
        departamentCode: "126",
        description: "Representações de bancos estrangeiros",
        cnae: "66193/03",
        activityBranch: "6619303",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2814,
        departamentCode: "125",
        description: "Caixas eletrônicos",
        cnae: "66193/04",
        activityBranch: "6619304",
        mcc: {
            code: 6011,
            description: "INSTITUICOES FINANCEIRAS - DESEMBOLSOS MANUAIS EM DINHEIRO"
        }
    },
    {
        id: 2815,
        departamentCode: "126",
        description: "Operadoras de cartões de débito",
        cnae: "66193/05",
        activityBranch: "6619305",
        mcc: {
            code: 6012,
            description: "INSTITUICOES FINANCEIRAS - MERCADORIAS E SERVICOS"
        }
    },
    {
        id: 2816,
        departamentCode: "212",
        description: "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente",
        cnae: "66193/99",
        activityBranch: "6619399",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2817,
        departamentCode: "129",
        description: "Peritos e avaliadores de seguros",
        cnae: "66215/01",
        activityBranch: "6621501",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2818,
        departamentCode: "209",
        description: "Auditoria e consultoria atuarial",
        cnae: "66215/02",
        activityBranch: "6621502",
        mcc: {
            code: 8931,
            description: "SERVICOS DE CONTABILIDADE E AUDITORIA"
        }
    },
    {
        id: 2819,
        departamentCode: "129",
        description: "Corretores e agentes de seguros, de planos de previdência complementar e de saúde",
        cnae: "66223/00",
        activityBranch: "6622300",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2820,
        departamentCode: "129",
        description: "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente",
        cnae: "66291/00",
        activityBranch: "6629100",
        mcc: {
            code: 6300,
            description: "VENDA DE SEGUROS (INSURANCE SALES/UNDERWRITE)"
        }
    },
    {
        id: 2821,
        departamentCode: "128",
        description: "Atividades de administração de fundos por contrato ou comissão",
        cnae: "66304/00",
        activityBranch: "6630400",
        mcc: {
            code: 6211,
            description: "CORRETORES DE IMOVEIS (SECURITIES BROKERS/DEALERS)"
        }
    },
    {
        id: 2822,
        departamentCode: "130",
        description: "Compra e venda de imóveis próprios",
        cnae: "68102/01",
        activityBranch: "6810201",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2823,
        departamentCode: "130",
        description: "Aluguel de imóveis próprios",
        cnae: "68102/02",
        activityBranch: "6810202",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2824,
        departamentCode: "130",
        description: "Loteamento de imóveis próprios",
        cnae: "68102/03",
        activityBranch: "6810203",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2825,
        departamentCode: "130",
        description: "Corretagem na compra e venda e avaliação de imóveis",
        cnae: "68218/01",
        activityBranch: "6821801",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2826,
        departamentCode: "130",
        description: "Corretagem no aluguel de imóveis",
        cnae: "68218/02",
        activityBranch: "6821802",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2827,
        departamentCode: "130",
        description: "Gestão e administração da propriedade imobiliária",
        cnae: "68226/00",
        activityBranch: "6822600",
        mcc: {
            code: 6513,
            description: "CORRETOR DE IMOVEIS (ALUGUEL)"
        }
    },
    {
        id: 2828,
        departamentCode: "195",
        description: "Serviços advocatícios",
        cnae: "69117/01",
        activityBranch: "6911701",
        mcc: {
            code: 8111,
            description: "SERVICOS JURIDICOS - ADVOGADOS"
        }
    },
    {
        id: 2829,
        departamentCode: "195",
        description: "Atividades auxiliares da justiça",
        cnae: "69117/02",
        activityBranch: "6911702",
        mcc: {
            code: 8111,
            description: "SERVICOS JURIDICOS - ADVOGADOS"
        }
    },
    {
        id: 2830,
        departamentCode: "143",
        description: "Agente de propriedade industrial",
        cnae: "69117/03",
        activityBranch: "6911703",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2831,
        departamentCode: "210",
        description: "Cartórios",
        cnae: "69125/00",
        activityBranch: "6912500",
        mcc: {
            code: 9311,
            description: "PAGAMENTOS DE IMPOSTOS (TAX PAYMENTS)"
        }
    },
    {
        id: 2832,
        departamentCode: "209",
        description: "Atividades de contabilidade",
        cnae: "69206/01",
        activityBranch: "6920601",
        mcc: {
            code: 8931,
            description: "SERVICOS DE CONTABILIDADE E AUDITORIA"
        }
    },
    {
        id: 2833,
        departamentCode: "209",
        description: "Atividades de consultoria e auditoria contábil e tributária",
        cnae: "69206/02",
        activityBranch: "6920602",
        mcc: {
            code: 8931,
            description: "SERVICOS DE CONTABILIDADE E AUDITORIA"
        }
    },
    {
        id: 2834,
        departamentCode: "153",
        description: "Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica",
        cnae: "70204/00",
        activityBranch: "7020400",
        mcc: {
            code: 7392,
            description: "SERVICOS DE GERENCIAMENTO, CONSULTORIA E RELACOES PUBLICAS"
        }
    },
    {
        id: 2835,
        departamentCode: "208",
        description: "Serviços de arquitetura",
        cnae: "71111/00",
        activityBranch: "7111100",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2836,
        departamentCode: "208",
        description: "Serviços de engenharia",
        cnae: "71120/00",
        activityBranch: "7112000",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2837,
        departamentCode: "208",
        description: "Serviços de cartografia, topografia e geodésia",
        cnae: "71197/01",
        activityBranch: "7119701",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2838,
        departamentCode: "208",
        description: "Atividades de estudos geológicos",
        cnae: "71197/02",
        activityBranch: "7119702",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2839,
        departamentCode: "208",
        description: "Serviços de desenho técnico relacionados à arquitetura e engenharia",
        cnae: "71197/03",
        activityBranch: "7119703",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2840,
        departamentCode: "212",
        description: "Serviços de perícia técnica relacionados à segurança do trabalho",
        cnae: "71197/04",
        activityBranch: "7119704",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2841,
        departamentCode: "208",
        description: "Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente",
        cnae: "71197/99",
        activityBranch: "7119799",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2842,
        departamentCode: "207",
        description: "Testes e análises técnicas",
        cnae: "71201/00",
        activityBranch: "7120100",
        mcc: {
            code: 8734,
            description: "LABORATORIOS DE TESTES (NAO MEDICOS)"
        }
    },
    {
        id: 2843,
        departamentCode: "212",
        description: "Pesquisa e desenvolvimento experimental em ciências físicas e naturais",
        cnae: "72100/00",
        activityBranch: "7210000",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2844,
        departamentCode: "212",
        description: "Pesquisa e desenvolvimento experimental em ciências sociais e humanas",
        cnae: "72207/00",
        activityBranch: "7220700",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2845,
        departamentCode: "144",
        description: "Agências de publicidade",
        cnae: "73114/00",
        activityBranch: "7311400",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2846,
        departamentCode: "144",
        description: "Agenciamento de espaços para publicidade, exceto em veículos de comunicação",
        cnae: "73122/00",
        activityBranch: "7312200",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2847,
        departamentCode: "144",
        description: "Criação de estandes para feiras e exposições",
        cnae: "73190/01",
        activityBranch: "7319001",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2848,
        departamentCode: "144",
        description: "Promoção de vendas",
        cnae: "73190/02",
        activityBranch: "7319002",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2849,
        departamentCode: "115",
        description: "Marketing direto",
        cnae: "73190/03",
        activityBranch: "7319003",
        mcc: {
            code: 5969,
            description: "OUTROS VENDEDORES DE MARKETING DIRETO"
        }
    },
    {
        id: 2850,
        departamentCode: "144",
        description: "Consultoria em publicidade",
        cnae: "73190/04",
        activityBranch: "7319004",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2851,
        departamentCode: "144",
        description: "Outras atividades de publicidade não especificadas anteriormente",
        cnae: "73190/99",
        activityBranch: "7319099",
        mcc: {
            code: 7311,
            description: "PUBLICIDADES"
        }
    },
    {
        id: 2852,
        departamentCode: "212",
        description: "Pesquisas de mercado e de opinião pública",
        cnae: "73203/00",
        activityBranch: "7320300",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2853,
        departamentCode: "208",
        description: "Design de interiores",
        cnae: "74102/02",
        activityBranch: "7410202",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 2854,
        departamentCode: "212",
        description: "Design de produto",
        cnae: "74102/03",
        activityBranch: "7410203",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2855,
        departamentCode: "212",
        description: "Atividades de design não especificadas anteriormente",
        cnae: "74102/99",
        activityBranch: "7410299",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2856,
        departamentCode: "135",
        description: "Atividades de produção de fotografias, exceto aérea e submarina",
        cnae: "74200/01",
        activityBranch: "7420001",
        mcc: {
            code: 7221,
            description: "ESTUDIOS FOTOGRAFICOS"
        }
    },
    {
        id: 2857,
        departamentCode: "135",
        description: "Atividades de produção de fotografias aéreas e submarinas",
        cnae: "74200/02",
        activityBranch: "7420002",
        mcc: {
            code: 7221,
            description: "ESTUDIOS FOTOGRAFICOS"
        }
    },
    {
        id: 2858,
        departamentCode: "156",
        description: "Laboratórios fotográficos",
        cnae: "74200/03",
        activityBranch: "7420003",
        mcc: {
            code: 7395,
            description: "LABORATORIO DE TRATAMENTO E REVELACAO DE FOTOS"
        }
    },
    {
        id: 2859,
        departamentCode: "135",
        description: "Filmagem de festas e eventos",
        cnae: "74200/04",
        activityBranch: "7420004",
        mcc: {
            code: 7221,
            description: "ESTUDIOS FOTOGRAFICOS"
        }
    },
    {
        id: 2860,
        departamentCode: "143",
        description: "Serviços de microfilmagem",
        cnae: "74200/05",
        activityBranch: "7420005",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2861,
        departamentCode: "157",
        description: "Serviços de tradução, interpretação e similares",
        cnae: "74901/01",
        activityBranch: "7490101",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2862,
        departamentCode: "212",
        description: "Escafandria e mergulho",
        cnae: "74901/02",
        activityBranch: "7490102",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2863,
        departamentCode: "2",
        description: "Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias",
        cnae: "74901/03",
        activityBranch: "7490103",
        mcc: {
            code: 763,
            description: "COOPERATIVA AGRICOLA"
        }
    },
    {
        id: 2864,
        departamentCode: "212",
        description: "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários",
        cnae: "74901/04",
        activityBranch: "7490104",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2865,
        departamentCode: "178",
        description: "Agenciamento de profissionais para atividades esportivas, culturais e artísticas",
        cnae: "74901/05",
        activityBranch: "7490105",
        mcc: {
            code: 7941,
            description: "ESPORTES COMERCIAIS, CAMPOS ESPORTIVOS PROFISSIONAIS, CLUBES E PROMOTORES DE ESPORTES"
        }
    },
    {
        id: 2866,
        departamentCode: "212",
        description: "Outras atividades profissionais, científicas e técnicas não especificadas anteriormente",
        cnae: "74901/99",
        activityBranch: "7490199",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2867,
        departamentCode: "1",
        description: "Atividades veterinárias",
        cnae: "75001/00",
        activityBranch: "7500100",
        mcc: {
            code: 742,
            description: "VETERINARIA"
        }
    },
    {
        id: 2868,
        departamentCode: "158",
        description: "Locação de automóveis sem condutor",
        cnae: "77110/00",
        activityBranch: "7711000",
        mcc: {
            code: 7512,
            description: "ALUGUEL DE AUTOMOVEIS (AUTOMOBILE RENTAL AGENCY)"
        }
    },
    {
        id: 2869,
        departamentCode: "24",
        description: "Locação de embarcações sem tripulação, exceto para fins recreativos",
        cnae: "77195/01",
        activityBranch: "7719501",
        mcc: {
            code: 4457,
            description: "LOCACAO DE BARCOS"
        }
    },
    {
        id: 2870,
        departamentCode: "157",
        description: "Locação de aeronaves sem tripulação",
        cnae: "77195/02",
        activityBranch: "7719502",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2871,
        departamentCode: "158",
        description: "Locação de outros meios de transporte não especificados anteriormente, sem condutor",
        cnae: "77195/99",
        activityBranch: "7719599",
        mcc: {
            code: 7512,
            description: "ALUGUEL DE AUTOMOVEIS (AUTOMOBILE RENTAL AGENCY)"
        }
    },
    {
        id: 2872,
        departamentCode: "106",
        description: "Aluguel de equipamentos recreativos e esportivos",
        cnae: "77217/00",
        activityBranch: "7721700",
        mcc: {
            code: 5941,
            description: "SERVICOS GERIAS PARA ESPORTES"
        }
    },
    {
        id: 2873,
        departamentCode: "172",
        description: "Aluguel de fitas de vídeo, DVDs e similares",
        cnae: "77225/00",
        activityBranch: "7722500",
        mcc: {
            code: 7841,
            description: "LOJAS DE VIDEOS"
        }
    },
    {
        id: 2874,
        departamentCode: "140",
        description: "Aluguel de objetos do vestuário, jóias e acessórios",
        cnae: "77233/00",
        activityBranch: "7723300",
        mcc: {
            code: 7296,
            description: "ALUGUEL DE ROUPAS, TRAJES, ROUPAS FORMAIS, UNIFORMES"
        }
    },
    {
        id: 2875,
        departamentCode: "180",
        description: "Aluguel de aparelhos de jogos eletrônicos",
        cnae: "77292/01",
        activityBranch: "7729201",
        mcc: {
            code: 7994,
            description: "ESTABELECIMENTOS DE VIDEO-GAMES"
        }
    },
    {
        id: 2876,
        departamentCode: "155",
        description: "Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais",
        cnae: "77292/02",
        activityBranch: "7729202",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2877,
        departamentCode: "155",
        description: "Aluguel de material médico",
        cnae: "77292/03",
        activityBranch: "7729203",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2878,
        departamentCode: "155",
        description: "Aluguel de outros objetos pessoais e domésticos não especificados anteriormente",
        cnae: "77292/99",
        activityBranch: "7729299",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2879,
        departamentCode: "155",
        description: "Aluguel de máquinas e equipamentos agrícolas sem operador",
        cnae: "77314/00",
        activityBranch: "7731400",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2880,
        departamentCode: "155",
        description: "Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes",
        cnae: "77322/01",
        activityBranch: "7732201",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2881,
        departamentCode: "155",
        description: "Aluguel de andaimes",
        cnae: "77322/02",
        activityBranch: "7732202",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2882,
        departamentCode: "155",
        description: "Aluguel de máquinas e equipamentos para escritório",
        cnae: "77331/00",
        activityBranch: "7733100",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2883,
        departamentCode: "155",
        description: "Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador",
        cnae: "77390/01",
        activityBranch: "7739001",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2884,
        departamentCode: "155",
        description: "Aluguel de equipamentos científicos, médicos e hospitalares, sem operador",
        cnae: "77390/02",
        activityBranch: "7739002",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2885,
        departamentCode: "155",
        description: "Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes",
        cnae: "77390/03",
        activityBranch: "7739003",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2886,
        departamentCode: "155",
        description: "Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, sem operador",
        cnae: "77390/99",
        activityBranch: "7739099",
        mcc: {
            code: 7394,
            description: "ALUGUEL E LEASING DE EQUIPAMENTOS, ALUGUEL DE FERRAMENTAS, MOVEIS E ELETRODOMESTICOS"
        }
    },
    {
        id: 2887,
        departamentCode: "153",
        description: "Gestão de ativos intangíveis não-financeiros",
        cnae: "77403/00",
        activityBranch: "7740300",
        mcc: {
            code: 7392,
            description: "SERVICOS DE GERENCIAMENTO, CONSULTORIA E RELACOES PUBLICAS"
        }
    },
    {
        id: 2888,
        departamentCode: "150",
        description: "Seleção e agenciamento de mão-de-obra",
        cnae: "78108/00",
        activityBranch: "7810800",
        mcc: {
            code: 7361,
            description: "AGENCIAS DE EMPREGO"
        }
    },
    {
        id: 2889,
        departamentCode: "150",
        description: "Locação de mão-de-obra temporária",
        cnae: "78205/00",
        activityBranch: "7820500",
        mcc: {
            code: 7361,
            description: "AGENCIAS DE EMPREGO"
        }
    },
    {
        id: 2890,
        departamentCode: "150",
        description: "Fornecimento e gestão de recursos humanos para terceiros",
        cnae: "78302/00",
        activityBranch: "7830200",
        mcc: {
            code: 7361,
            description: "AGENCIAS DE EMPREGO"
        }
    },
    {
        id: 2891,
        departamentCode: "28",
        description: "Agências de viagens",
        cnae: "79112/00",
        activityBranch: "7911200",
        mcc: {
            code: 4722,
            description: "AGENCIAS DE VIAGENS (TRAVEL AGENCIES)"
        }
    },
    {
        id: 2892,
        departamentCode: "28",
        description: "Operadores turísticos",
        cnae: "79121/00",
        activityBranch: "7912100",
        mcc: {
            code: 4722,
            description: "AGENCIAS DE VIAGENS (TRAVEL AGENCIES)"
        }
    },
    {
        id: 2893,
        departamentCode: "28",
        description: "Serviços de reservas e outros serviços de turismo não especificados anteriormente",
        cnae: "79902/00",
        activityBranch: "7990200",
        mcc: {
            code: 4722,
            description: "AGENCIAS DE VIAGENS (TRAVEL AGENCIES)"
        }
    },
    {
        id: 2894,
        departamentCode: "154",
        description: "Atividades de vigilância e segurança privada",
        cnae: "80111/01",
        activityBranch: "8011101",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2895,
        departamentCode: "154",
        description: "Serviços de adestramento de cães de guarda",
        cnae: "80111/02",
        activityBranch: "8011102",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2896,
        departamentCode: "154",
        description: "Atividades de transporte de valores",
        cnae: "80129/00",
        activityBranch: "8012900",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2897,
        departamentCode: "154",
        description: "Atividades de monitoramento de sistemas de segurança eletrônico",
        cnae: "80200/01",
        activityBranch: "8020001",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2898,
        departamentCode: "154",
        description: "Outras atividades de serviços de segurança",
        cnae: "80200/02",
        activityBranch: "8020002",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2899,
        departamentCode: "154",
        description: "Atividades de investigação particular",
        cnae: "80307/00",
        activityBranch: "8030700",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 2900,
        departamentCode: "149",
        description: "Serviços combinados para apoio a edifícios, exceto condomínios prediais",
        cnae: "81117/00",
        activityBranch: "8111700",
        mcc: {
            code: 7349,
            description: "SERVICO LIMPEZA E MANUTENCAO"
        }
    },
    {
        id: 2901,
        departamentCode: "149",
        description: "Condomínios prediais",
        cnae: "81125/00",
        activityBranch: "8112500",
        mcc: {
            code: 7349,
            description: "SERVICO LIMPEZA E MANUTENCAO"
        }
    },
    {
        id: 2902,
        departamentCode: "149",
        description: "Limpeza em prédios e em domicílios",
        cnae: "81214/00",
        activityBranch: "8121400",
        mcc: {
            code: 7349,
            description: "SERVICO LIMPEZA E MANUTENCAO"
        }
    },
    {
        id: 2903,
        departamentCode: "148",
        description: "Imunização e controle de pragas urbanas",
        cnae: "81222/00",
        activityBranch: "8122200",
        mcc: {
            code: 7342,
            description: "SERVICOS DE DESINFECCAO E EXTERMINIO"
        }
    },
    {
        id: 2904,
        departamentCode: "149",
        description: "Atividades de limpeza não especificadas anteriormente",
        cnae: "81290/00",
        activityBranch: "8129000",
        mcc: {
            code: 7349,
            description: "SERVICO LIMPEZA E MANUTENCAO"
        }
    },
    {
        id: 2905,
        departamentCode: "3",
        description: "Atividades paisagísticas",
        cnae: "81303/00",
        activityBranch: "8130300",
        mcc: {
            code: 780,
            description: "SERVICOS DE PAISAGISMO E HORTICULTURA"
        }
    },
    {
        id: 2906,
        departamentCode: "153",
        description: "Serviços combinados de escritório e apoio administrativo",
        cnae: "82113/00",
        activityBranch: "8211300",
        mcc: {
            code: 7392,
            description: "SERVICOS DE GERENCIAMENTO, CONSULTORIA E RELACOES PUBLICAS"
        }
    },
    {
        id: 2907,
        departamentCode: "147",
        description: "Fotocópias",
        cnae: "82199/01",
        activityBranch: "8219901",
        mcc: {
            code: 7338,
            description: "SERVICOS DE COPIA RAPIDA, REPRODUCAO E BLUEPRINTING"
        }
    },
    {
        id: 2908,
        departamentCode: "157",
        description: "Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente",
        cnae: "82199/99",
        activityBranch: "8219999",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2909,
        departamentCode: "115",
        description: "Atividades de teleatendimento",
        cnae: "82202/00",
        activityBranch: "8220200",
        mcc: {
            code: 5969,
            description: "OUTROS VENDEDORES DE MARKETING DIRETO"
        }
    },
    {
        id: 2910,
        departamentCode: "179",
        description: "Serviços de organização de feiras, congressos, exposições e festas",
        cnae: "82300/01",
        activityBranch: "8230001",
        mcc: {
            code: 7991,
            description: "ATRACOES E EXPOSICOES TURISTICAS"
        }
    },
    {
        id: 2911,
        departamentCode: "96",
        description: "Casas de festas e eventos",
        cnae: "82300/02",
        activityBranch: "8230002",
        mcc: {
            code: 5811,
            description: "DISTRIBUICAO E PRODUCAO DE ALIMENTOS"
        }
    },
    {
        id: 2912,
        departamentCode: "157",
        description: "Atividades de cobrança e informações cadastrais",
        cnae: "82911/00",
        activityBranch: "8291100",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2913,
        departamentCode: "157",
        description: "Envasamento e empacotamento sob contrato",
        cnae: "82920/00",
        activityBranch: "8292000",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2914,
        departamentCode: "35",
        description: "Medição de consumo de energia elétrica, gás e água",
        cnae: "82997/01",
        activityBranch: "8299701",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 2915,
        departamentCode: "157",
        description: "Emissão de vales-alimentação, vales-transporte e similares",
        cnae: "82997/02",
        activityBranch: "8299702",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 2916,
        departamentCode: "13",
        description: "Serviços de gravação de carimbos, exceto confecção",
        cnae: "82997/03",
        activityBranch: "8299703",
        mcc: {
            code: 2791,
            description: "TIPOGRAFIA, FABRICACAO DE CHAPAS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 2917,
        departamentCode: "212",
        description: "Leiloeiros independentes",
        cnae: "82997/04",
        activityBranch: "8299704",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2918,
        departamentCode: "212",
        description: "Serviços de levantamento de fundos sob contrato",
        cnae: "82997/05",
        activityBranch: "8299705",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 2919,
        departamentCode: "181",
        description: "Casas lotéricas",
        cnae: "82997/06",
        activityBranch: "8299706",
        mcc: {
            code: 7995,
            description: "CASSINOS, LOTERIAS E JOGOS DE AZAR"
        }
    },
    {
        id: 2920,
        departamentCode: "33",
        description: "Salas de acesso à internet",
        cnae: "82997/07",
        activityBranch: "8299707",
        mcc: {
            code: 4816,
            description: "REDES DE COMPUTADORES / SERVICOS DE INFORMACAO"
        }
    },
    {
        id: 2921,
        departamentCode: "143",
        description: "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente",
        cnae: "82997/99",
        activityBranch: "8299799",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 2922,
        departamentCode: "210",
        description: "Administração pública em geral",
        cnae: "84116/00",
        activityBranch: "8411600",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2923,
        departamentCode: "210",
        description: "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais",
        cnae: "84124/00",
        activityBranch: "8412400",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2924,
        departamentCode: "210",
        description: "Regulação das atividades econômicas",
        cnae: "84132/00",
        activityBranch: "8413200",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2925,
        departamentCode: "210",
        description: "Relações exteriores",
        cnae: "84213/00",
        activityBranch: "8421300",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2926,
        departamentCode: "210",
        description: "Defesa",
        cnae: "84221/00",
        activityBranch: "8422100",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2927,
        departamentCode: "210",
        description: "Justiça",
        cnae: "84230/00",
        activityBranch: "8423000",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2928,
        departamentCode: "210",
        description: "Segurança e ordem pública",
        cnae: "84248/00",
        activityBranch: "8424800",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2929,
        departamentCode: "210",
        description: "Defesa Civil",
        cnae: "84256/00",
        activityBranch: "8425600",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2930,
        departamentCode: "210",
        description: "Seguridade social obrigatória",
        cnae: "84302/00",
        activityBranch: "8430200",
        mcc: {
            code: 9399,
            description: "SERVICOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)"
        }
    },
    {
        id: 2931,
        departamentCode: "201",
        description: "Educação infantil - creche",
        cnae: "85112/00",
        activityBranch: "8511200",
        mcc: {
            code: 8351,
            description: "SERVICOS DE CUIDADOS DE CRIANCAS (CHILD CARE SVCS)"
        }
    },
    {
        id: 2932,
        departamentCode: "201",
        description: "Educação infantil - pré-escola",
        cnae: "85121/00",
        activityBranch: "8512100",
        mcc: {
            code: 8351,
            description: "SERVICOS DE CUIDADOS DE CRIANCAS (CHILD CARE SVCS)"
        }
    },
    {
        id: 2933,
        departamentCode: "196",
        description: "Ensino fundamental",
        cnae: "85139/00",
        activityBranch: "8513900",
        mcc: {
            code: 8211,
            description: "EDUCACAO PRIMARIA E SECUNDARIA (ELEM./SEC.S.)"
        }
    },
    {
        id: 2934,
        departamentCode: "196",
        description: "Ensino médio",
        cnae: "85201/00",
        activityBranch: "8520100",
        mcc: {
            code: 8211,
            description: "EDUCACAO PRIMARIA E SECUNDARIA (ELEM./SEC.S.)"
        }
    },
    {
        id: 2935,
        departamentCode: "197",
        description: "Educação superior - graduação",
        cnae: "85317/00",
        activityBranch: "8531700",
        mcc: {
            code: 8220,
            description: "UNIVERSIDADES E FACULDADES (COLLEGES/UNIV/JC/PROF.)"
        }
    },
    {
        id: 2936,
        departamentCode: "197",
        description: "Educação superior - graduação e pós-graduação",
        cnae: "85325/00",
        activityBranch: "8532500",
        mcc: {
            code: 8220,
            description: "UNIVERSIDADES E FACULDADES (COLLEGES/UNIV/JC/PROF.)"
        }
    },
    {
        id: 2937,
        departamentCode: "197",
        description: "Educação superior - pós-graduação e extensão",
        cnae: "85333/00",
        activityBranch: "8533300",
        mcc: {
            code: 8220,
            description: "UNIVERSIDADES E FACULDADES (COLLEGES/UNIV/JC/PROF.)"
        }
    },
    {
        id: 2938,
        departamentCode: "199",
        description: "Educação profissional de nível técnico",
        cnae: "85414/00",
        activityBranch: "8541400",
        mcc: {
            code: 8249,
            description: "ESCOLA DE NEGOCIOS/VOCACOES (TRADE/VOCATIONS S.)"
        }
    },
    {
        id: 2939,
        departamentCode: "199",
        description: "Educação profissional de nível tecnológico",
        cnae: "85422/00",
        activityBranch: "8542200",
        mcc: {
            code: 8249,
            description: "ESCOLA DE NEGOCIOS/VOCACOES (TRADE/VOCATIONS S.)"
        }
    },
    {
        id: 2940,
        departamentCode: "198",
        description: "Administração de caixas escolares",
        cnae: "85503/01",
        activityBranch: "8550301",
        mcc: {
            code: 8244,
            description: "ESCOLA DE COMERCIOS E SECRETARIADO (BUS./SEC. SCHOOL)"
        }
    },
    {
        id: 2941,
        departamentCode: "198",
        description: "Atividades de apoio à educação, exceto caixas escolares",
        cnae: "85503/02",
        activityBranch: "8550302",
        mcc: {
            code: 8244,
            description: "ESCOLA DE COMERCIOS E SECRETARIADO (BUS./SEC. SCHOOL)"
        }
    },
    {
        id: 2942,
        departamentCode: "200",
        description: "Ensino de esportes",
        cnae: "85911/00",
        activityBranch: "8591100",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2943,
        departamentCode: "173",
        description: "Ensino de dança",
        cnae: "85929/01",
        activityBranch: "8592901",
        mcc: {
            code: 7911,
            description: "SALOES DE DANCA, ESTUDIOS E ESCOLAS"
        }
    },
    {
        id: 2944,
        departamentCode: "200",
        description: "Ensino de artes cênicas, exceto dança",
        cnae: "85929/02",
        activityBranch: "8592902",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2945,
        departamentCode: "200",
        description: "Ensino de música",
        cnae: "85929/03",
        activityBranch: "8592903",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2946,
        departamentCode: "200",
        description: "Ensino de arte e cultura não especificado anteriormente",
        cnae: "85929/99",
        activityBranch: "8592999",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2947,
        departamentCode: "200",
        description: "Ensino de idiomas",
        cnae: "85937/00",
        activityBranch: "8593700",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2948,
        departamentCode: "200",
        description: "Formação de condutores",
        cnae: "85996/01",
        activityBranch: "8599601",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2949,
        departamentCode: "200",
        description: "Cursos de pilotagem",
        cnae: "85996/02",
        activityBranch: "8599602",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2950,
        departamentCode: "198",
        description: "Treinamento em informática",
        cnae: "85996/03",
        activityBranch: "8599603",
        mcc: {
            code: 8244,
            description: "ESCOLA DE COMERCIOS E SECRETARIADO (BUS./SEC. SCHOOL)"
        }
    },
    {
        id: 2951,
        departamentCode: "200",
        description: "Treinamento em desenvolvimento profissional e gerencial",
        cnae: "85996/04",
        activityBranch: "8599604",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2952,
        departamentCode: "200",
        description: "Cursos preparatórios para concursos",
        cnae: "85996/05",
        activityBranch: "8599605",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2953,
        departamentCode: "200",
        description: "Outras atividades de ensino não especificadas anteriormente",
        cnae: "85996/99",
        activityBranch: "8599699",
        mcc: {
            code: 8299,
            description: "COLEGIOS (SCHOOLS)"
        }
    },
    {
        id: 2954,
        departamentCode: "192",
        description: "Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências",
        cnae: "86101/01",
        activityBranch: "8610101",
        mcc: {
            code: 8062,
            description: "HOSPITAIS"
        }
    },
    {
        id: 2955,
        departamentCode: "192",
        description: "Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências",
        cnae: "86101/02",
        activityBranch: "8610102",
        mcc: {
            code: 8062,
            description: "HOSPITAIS"
        }
    },
    {
        id: 2956,
        departamentCode: "17",
        description: "UTI móvel",
        cnae: "86216/01",
        activityBranch: "8621601",
        mcc: {
            code: 4119,
            description: "AMBULANCIAS"
        }
    },
    {
        id: 2957,
        departamentCode: "17",
        description: "Serviços móveis de atendimento a urgências, exceto por UTI móvel",
        cnae: "86216/02",
        activityBranch: "8621602",
        mcc: {
            code: 4119,
            description: "AMBULANCIAS"
        }
    },
    {
        id: 2958,
        departamentCode: "17",
        description: "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências",
        cnae: "86224/00",
        activityBranch: "8622400",
        mcc: {
            code: 4119,
            description: "AMBULANCIAS"
        }
    },
    {
        id: 2959,
        departamentCode: "194",
        description: "Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos",
        cnae: "86305/01",
        activityBranch: "8630501",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2960,
        departamentCode: "194",
        description: "Atividade médica ambulatorial com recursos para realização de exames complementares",
        cnae: "86305/02",
        activityBranch: "8630502",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2961,
        departamentCode: "186",
        description: "Atividade médica ambulatorial restrita a consultas",
        cnae: "86305/03",
        activityBranch: "8630503",
        mcc: {
            code: 8011,
            description: "MEDICOS (CLINICAS E CONSULTORIOS)"
        }
    },
    {
        id: 2962,
        departamentCode: "187",
        description: "Atividade odontológica",
        cnae: "86305/04",
        activityBranch: "8630504",
        mcc: {
            code: 8021,
            description: "DENTISTAS E ORTODONTISTAS (CLINICAS E CONSULTORIOS)"
        }
    },
    {
        id: 2963,
        departamentCode: "194",
        description: "Serviços de vacinação e imunização humana",
        cnae: "86305/06",
        activityBranch: "8630506",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2964,
        departamentCode: "194",
        description: "Atividades de reprodução humana assistida",
        cnae: "86305/07",
        activityBranch: "8630507",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2965,
        departamentCode: "194",
        description: "Atividades de atenção ambulatorial não especificadas anteriormente",
        cnae: "86305/99",
        activityBranch: "8630599",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2966,
        departamentCode: "193",
        description: "Laboratórios de anatomia patológica e citológica",
        cnae: "86402/01",
        activityBranch: "8640201",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2967,
        departamentCode: "193",
        description: "Laboratórios clínicos",
        cnae: "86402/02",
        activityBranch: "8640202",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2968,
        departamentCode: "193",
        description: "Serviços de diálise e nefrologia",
        cnae: "86402/03",
        activityBranch: "8640203",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2969,
        departamentCode: "193",
        description: "Serviços de tomografia",
        cnae: "86402/04",
        activityBranch: "8640204",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2970,
        departamentCode: "193",
        description: "Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia",
        cnae: "86402/05",
        activityBranch: "8640205",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2971,
        departamentCode: "193",
        description: "Serviços de ressonância magnética",
        cnae: "86402/06",
        activityBranch: "8640206",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2972,
        departamentCode: "193",
        description: "Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética",
        cnae: "86402/07",
        activityBranch: "8640207",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2973,
        departamentCode: "193",
        description: "Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos",
        cnae: "86402/08",
        activityBranch: "8640208",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2974,
        departamentCode: "193",
        description: "Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos",
        cnae: "86402/09",
        activityBranch: "8640209",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2975,
        departamentCode: "193",
        description: "Serviços de quimioterapia",
        cnae: "86402/10",
        activityBranch: "8640210",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2976,
        departamentCode: "193",
        description: "Serviços de radioterapia",
        cnae: "86402/11",
        activityBranch: "8640211",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2977,
        departamentCode: "193",
        description: "Serviços de hemoterapia",
        cnae: "86402/12",
        activityBranch: "8640212",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2978,
        departamentCode: "193",
        description: "Serviços de litotripsia",
        cnae: "86402/13",
        activityBranch: "8640213",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2979,
        departamentCode: "193",
        description: "Serviços de bancos de células e tecidos humanos",
        cnae: "86402/14",
        activityBranch: "8640214",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2980,
        departamentCode: "193",
        description: "Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente",
        cnae: "86402/99",
        activityBranch: "8640299",
        mcc: {
            code: 8071,
            description: "ANALISES CLINICAS MEDICAS E DENTAIS"
        }
    },
    {
        id: 2981,
        departamentCode: "194",
        description: "Atividades de enfermagem",
        cnae: "86500/01",
        activityBranch: "8650001",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2982,
        departamentCode: "194",
        description: "Atividades de profissionais da nutrição",
        cnae: "86500/02",
        activityBranch: "8650002",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2983,
        departamentCode: "194",
        description: "Atividades de psicologia e psicanálise",
        cnae: "86500/03",
        activityBranch: "8650003",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2984,
        departamentCode: "194",
        description: "Atividades de fisioterapia",
        cnae: "86500/04",
        activityBranch: "8650004",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2985,
        departamentCode: "194",
        description: "Atividades de terapia ocupacional",
        cnae: "86500/05",
        activityBranch: "8650005",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2986,
        departamentCode: "194",
        description: "Atividades de fonoaudiologia",
        cnae: "86500/06",
        activityBranch: "8650006",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2987,
        departamentCode: "194",
        description: "Atividades de terapia de nutrição enteral e parenteral",
        cnae: "86500/07",
        activityBranch: "8650007",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2988,
        departamentCode: "194",
        description: "Atividades de profissionais da área de saúde não especificadas anteriormente",
        cnae: "86500/99",
        activityBranch: "8650099",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2989,
        departamentCode: "194",
        description: "Atividades de apoio à gestão de saúde",
        cnae: "86607/00",
        activityBranch: "8660700",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2990,
        departamentCode: "194",
        description: "Atividades de práticas integrativas e complementares em saúde humana",
        cnae: "86909/01",
        activityBranch: "8690901",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2991,
        departamentCode: "194",
        description: "Atividades de bancos de leite humano",
        cnae: "86909/02",
        activityBranch: "8690902",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2992,
        departamentCode: "188",
        description: "Atividades de acupuntura",
        cnae: "86909/03",
        activityBranch: "8690903",
        mcc: {
            code: 8031,
            description: "OSTEOPATAS"
        }
    },
    {
        id: 2993,
        departamentCode: "188",
        description: "Atividades de podologia",
        cnae: "86909/04",
        activityBranch: "8690904",
        mcc: {
            code: 8031,
            description: "OSTEOPATAS"
        }
    },
    {
        id: 2994,
        departamentCode: "194",
        description: "Outras atividades de atenção à saúde humana não especificadas anteriormente",
        cnae: "86909/99",
        activityBranch: "8690999",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 2995,
        departamentCode: "191",
        description: "Clínicas e residências geriátricas",
        cnae: "87115/01",
        activityBranch: "8711501",
        mcc: {
            code: 8050,
            description: "CASAS DE REPOUSO, CLIN. DE RECUPERACAO E ENFERMAGEM"
        }
    },
    {
        id: 2996,
        departamentCode: "191",
        description: "Instituições de longa permanência para idosos",
        cnae: "87115/02",
        activityBranch: "8711502",
        mcc: {
            code: 8050,
            description: "CASAS DE REPOUSO, CLIN. DE RECUPERACAO E ENFERMAGEM"
        }
    },
    {
        id: 2997,
        departamentCode: "191",
        description: "Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes",
        cnae: "87115/03",
        activityBranch: "8711503",
        mcc: {
            code: 8050,
            description: "CASAS DE REPOUSO, CLIN. DE RECUPERACAO E ENFERMAGEM"
        }
    },
    {
        id: 2998,
        departamentCode: "191",
        description: "Centros de apoio a pacientes com câncer e com AIDS",
        cnae: "87115/04",
        activityBranch: "8711504",
        mcc: {
            code: 8050,
            description: "CASAS DE REPOUSO, CLIN. DE RECUPERACAO E ENFERMAGEM"
        }
    },
    {
        id: 2999,
        departamentCode: "191",
        description: "Condomínios residenciais para idosos",
        cnae: "87115/05",
        activityBranch: "8711505",
        mcc: {
            code: 8050,
            description: "CASAS DE REPOUSO, CLIN. DE RECUPERACAO E ENFERMAGEM"
        }
    },
    {
        id: 3000,
        departamentCode: "194",
        description: "Atividades de fornecimento de infra-estrutura de apoio e assistência a paciente no domicílio",
        cnae: "87123/00",
        activityBranch: "8712300",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 3001,
        departamentCode: "194",
        description: "Atividades de centros de assistência psicossocial",
        cnae: "87204/01",
        activityBranch: "8720401",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 3002,
        departamentCode: "194",
        description: "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química não especificadas anteriormente",
        cnae: "87204/99",
        activityBranch: "8720499",
        mcc: {
            code: 8099,
            description: "MEDICINA EM GERAL E PRATICANTES DE SERVICOS DE SAUDE"
        }
    },
    {
        id: 3003,
        departamentCode: "202",
        description: "Orfanatos",
        cnae: "87301/01",
        activityBranch: "8730101",
        mcc: {
            code: 8398,
            description: "ORGANIZACOES DE SERVICOS BENEFICIENTES E SOCIAIS"
        }
    },
    {
        id: 3004,
        departamentCode: "202",
        description: "Albergues assistenciais",
        cnae: "87301/02",
        activityBranch: "8730102",
        mcc: {
            code: 8398,
            description: "ORGANIZACOES DE SERVICOS BENEFICIENTES E SOCIAIS"
        }
    },
    {
        id: 3005,
        departamentCode: "202",
        description: "Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente",
        cnae: "87301/99",
        activityBranch: "8730199",
        mcc: {
            code: 8398,
            description: "ORGANIZACOES DE SERVICOS BENEFICIENTES E SOCIAIS"
        }
    },
    {
        id: 3006,
        departamentCode: "202",
        description: "Serviços de assistência social sem alojamento",
        cnae: "88006/00",
        activityBranch: "8800600",
        mcc: {
            code: 8398,
            description: "ORGANIZACOES DE SERVICOS BENEFICIENTES E SOCIAIS"
        }
    },
    {
        id: 3007,
        departamentCode: "174",
        description: "Produção teatral",
        cnae: "90019/01",
        activityBranch: "9001901",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3008,
        departamentCode: "175",
        description: "Produção musical",
        cnae: "90019/02",
        activityBranch: "9001902",
        mcc: {
            code: 7929,
            description: "BANDAS, ORQUESTRAS E ARTISTAS DIVERSOS (NAO CLASSIFICADOS EM OUTROS LUGARES)"
        }
    },
    {
        id: 3009,
        departamentCode: "174",
        description: "Produção de espetáculos de dança",
        cnae: "90019/03",
        activityBranch: "9001903",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3010,
        departamentCode: "174",
        description: "Produção de espetáculos circenses, de marionetes e similares",
        cnae: "90019/04",
        activityBranch: "9001904",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3011,
        departamentCode: "185",
        description: "Produção de espetáculos de rodeios, vaquejadas e similares",
        cnae: "90019/05",
        activityBranch: "9001905",
        mcc: {
            code: 7999,
            description: "SERVICOS DE RECREACAO E FESTAS"
        }
    },
    {
        id: 3012,
        departamentCode: "174",
        description: "Atividades de sonorização e de iluminação",
        cnae: "90019/06",
        activityBranch: "9001906",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3013,
        departamentCode: "174",
        description: "Artes cênicas, espetáculos e atividades complementares não especificados anteriormente",
        cnae: "90019/99",
        activityBranch: "9001999",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3014,
        departamentCode: "143",
        description: "Atividades de artistas plásticos, jornalistas independentes e escritores",
        cnae: "90027/01",
        activityBranch: "9002701",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 3015,
        departamentCode: "103",
        description: "Restauração de obras de arte",
        cnae: "90027/02",
        activityBranch: "9002702",
        mcc: {
            code: 5932,
            description: "LOJA DE ANTIGUIDADES (ANTIQUE SHOPS)"
        }
    },
    {
        id: 3016,
        departamentCode: "174",
        description: "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas",
        cnae: "90035/00",
        activityBranch: "9003500",
        mcc: {
            code: 7922,
            description: "TEATROS, PRODUC. TEATR. E ESPECTAC."
        }
    },
    {
        id: 3017,
        departamentCode: "179",
        description: "Atividades de bibliotecas e arquivos",
        cnae: "91015/00",
        activityBranch: "9101500",
        mcc: {
            code: 7991,
            description: "ATRACOES E EXPOSICOES TURISTICAS"
        }
    },
    {
        id: 3018,
        departamentCode: "179",
        description: "Atividades de museus e de exploração de lugares e prédios históricos e atrações similares",
        cnae: "91023/01",
        activityBranch: "9102301",
        mcc: {
            code: 7991,
            description: "ATRACOES E EXPOSICOES TURISTICAS"
        }
    },
    {
        id: 3019,
        departamentCode: "4",
        description: "Restauração e conservação de lugares e prédios históricos",
        cnae: "91023/02",
        activityBranch: "9102302",
        mcc: {
            code: 1520,
            description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL"
        }
    },
    {
        id: 3020,
        departamentCode: "184",
        description: "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental",
        cnae: "91031/00",
        activityBranch: "9103100",
        mcc: {
            code: 7998,
            description: "AQUARIOS E ZOOLOGICOS"
        }
    },
    {
        id: 3021,
        departamentCode: "181",
        description: "Casas de bingo",
        cnae: "92003/01",
        activityBranch: "9200301",
        mcc: {
            code: 7995,
            description: "CASSINOS, LOTERIAS E JOGOS DE AZAR"
        }
    },
    {
        id: 3022,
        departamentCode: "181",
        description: "Exploração de apostas em corridas de cavalos",
        cnae: "92003/02",
        activityBranch: "9200302",
        mcc: {
            code: 7995,
            description: "CASSINOS, LOTERIAS E JOGOS DE AZAR"
        }
    },
    {
        id: 3023,
        departamentCode: "181",
        description: "Exploração de jogos de azar e apostas não especificados anteriormente",
        cnae: "92003/99",
        activityBranch: "9200399",
        mcc: {
            code: 7995,
            description: "CASSINOS, LOTERIAS E JOGOS DE AZAR"
        }
    },
    {
        id: 3024,
        departamentCode: "178",
        description: "Gestão de instalações de esportes",
        cnae: "93115/00",
        activityBranch: "9311500",
        mcc: {
            code: 7941,
            description: "ESPORTES COMERCIAIS, CAMPOS ESPORTIVOS PROFISSIONAIS, CLUBES E PROMOTORES DE ESPORTES"
        }
    },
    {
        id: 3025,
        departamentCode: "183",
        description: "Clubes sociais, esportivos e similares",
        cnae: "93123/00",
        activityBranch: "9312300",
        mcc: {
            code: 7997,
            description: "ACADEMIAS / CLUBES"
        }
    },
    {
        id: 3026,
        departamentCode: "183",
        description: "Atividades de condicionamento físico",
        cnae: "93131/00",
        activityBranch: "9313100",
        mcc: {
            code: 7997,
            description: "ACADEMIAS / CLUBES"
        }
    },
    {
        id: 3027,
        departamentCode: "185",
        description: "Produção e promoção de eventos esportivos",
        cnae: "93191/01",
        activityBranch: "9319101",
        mcc: {
            code: 7999,
            description: "SERVICOS DE RECREACAO E FESTAS"
        }
    },
    {
        id: 3028,
        departamentCode: "185",
        description: "Outras atividades esportivas não especificadas anteriormente",
        cnae: "93191/99",
        activityBranch: "9319199",
        mcc: {
            code: 7999,
            description: "SERVICOS DE RECREACAO E FESTAS"
        }
    },
    {
        id: 3029,
        departamentCode: "182",
        description: "Parques de diversão e parques temáticos",
        cnae: "93212/00",
        activityBranch: "9321200",
        mcc: {
            code: 7996,
            description: "PARQUE DE DIVERSAO, CIRCO E AFINS"
        }
    },
    {
        id: 3030,
        departamentCode: "98",
        description: "Discotecas, danceterias, salões de dança e similares",
        cnae: "93298/01",
        activityBranch: "9329801",
        mcc: {
            code: 5813,
            description: "BARES, PUBS E CASA NOTURNAS"
        }
    },
    {
        id: 3031,
        departamentCode: "177",
        description: "Exploração de boliches",
        cnae: "93298/02",
        activityBranch: "9329802",
        mcc: {
            code: 7933,
            description: "BOWLING ALLEYS"
        }
    },
    {
        id: 3032,
        departamentCode: "176",
        description: "Exploração de jogos de sinuca, bilhar e similares",
        cnae: "93298/03",
        activityBranch: "9329803",
        mcc: {
            code: 7932,
            description: "ESTABELECIMENTOS DE BILHAR E PISCINA"
        }
    },
    {
        id: 3033,
        departamentCode: "180",
        description: "Exploração de jogos eletrônicos recreativos",
        cnae: "93298/04",
        activityBranch: "9329804",
        mcc: {
            code: 7994,
            description: "ESTABELECIMENTOS DE VIDEO-GAMES"
        }
    },
    {
        id: 3034,
        departamentCode: "185",
        description: "Outras atividades de recreação e lazer não especificadas anteriormente",
        cnae: "93298/99",
        activityBranch: "9329899",
        mcc: {
            code: 7999,
            description: "SERVICOS DE RECREACAO E FESTAS"
        }
    },
    {
        id: 3035,
        departamentCode: "206",
        description: "Atividades de organizações associativas patronais e empresariais",
        cnae: "94111/00",
        activityBranch: "9411100",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3036,
        departamentCode: "212",
        description: "Atividades de fiscalização profissional",
        cnae: "94120/01",
        activityBranch: "9412001",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 3037,
        departamentCode: "206",
        description: "Outras atividades associativas profissionais",
        cnae: "94120/99",
        activityBranch: "9412099",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3038,
        departamentCode: "206",
        description: "Atividades de organizações sindicais",
        cnae: "94201/00",
        activityBranch: "9420100",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3039,
        departamentCode: "203",
        description: "Atividades de associações de defesa de direitos sociais",
        cnae: "94308/00",
        activityBranch: "9430800",
        mcc: {
            code: 8641,
            description: "ASSOCIACOES CIVICAS E SOCIAIS"
        }
    },
    {
        id: 3040,
        departamentCode: "205",
        description: "Atividades de organizações religiosas ou filosóficas",
        cnae: "94910/00",
        activityBranch: "9491000",
        mcc: {
            code: 8661,
            description: "ORGANIZACOES RELIGIOSAS"
        }
    },
    {
        id: 3041,
        departamentCode: "204",
        description: "Atividades de organizações políticas",
        cnae: "94928/00",
        activityBranch: "9492800",
        mcc: {
            code: 8651,
            description: "ORGANIZACOES POLITICAS"
        }
    },
    {
        id: 3042,
        departamentCode: "206",
        description: "Atividades de organizações associativas ligadas à cultura e à arte",
        cnae: "94936/00",
        activityBranch: "9493600",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3043,
        departamentCode: "206",
        description: "Atividades associativas não especificadas anteriormente",
        cnae: "94995/00",
        activityBranch: "9499500",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3044,
        departamentCode: "152",
        description: "Reparação e manutenção de computadores e de equipamentos periféricos",
        cnae: "95118/00",
        activityBranch: "9511800",
        mcc: {
            code: 7379,
            description: "COMPUTADORES: CONCERTOS E REPAROS"
        }
    },
    {
        id: 3045,
        departamentCode: "165",
        description: "Reparação e manutenção de equipamentos de comunicação",
        cnae: "95126/00",
        activityBranch: "9512600",
        mcc: {
            code: 7622,
            description: "CONSERTO DE EQUIP. AUDIO E TV"
        }
    },
    {
        id: 3046,
        departamentCode: "166",
        description: "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico",
        cnae: "95215/00",
        activityBranch: "9521500",
        mcc: {
            code: 7629,
            description: "CONSERTO DE ELETRONICOS"
        }
    },
    {
        id: 3047,
        departamentCode: "137",
        description: "Reparação de calçados, bolsas e artigos de viagem",
        cnae: "95291/01",
        activityBranch: "9529101",
        mcc: {
            code: 7251,
            description: "LOJA/REPARO DE SAPATOS"
        }
    },
    {
        id: 3048,
        departamentCode: "157",
        description: "Chaveiros",
        cnae: "95291/02",
        activityBranch: "9529102",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 3049,
        departamentCode: "167",
        description: "Reparação de relógios",
        cnae: "95291/03",
        activityBranch: "9529103",
        mcc: {
            code: 7631,
            description: "CONSERTO DE RELOGIOS E JOIAS"
        }
    },
    {
        id: 3050,
        departamentCode: "169",
        description: "Reparação de bicicletas, triciclos e outros veículos não-motorizados",
        cnae: "95291/04",
        activityBranch: "9529104",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 3051,
        departamentCode: "168",
        description: "Reparação de artigos do mobiliário",
        cnae: "95291/05",
        activityBranch: "9529105",
        mcc: {
            code: 7641,
            description: "RESTAURACAO DE MOVEIS (FURNITURE REPAIR)"
        }
    },
    {
        id: 3052,
        departamentCode: "167",
        description: "Reparação de jóias",
        cnae: "95291/06",
        activityBranch: "9529106",
        mcc: {
            code: 7631,
            description: "CONSERTO DE RELOGIOS E JOIAS"
        }
    },
    {
        id: 3053,
        departamentCode: "169",
        description: "Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente",
        cnae: "95291/99",
        activityBranch: "9529199",
        mcc: {
            code: 7699,
            description: "LOJA DE CONSERTOS GERAIS E SERVICOS RELACIONADOS"
        }
    },
    {
        id: 3054,
        departamentCode: "134",
        description: "Lavanderias",
        cnae: "96017/01",
        activityBranch: "9601701",
        mcc: {
            code: 7216,
            description: "LAVANDERIA TINTURARIA"
        }
    },
    {
        id: 3055,
        departamentCode: "134",
        description: "Tinturarias",
        cnae: "96017/02",
        activityBranch: "9601702",
        mcc: {
            code: 7216,
            description: "LAVANDERIA TINTURARIA"
        }
    },
    {
        id: 3056,
        departamentCode: "133",
        description: "Toalheiros",
        cnae: "96017/03",
        activityBranch: "9601703",
        mcc: {
            code: 7210,
            description: "LAVANDARIA, LIMPEZA E SERVICOS DE VESTUARIO"
        }
    },
    {
        id: 3057,
        departamentCode: "136",
        description: "Cabeleireiros, manicure e pedicure",
        cnae: "96025/01",
        activityBranch: "9602501",
        mcc: {
            code: 7230,
            description: "SALAO DE BELEZA / BARBEARIA / DEPILACAO / MANICURE"
        }
    },
    {
        id: 3058,
        departamentCode: "142",
        description: "Atividades de Estética e outros serviços de cuidados com a beleza",
        cnae: "96025/02",
        activityBranch: "9602502",
        mcc: {
            code: 7298,
            description: "CLINICAS DE ESTETICA FACIAL / CORPORAL"
        }
    },
    {
        id: 3059,
        departamentCode: "138",
        description: "Gestão e manutenção de cemitérios",
        cnae: "96033/01",
        activityBranch: "9603301",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3060,
        departamentCode: "138",
        description: "Serviços de cremação",
        cnae: "96033/02",
        activityBranch: "9603302",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3061,
        departamentCode: "138",
        description: "Serviços de sepultamento",
        cnae: "96033/03",
        activityBranch: "9603303",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3062,
        departamentCode: "138",
        description: "Serviços de funerárias",
        cnae: "96033/04",
        activityBranch: "9603304",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3063,
        departamentCode: "138",
        description: "Serviços de somatoconservação",
        cnae: "96033/05",
        activityBranch: "9603305",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3064,
        departamentCode: "138",
        description: "Atividades funerárias e serviços relacionados não especificados anteriormente",
        cnae: "96033/99",
        activityBranch: "9603399",
        mcc: {
            code: 7261,
            description: "SERVICO FUNERARIO"
        }
    },
    {
        id: 3065,
        departamentCode: "139",
        description: "Agências matrimoniais",
        cnae: "96092/02",
        activityBranch: "9609202",
        mcc: {
            code: 7273,
            description: "SERVICO DE ENCONTROS E ACOMPANHANTE"
        }
    },
    {
        id: 3066,
        departamentCode: "143",
        description: "Exploração de máquinas de serviços pessoais acionadas por moeda",
        cnae: "96092/04",
        activityBranch: "9609204",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 3067,
        departamentCode: "141",
        description: "Atividades de sauna e banhos",
        cnae: "96092/05",
        activityBranch: "9609205",
        mcc: {
            code: 7297,
            description: "CENTRO DE SAUNAS E MASSAGENS"
        }
    },
    {
        id: 3068,
        departamentCode: "143",
        description: "Serviços de tatuagem e colocação de piercing",
        cnae: "96092/06",
        activityBranch: "9609206",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 3069,
        departamentCode: "143",
        description: "Alojamento de animais domésticos",
        cnae: "96092/07",
        activityBranch: "9609207",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 3070,
        departamentCode: "123",
        description: "Higiene e embelezamento de animais domésticos",
        cnae: "96092/08",
        activityBranch: "9609208",
        mcc: {
            code: 5995,
            description: "PET SHOP"
        }
    },
    {
        id: 3071,
        departamentCode: "143",
        description: "Outras atividades de serviços pessoais não especificadas anteriormente",
        cnae: "96092/99",
        activityBranch: "9609299",
        mcc: {
            code: 7299,
            description: "OUTROS SERVICOS PESSOAIS"
        }
    },
    {
        id: 3072,
        departamentCode: "149",
        description: "Serviços domésticos",
        cnae: "97005/00",
        activityBranch: "9700500",
        mcc: {
            code: 7349,
            description: "SERVICO LIMPEZA E MANUTENCAO"
        }
    },
    {
        id: 3073,
        departamentCode: "212",
        description: "Organismos internacionais e outras instituições extraterritoriais",
        cnae: "99008/00",
        activityBranch: "9900800",
        mcc: {
            code: 8999,
            description: "OUTROS SERVICOS PROFISSIONAIS DE ESPECIALIZADOS"
        }
    },
    {
        id: 3074,
        departamentCode: "82",
        description: "Fabricação de motocicletas, peças e acessórios",
        cnae: "30911/00",
        activityBranch: "3091100",
        mcc: {
            code: 5571,
            description: "LOJAS DE MOTOCICLETAS E ACESSORIOS"
        }
    },
    {
        id: 3075,
        departamentCode: "123",
        description: "Alojamento, higiene e embelezamento de animais",
        cnae: "96092/03",
        activityBranch: "9609203",
        mcc: {
            code: 5995,
            description: "PET SHOP"
        }
    },
    {
        id: 3076,
        departamentCode: "142",
        description: "Clínicas de estética e similares",
        cnae: "96092/01",
        activityBranch: "9609201",
        mcc: {
            code: 7298,
            description: "CLINICAS DE ESTETICA FACIAL / CORPORAL"
        }
    },
    {
        id: 3077,
        departamentCode: "206",
        description: "Atividades de organizações associativas profissionais",
        cnae: "94120/00",
        activityBranch: "9412000",
        mcc: {
            code: 8699,
            description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NAO CLASSIF."
        }
    },
    {
        id: 3078,
        departamentCode: "154",
        description: "Atividades de monitoramento de sistemas de segurança",
        cnae: "80200/00",
        activityBranch: "8020000",
        mcc: {
            code: 7393,
            description: "AGENCIAS DE DETETIVES, PROTECCAO E DE SEGURANCA"
        }
    },
    {
        id: 3079,
        departamentCode: "208",
        description: "Design",
        cnae: "74102/01",
        activityBranch: "7410201",
        mcc: {
            code: 8911,
            description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA"
        }
    },
    {
        id: 3080,
        departamentCode: "151",
        description: "Desenvolvimento de programas de computador sob encomenda",
        cnae: "62015/00",
        activityBranch: "6201500",
        mcc: {
            code: 7372,
            description: "PROGRAMACAO DE COMPUTADORES, DESIGN DE SISTEMAS INTEGRADOS E PROCESSAMENTO DE DADOS"
        }
    },
    {
        id: 3081,
        departamentCode: "74",
        description: "Fabricação de produtos de panificação",
        cnae: "10911/00",
        activityBranch: "1091100",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 3082,
        departamentCode: "74",
        description: "Padaria e confeitaria com predominância de produção própria",
        cnae: "47211/01",
        activityBranch: "4721101",
        mcc: {
            code: 5462,
            description: "CONFEITERIAS (BAKERIES)"
        }
    },
    {
        id: 3083,
        departamentCode: "55",
        description: "Fabricação de adubos e fertilizantes",
        cnae: "20134/00",
        activityBranch: "2013400",
        mcc: {
            code: 5169,
            description: "PRODUTOS QUIMICOS E AFINS, NAO CLASSIFICADOS EM OUTRA PARTE"
        }
    },
    {
        id: 3084,
        departamentCode: "35",
        description: "Geração de energia elétrica",
        cnae: "35115/00",
        activityBranch: "3511500",
        mcc: {
            code: 4900,
            description: "UTILID./ELEC/GAS/AGUA/SANI (UT../ELEC/GAS/H2O/SANI)"
        }
    },
    {
        id: 3085,
        departamentCode: "157",
        description: "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
        cnae: "52397/00",
        activityBranch: "5239700",
        mcc: {
            code: 7399,
            description: "SERVICOS DE NEGOCIOS"
        }
    },
    {
        id: 3086,
        departamentCode: "94",
        description: "Comércio varejista especializado de equipamentos e suprimentos de informática",
        cnae: "47512/00",
        activityBranch: "4751200",
        mcc: {
            code: 5734,
            description: "LOJA DE SOFTWARE"
        }
    },
    {
        id: 3087,
        departamentCode: "147",
        description: "Serviços de acabamentos gráficos",
        cnae: "18229/00",
        activityBranch: "1822900",
        mcc: {
            code: 7338,
            description: "SERVICOS DE COPIA RAPIDA, REPRODUCAO E BLUEPRINTING"
        }
    },
    {
        id: 3088,
        departamentCode: "43",
        description: "Serviços de usinagem, solda, tratamento e revestimento em metais",
        cnae: "25390/00",
        activityBranch: "2539000",
        mcc: {
            code: 5051,
            description: "CENTROS DE SERVICOS DE METAIS (METAL SERVICE CENTERS)"
        }
    },
    {
        id: 3089,
        departamentCode: "46",
        description: "Equipamento P/ Encanamento e Aquecimento Diversos",
        cnae: "2812-7/00",
        activityBranch: "2812700",
        mcc: {
            code: 5074,
            description: "EQUIP. DE AQUECIMENTO/ENCANAMENTO (PLUMB./HEAT. E.)"
        }
    },
    {
        id: 3090,
        departamentCode: "64",
        description: "Lojas de Suprimentos para Grama e Jardim Diversos",
        cnae: "0142-3/00",
        activityBranch: "142300",
        mcc: {
            code: 5261,
            description: "JARDINAGEM"
        }
    },
    {
        id: 3091,
        departamentCode: "145",
        description: "Agência de Proteção Ao Crédito Diversos",
        cnae: "8291-1/00",
        activityBranch: "8291100",
        mcc: {
            code: 7321,
            description: "AGENCIAS DE RELATORIOS DE CREDITO AO CONSUMIDOR (CONSUMER CREDIT REPORTING AGENCIES)"
        }
    },
    {
        id: 3092,
        departamentCode: "146",
        description: "Fotografia Comercial Diversos",
        cnae: "2012519",
        activityBranch: "7410201",
        mcc: {
            code: 7333,
            description: "SERVICOS DE IMPRESSAO E ARTE GRAFICA"
        }
    },
    {
        id: 3093,
        departamentCode: "190",
        description: "Quiropodistas, Podólogos Diversos",
        cnae: "2480245",
        activityBranch: "8690904",
        mcc: {
            code: 8049,
            description: "TRATAMENTOS PODIATRICOS"
        }
    }
];

let SpeViewNMccProxy = class SpeViewNMccProxy {
    constructor(api) {
        this.api = api;
    }
    findActivityBranch() {
        return of(activitysBranchMock);
    }
};
SpeViewNMccProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNMccProxy);

let UiPxEcModule = class UiPxEcModule {
};
UiPxEcModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService,
            SpeNOnboardingEcProxy,
            SpeJOnboardingEcUploadProxy,
            SpeNViewWhiteLabelProxy,
            SpeViewNAccountProxy,
            SpeNAccountsProxy,
            SpeViewNMccProxy
        ]
    })
], UiPxEcModule);

var StatusAnalysisEnum;
(function (StatusAnalysisEnum) {
    StatusAnalysisEnum[StatusAnalysisEnum["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
    StatusAnalysisEnum[StatusAnalysisEnum["REQUESTED"] = 1] = "REQUESTED";
    StatusAnalysisEnum[StatusAnalysisEnum["IN_ANALYSIS"] = 2] = "IN_ANALYSIS";
    StatusAnalysisEnum[StatusAnalysisEnum["APPROVED"] = 3] = "APPROVED";
    StatusAnalysisEnum[StatusAnalysisEnum["REPROVED"] = 4] = "REPROVED";
})(StatusAnalysisEnum || (StatusAnalysisEnum = {}));
var StatusRequestEnum;
(function (StatusRequestEnum) {
    StatusRequestEnum[StatusRequestEnum["IN_ANALYSIS"] = 0] = "IN_ANALYSIS";
    StatusRequestEnum[StatusRequestEnum["APPROVED"] = 1] = "APPROVED";
    StatusRequestEnum[StatusRequestEnum["REPROVED"] = 2] = "REPROVED";
})(StatusRequestEnum || (StatusRequestEnum = {}));

var StatusDefaultEnum;
(function (StatusDefaultEnum) {
    StatusDefaultEnum[StatusDefaultEnum["ACTIVE"] = 0] = "ACTIVE";
    StatusDefaultEnum[StatusDefaultEnum["INACTIVE"] = 1] = "INACTIVE";
})(StatusDefaultEnum || (StatusDefaultEnum = {}));
var TypeVisibleEnum;
(function (TypeVisibleEnum) {
    TypeVisibleEnum[TypeVisibleEnum["WEB_AND_APP"] = 1] = "WEB_AND_APP";
    TypeVisibleEnum[TypeVisibleEnum["APP"] = 2] = "APP";
    TypeVisibleEnum[TypeVisibleEnum["WEB"] = 3] = "WEB";
})(TypeVisibleEnum || (TypeVisibleEnum = {}));

var flowProductsAndServices;
(function (flowProductsAndServices) {
    flowProductsAndServices["CARD_MACHINE"] = "0";
    flowProductsAndServices["CREDIT_CARD"] = "1";
    flowProductsAndServices["BILLET"] = "2";
    flowProductsAndServices["ENERGY"] = "3";
})(flowProductsAndServices || (flowProductsAndServices = {}));

var Status;
(function (Status) {
    Status["IN_ONBORDING"] = "IN_ONBORDING";
    Status["IN_ANALYSIS_COMPLIANCE"] = "IN_ANALYSIS_COMPLIANCE";
    Status["APPROVED_COMPLIANCE"] = "APPROVED_COMPLIANCE";
    Status["IN_ANALYSIS_TOPAZIO"] = "IN_ANALYSIS_TOPAZIO";
    Status["APPROVED_TOPAZIO"] = "APPROVED_TOPAZIO";
    Status["FINISHED"] = "FINISHED";
    Status["REPROVED"] = "REPROVED";
    Status["DOCUMENT_PHYSICAL_PERSON_REPROVED"] = "DOCUMENT_PHYSICAL_PERSON_REPROVED";
    Status["DOCUMENT_LEGAL_PERSON_REPROVED"] = "DOCUMENT_LEGAL_PERSON_REPROVED";
    Status["REGISTRATION_DATA_PHYSICAL_PERSON_INVALID"] = "REGISTRATION_DATA_PHYSICAL_PERSON_INVALID";
    Status["REGISTRATION_DATA_LEGAL_PERSON_INVALID"] = "REGISTRATION_DATA_LEGAL_PERSON_INVALID";
})(Status || (Status = {}));

var OwnershipEnum;
(function (OwnershipEnum) {
    OwnershipEnum["OWNERAOFTHECCOUNT"] = "OWNERAOFTHECCOUNT";
    OwnershipEnum["SPOUSE"] = "SPOUSE";
    OwnershipEnum["FATHERORMOTHER"] = "FATHERORMOTHER";
    OwnershipEnum["BROTHERORSISTER"] = "BROTHERORSISTER";
})(OwnershipEnum || (OwnershipEnum = {}));

var PositionPhotoEnum;
(function (PositionPhotoEnum) {
    PositionPhotoEnum["FRONT"] = "FRONT";
    PositionPhotoEnum["VERSE"] = "VERSE";
})(PositionPhotoEnum || (PositionPhotoEnum = {}));

var UploadTypeEnum;
(function (UploadTypeEnum) {
    UploadTypeEnum["CPF"] = "CPF";
    UploadTypeEnum["CNPJ"] = "CNPJ";
    UploadTypeEnum["RESIDENCIAL_CERTIFICATE"] = "RESIDENCIAL_CERTIFICATE";
    UploadTypeEnum["RG"] = "RG";
    UploadTypeEnum["CNH"] = "CNH";
    UploadTypeEnum["SOCIAL_CONTRACT"] = "SOCIAL_CONTRACT";
    UploadTypeEnum["MINUTES_MEETING"] = "MINUTES_MEETING";
    UploadTypeEnum["PROFESSIONAL_CERTIFICATE"] = "PROFESSIONAL_CERTIFICATE";
    UploadTypeEnum["SELF_PHOTO"] = "SELF_PHOTO";
    UploadTypeEnum["ATTORNEY_LETTER"] = "ATTORNEY_LETTER";
})(UploadTypeEnum || (UploadTypeEnum = {}));

export { ConfigService, OwnershipEnum, PositionPhotoEnum, SpeJOnboardingEcUploadProxy, SpeNAccountsProxy, SpeNOnboardingEcProxy, SpeNViewWhiteLabelProxy, SpeViewNAccountProxy, SpeViewNMccProxy, Status, StatusAnalysisEnum, StatusDefaultEnum, StatusRequestEnum, TypeVisibleEnum, UiPxEcModule, UploadTypeEnum, flowProductsAndServices };
//# sourceMappingURL=wlp-ui-px-ec.js.map
